{
  "id": "royal-rumble",
  "name": "Royal Rumble",
  "specialRules": [
    "Up to 9 players; each is dealt a random island and starts on its Keep with 7 troops, with players spread as evenly around the ring as the count allows. Everything else is neutral: 3 troops on the islands, 4 in the arena.",
    "An island is worth +3 troops while you hold all four of its territories.",
    "The Landing is the only way into the arena, and it is one-way: it attacks the Gate straight ahead, but nothing in the arena can attack back onto an island.",
    "A neutral islet (starts with 5, no bonus) sits on each strait between neighbouring islands: your Cliffs reach the islet clockwise, your Shoals the one counter-clockwise, and the Gates of the two lanes either side reach it from the arena. Every attack across an islet crossing (the orange lines), either way, rolls a 5-sided die against the defender's 6-sided die.",
    "Inside the arena every lane is the same: your Gate (+1), then your Run of Terrace and Pit (+3), then the Sand at the centre (+9, starts with 8).",
    "Storming the Sand: attacking it from a Pit (the red chevrons) rolls an 8-sided die against the defender's 6-sided die."
  ],
  "addedOn": "2026-10-27",
  "viewBox": {
    "x": 0,
    "y": 0,
    "width": 1200,
    "height": 1150
  },
  "backdropColor": {
    "light": "#d6d0c8",
    "dark": "#2b2724",
    "topBar": true
  },
  "forceSeaRouteTuning": {
    "ashmoor-cliffs|tern-islet": {
      "endpointMode": "centers"
    },
    "ashmoor-gate|ashmoor-landing": {
      "endpointMode": "centers"
    },
    "ashmoor-gate|brine-skerry": {
      "endpointMode": "centers"
    },
    "ashmoor-gate|tern-islet": {
      "endpointMode": "centers"
    },
    "ashmoor-shoals|brine-skerry": {
      "endpointMode": "centers"
    },
    "brine-skerry|stormreach-cliffs": {
      "endpointMode": "centers"
    },
    "brine-skerry|stormreach-gate": {
      "endpointMode": "centers"
    },
    "driftstone|emberrock-gate": {
      "endpointMode": "centers"
    },
    "driftstone|emberrock-shoals": {
      "endpointMode": "centers"
    },
    "driftstone|greywatch-cliffs": {
      "endpointMode": "centers"
    },
    "driftstone|greywatch-gate": {
      "endpointMode": "centers"
    },
    "emberrock-cliffs|wreckers-reef": {
      "endpointMode": "centers"
    },
    "emberrock-gate|emberrock-landing": {
      "endpointMode": "centers"
    },
    "emberrock-gate|wreckers-reef": {
      "endpointMode": "centers"
    },
    "fog-isle|goldcrest-gate": {
      "endpointMode": "centers"
    },
    "fog-isle|goldcrest-shoals": {
      "endpointMode": "centers"
    },
    "fog-isle|mistfell-cliffs": {
      "endpointMode": "centers"
    },
    "fog-isle|mistfell-gate": {
      "endpointMode": "centers"
    },
    "gannet-rock|goldcrest-cliffs": {
      "endpointMode": "centers"
    },
    "gannet-rock|goldcrest-gate": {
      "endpointMode": "centers"
    },
    "gannet-rock|stormreach-gate": {
      "endpointMode": "centers"
    },
    "gannet-rock|stormreach-shoals": {
      "endpointMode": "centers"
    },
    "goldcrest-gate|goldcrest-landing": {
      "endpointMode": "centers"
    },
    "greywatch-gate|greywatch-landing": {
      "endpointMode": "centers"
    },
    "greywatch-gate|seal-skerry": {
      "endpointMode": "centers"
    },
    "greywatch-shoals|seal-skerry": {
      "endpointMode": "centers"
    },
    "gull-rock|ironhold-cliffs": {
      "endpointMode": "centers"
    },
    "gull-rock|ironhold-gate": {
      "endpointMode": "centers"
    },
    "gull-rock|saltmarch-gate": {
      "endpointMode": "centers"
    },
    "gull-rock|saltmarch-shoals": {
      "endpointMode": "centers"
    },
    "ironhold-gate|ironhold-landing": {
      "endpointMode": "centers"
    },
    "ironhold-gate|tern-islet": {
      "endpointMode": "centers"
    },
    "ironhold-shoals|tern-islet": {
      "endpointMode": "centers"
    },
    "kelp-holm|mistfell-gate": {
      "endpointMode": "centers"
    },
    "kelp-holm|mistfell-shoals": {
      "endpointMode": "centers"
    },
    "kelp-holm|thornvale-cliffs": {
      "endpointMode": "centers"
    },
    "kelp-holm|thornvale-gate": {
      "endpointMode": "centers"
    },
    "mistfell-gate|mistfell-landing": {
      "endpointMode": "centers"
    },
    "saltmarch-cliffs|seal-skerry": {
      "endpointMode": "centers"
    },
    "saltmarch-gate|saltmarch-landing": {
      "endpointMode": "centers"
    },
    "saltmarch-gate|seal-skerry": {
      "endpointMode": "centers"
    },
    "stormreach-gate|stormreach-landing": {
      "endpointMode": "centers"
    },
    "thornvale-gate|thornvale-landing": {
      "endpointMode": "centers"
    },
    "thornvale-gate|wreckers-reef": {
      "endpointMode": "centers"
    },
    "thornvale-shoals|wreckers-reef": {
      "endpointMode": "centers"
    }
  },
  "edgeConfig": {
    "internalBorderWidth": 2.3,
    "regionBorderWidth": 12.2,
    "bridgeStrokeWidth": 0
  },
  "gameLayout": {},
  "selectionInnerGlow": true,
  "fixedSetup": {
    "playerCount": 9,
    "minPlayers": 2,
    "areas": [
      {
        "id": "ironhold",
        "armies": {
          "ironhold-keep": 7
        }
      },
      {
        "id": "saltmarch",
        "armies": {
          "saltmarch-keep": 7
        }
      },
      {
        "id": "greywatch",
        "armies": {
          "greywatch-keep": 7
        }
      },
      {
        "id": "emberrock",
        "armies": {
          "emberrock-keep": 7
        }
      },
      {
        "id": "thornvale",
        "armies": {
          "thornvale-keep": 7
        }
      },
      {
        "id": "mistfell",
        "armies": {
          "mistfell-keep": 7
        }
      },
      {
        "id": "goldcrest",
        "armies": {
          "goldcrest-keep": 7
        }
      },
      {
        "id": "stormreach",
        "armies": {
          "stormreach-keep": 7
        }
      },
      {
        "id": "ashmoor",
        "armies": {
          "ashmoor-keep": 7
        }
      }
    ],
    "seating": "ring",
    "neutralArmies": 3,
    "neutralOverrides": {
      "throne-sand": 8,
      "ironhold-gate": 4,
      "ironhold-terrace": 4,
      "ironhold-pit": 4,
      "saltmarch-gate": 4,
      "saltmarch-terrace": 4,
      "saltmarch-pit": 4,
      "greywatch-gate": 4,
      "greywatch-terrace": 4,
      "greywatch-pit": 4,
      "emberrock-gate": 4,
      "emberrock-terrace": 4,
      "emberrock-pit": 4,
      "thornvale-gate": 4,
      "thornvale-terrace": 4,
      "thornvale-pit": 4,
      "mistfell-gate": 4,
      "mistfell-terrace": 4,
      "mistfell-pit": 4,
      "goldcrest-gate": 4,
      "goldcrest-terrace": 4,
      "goldcrest-pit": 4,
      "stormreach-gate": 4,
      "stormreach-terrace": 4,
      "stormreach-pit": 4,
      "ashmoor-gate": 4,
      "ashmoor-terrace": 4,
      "ashmoor-pit": 4,
      "gull-rock": 5,
      "seal-skerry": 5,
      "driftstone": 5,
      "wreckers-reef": 5,
      "kelp-holm": 5,
      "fog-isle": 5,
      "gannet-rock": 5,
      "brine-skerry": 5,
      "tern-islet": 5
    }
  },
  "legend": {
    "position": "bottom-right",
    "centerY": 1040,
    "items": [
      {
        "symbol": "route",
        "kind": "disadvantage",
        "label": "5 v 6"
      },
      {
        "symbol": "chevron",
        "kind": "advantage",
        "label": "8 v 6"
      },
      {
        "symbol": "arrow",
        "kind": "route",
        "label": "1-way"
      }
    ]
  },
  "borderChevrons": {
    "territoryIds": [
      "throne-sand"
    ]
  },
  "regions": [
    {
      "id": "gate-ironhold",
      "name": "Gate of Ironhold",
      "bonus": 1,
      "shape": "M 501 303.1 L 501.1 303.1 L 504.5 300.4 L 508.5 298.7 L 512.4 296.9 L 516.2 295.1 L 519.8 292.3 L 523.9 290.2 L 528.3 291.5 L 532.9 292 L 537.1 290.7 L 541.4 291.4 L 545.7 292.7 L 549.9 291 L 553.8 288.9 L 557.7 286.8 L 561.7 285 L 566 283.6 L 570.4 282.5 L 574 279.7 L 578.3 278.7 L 582.7 277.8 L 586.7 279.7 L 590.7 281.7 L 595.7 280.8 L 599.3 284.4 L 603.8 284.4 L 608.1 285.7 L 612.9 285.5 L 616.7 288.3 L 621.3 288 L 625.6 289.5 L 629.9 288.3 L 634.2 287.1 L 637.9 290 L 642.6 290.2 L 646.3 292.9 L 649.2 296.3 L 653.2 297.5 L 657.3 298.3 L 661.1 300.1 L 664.8 302 L 667.7 305.2 L 670.8 308.2 L 675 309.6 L 679.3 310 L 683.1 311.5 L 686.9 313.1 L 690.1 315.6 L 693.4 318 L 693.5 318.1 L 679.8 355.6 L 557.8 392.3 L 520.2 355.7 Z",
      "territoryIds": [
        "ironhold-gate"
      ],
      "color": "#D2B48C",
      "bonusAnchor": {
        "x": 596.95,
        "y": 330.74
      }
    },
    {
      "id": "gate-saltmarch",
      "name": "Gate of Saltmarch",
      "bonus": 1,
      "shape": "M 679.8 355.6 L 693.5 318.1 L 697.1 319.9 L 700.9 321.4 L 704.3 323.8 L 706.9 327.1 L 712.5 325.8 L 718.1 324.7 L 724 324.8 L 729.2 322.2 L 734.9 321.1 L 740.1 318.6 L 744.6 314.6 L 750.6 314.1 L 754.8 315.7 L 758.2 318.5 L 761.7 321.2 L 765.9 322.8 L 770 324.4 L 774.1 326.3 L 777.2 329.5 L 780.5 332.5 L 785 334 L 788.6 337.2 L 791.9 340.6 L 795.9 343.1 L 800 345.4 L 804.7 346.5 L 809.6 345.9 L 813.9 348.3 L 812.5 353.9 L 812.2 359.6 L 811.5 365.4 L 813.1 371 L 813.1 376.7 L 814.5 382.2 L 815 387.9 L 816.4 393.4 L 819.4 397.1 L 819.8 401.8 L 822.7 405.4 L 824 409.8 L 823 414.3 L 823.3 418.8 L 822.6 423.4 L 823.6 427.9 L 825.2 431.9 L 828.4 434.8 L 832.3 436.7 L 834.9 439.4 L 802.2 458.3 L 685.1 408 Z",
      "territoryIds": [
        "saltmarch-gate"
      ],
      "color": "#6B9E00",
      "bonusAnchor": {
        "x": 754.5,
        "y": 385.83
      }
    },
    {
      "id": "gate-greywatch",
      "name": "Gate of Greywatch",
      "bonus": 1,
      "shape": "M 772.6 501.7 L 802.2 458.3 L 834.9 439.4 L 835.3 439.7 L 838.7 442.2 L 842.2 444.4 L 844.7 447.8 L 848 450.5 L 850.5 454.2 L 853.3 457.6 L 852.6 462 L 852.5 466.4 L 855.9 469.1 L 859.4 471.5 L 860.5 475.7 L 862.9 479.3 L 865.9 483.1 L 869.9 486 L 870.5 491.1 L 874 494.9 L 877.6 497.9 L 881.5 500.7 L 885.3 503.6 L 889.1 506.5 L 888.3 510.9 L 886.5 515 L 886.3 519.4 L 886.7 523.9 L 888.9 527.8 L 890.1 532.2 L 890.9 536.6 L 890.1 541.1 L 888.7 545.8 L 885.1 549 L 882.6 552.9 L 879.7 556.6 L 879.8 561.3 L 878.7 565.9 L 877.4 570.4 L 876.8 575 L 877.6 579.6 L 877.5 584.2 L 879.3 588.4 L 880.2 593 L 883 596.8 L 883.9 601.4 L 885.7 605.8 L 889.4 608.8 L 886.5 612.1 L 883.5 615.4 L 881.6 619.4 L 880.5 623.7 L 880.4 624.4 L 829.9 615.5 Z",
      "territoryIds": [
        "greywatch-gate"
      ],
      "color": "#FF6B6B"
    },
    {
      "id": "gate-emberrock",
      "name": "Gate of Emberrock",
      "bonus": 1,
      "shape": "M 750 753.8 L 779.3 629.8 L 829.9 615.5 L 880.4 624.4 L 879.7 628 L 877.7 631.9 L 875.9 636 L 876 640.4 L 875.8 645 L 875.2 649.6 L 877.2 653.8 L 878.2 658.3 L 878.9 663.1 L 876.8 667.4 L 878.5 671.7 L 878.6 676.4 L 876.6 680.5 L 872.9 683.3 L 869.5 686.2 L 866 688.9 L 862.8 692.3 L 861 696.5 L 860.9 701.1 L 860 705.6 L 857.6 709.2 L 855.7 713.1 L 853.9 717.1 L 852.2 721.1 L 849.9 724.9 L 846.1 727.4 L 842.5 729.8 L 838.6 731.9 L 836.6 735.8 L 836.1 740.1 L 834 743.9 L 832.6 747.9 L 830.3 751.6 L 827.2 754.7 L 824.5 758.1 L 823.1 762.2 L 818.1 762.4 L 813.2 763.6 L 808.3 763 L 803.3 762.7 L 798.6 764.2 L 794.1 766.5 L 790 769.2 L 785.8 771.9 L 781.6 774.5 L 778.3 778.2 L 778.6 783.1 L 778.5 787.8 Z",
      "territoryIds": [
        "emberrock-gate"
      ],
      "color": "#66BB6A",
      "bonusAnchor": {
        "x": 814.67,
        "y": 690.77
      }
    },
    {
      "id": "gate-thornvale",
      "name": "Gate of Thornvale",
      "bonus": 1,
      "shape": "M 600 808.3 L 702.1 732.2 L 750 753.8 L 778.5 787.8 L 778.5 788 L 776 791.7 L 773.8 795.5 L 771.8 799.5 L 770.2 803.6 L 766 804.4 L 762.3 806.6 L 758.3 808.2 L 754.9 810.8 L 750.7 811.8 L 746.5 812.1 L 742.4 813.2 L 738.4 814.7 L 736.3 819.3 L 733.7 823.7 L 729.8 826.9 L 725.7 829.8 L 724.4 834.7 L 721.2 838.6 L 720.1 843.5 L 717.7 847.9 L 714.7 851.3 L 711.3 854.2 L 707.1 855.8 L 702.9 857.5 L 698.5 858.2 L 694.3 859.9 L 690.3 861.8 L 686.7 864.5 L 681.3 864.7 L 675.8 864.6 L 672.6 860.1 L 667.9 857.1 L 663.2 855.2 L 658.1 854.6 L 653.6 852.1 L 648.7 850.9 L 644.6 851.5 L 640.7 852.7 L 636.6 851.9 L 632.4 852.7 L 628.4 852 L 624.3 851.9 L 620.2 851.4 L 616.1 852.1 L 611.1 852.5 L 606.9 855.1 L 602.1 855.5 L 600 855.5 Z",
      "territoryIds": [
        "thornvale-gate"
      ],
      "color": "#5E4800"
    },
    {
      "id": "gate-mistfell",
      "name": "Gate of Mistfell",
      "bonus": 1,
      "shape": "M 422.6 786.5 L 449.9 753.9 L 577.1 761 L 600 808.3 L 600 855.5 L 597.2 855.5 L 593 857.9 L 588.8 860.6 L 586 864.6 L 582.9 868.3 L 579.2 871.3 L 574.6 872.5 L 570 871.8 L 565.4 871.1 L 561.9 868.2 L 557.7 866.6 L 553.5 864.8 L 549 864.3 L 545.2 861.9 L 541.1 860.3 L 536.7 859.9 L 532.4 858.9 L 528.1 857.4 L 523.6 857.7 L 519.4 859.4 L 514.9 859.3 L 510.9 857.6 L 506.9 855.9 L 502.7 855.1 L 498.5 853.8 L 494.6 852 L 490.5 850.6 L 486.3 849.5 L 482.5 847.5 L 479.2 844.3 L 477.3 840.1 L 474.2 836.9 L 470.7 834 L 466.4 832.5 L 462.8 829.7 L 458.4 828.6 L 453.9 828.1 L 451.4 824.5 L 448.2 821.5 L 444.7 818.9 L 441.2 816.4 L 438.3 813.1 L 436.5 809.1 L 433.5 805.9 L 430.3 803 L 427.5 799.4 L 426.1 795 L 423.7 791.1 L 422.7 786.6 Z",
      "territoryIds": [
        "mistfell-gate"
      ],
      "color": "#00695C"
    },
    {
      "id": "gate-goldcrest",
      "name": "Gate of Goldcrest",
      "bonus": 1,
      "shape": "M 320.4 624.3 L 370.1 615.5 L 462.9 702.9 L 449.9 753.9 L 422.6 786.5 L 421.4 782.1 L 418.3 778.6 L 417.7 774.1 L 416.3 769.7 L 411.6 768.4 L 408.3 764.8 L 404.2 762.7 L 399.7 761.2 L 395 760.8 L 390.3 761.2 L 385.6 760.6 L 381.3 758.5 L 378.9 754.8 L 375.3 752.2 L 372.1 749.3 L 369 746.2 L 365.7 743.3 L 361.9 741.1 L 359 737.7 L 354.7 736.3 L 349.8 735.7 L 345.3 733.4 L 342.4 729.5 L 339.4 725.6 L 335.5 722.9 L 331.6 720.2 L 329.1 716.2 L 326.1 712.5 L 326.8 707.6 L 327.5 702.7 L 328.4 697.8 L 329.3 693 L 328.3 688 L 327.9 683 L 328.3 677.9 L 330.3 673.2 L 327.7 669.6 L 327.6 665.2 L 326.9 661 L 324.7 657.3 L 324.9 653.1 L 324.4 648.9 L 323.4 644.8 L 323.2 640.6 L 323 636.4 L 322 632.4 L 320.8 628.4 Z",
      "territoryIds": [
        "goldcrest-gate"
      ],
      "color": "#00E5CC"
    },
    {
      "id": "gate-stormreach",
      "name": "Gate of Stormreach",
      "bonus": 1,
      "shape": "M 304.9 540.5 L 305.5 536.2 L 306.1 531.8 L 305.7 527.4 L 305.5 523.1 L 307.4 518.9 L 310.6 515.6 L 311.7 511.1 L 311 506.5 L 311.4 502 L 311.8 497.4 L 313.8 493.3 L 315.1 488.9 L 315.1 484.4 L 314.6 479.9 L 313.9 475.4 L 314 470.9 L 319.7 467.9 L 326.1 467.6 L 332 465.5 L 338.3 464.6 L 343.1 460.2 L 349.5 458.9 L 354.9 455.2 L 361.5 455.2 L 363.7 451.6 L 364.9 447.5 L 365.8 443.4 L 366.4 440.1 L 397.9 458.3 L 412.8 584.8 L 370.1 615.5 L 320.4 624.3 L 320.4 624.2 L 320.5 620.1 L 320.8 615.9 L 320.5 611.8 L 320.8 607.6 L 320.3 603.4 L 318.6 599.5 L 319.8 595.4 L 320 591.1 L 319.1 586.8 L 320.2 582.6 L 317.5 579.2 L 316.5 575 L 315.3 570.6 L 313.5 566.4 L 312.1 562 L 309.8 558 L 310 553.3 L 309.9 548.5 L 308.5 543.9 Z",
      "territoryIds": [
        "stormreach-gate"
      ],
      "color": "#EC407A"
    },
    {
      "id": "gate-ashmoor",
      "name": "Gate of Ashmoor",
      "bonus": 1,
      "shape": "M 366.2 435 L 366.4 430.8 L 367.5 426.7 L 368.2 422.5 L 369.4 418.5 L 370.6 414.6 L 373.2 411.3 L 374.7 407.3 L 377.1 404 L 379.3 400.5 L 382 397.4 L 383.8 393.6 L 385.5 389.5 L 388.5 386.2 L 389.9 382.1 L 391.6 378 L 392.9 373.8 L 395.9 370.5 L 397.9 366.5 L 399.5 362.5 L 401.5 357.9 L 406.2 355.9 L 407.8 351.5 L 409.4 347.1 L 411.3 342.9 L 413.2 338.8 L 415.5 334.7 L 418.7 331.4 L 423.5 331.3 L 427.3 328.4 L 431.7 327 L 435 323.6 L 439.2 322.1 L 443.6 321 L 447.9 319.1 L 452.5 319.5 L 456.9 319.1 L 461.3 319.2 L 465.1 316.8 L 469.6 316.2 L 474 315.8 L 478.1 314.2 L 482.3 313.2 L 486.4 311.7 L 490 309.4 L 494.1 307.9 L 497.9 305.9 L 501 303.1 L 520.2 355.7 L 450.3 462.2 L 397.9 458.3 L 366.4 440.1 L 366.6 439.2 Z",
      "territoryIds": [
        "ashmoor-gate"
      ],
      "color": "#CE93D8"
    },
    {
      "id": "run-ironhold",
      "name": "Ironhold Run",
      "bonus": 3,
      "shape": "M 557.8 392.3 L 679.8 355.6 L 685.1 408 L 669 439.6 L 672 464.2 L 630.2 528.6 L 593.2 520.1 L 583.9 443.9 L 565.8 426.9 Z",
      "territoryIds": [
        "ironhold-terrace",
        "ironhold-pit"
      ],
      "color": "#B8F000"
    },
    {
      "id": "run-saltmarch",
      "name": "Saltmarch Run",
      "bonus": 3,
      "shape": "M 630.2 528.6 L 672 464.2 L 669 439.6 L 685.1 408 L 802.2 458.3 L 772.6 501.7 L 739.9 515.6 L 726.4 536.3 L 652.9 558.8 Z",
      "territoryIds": [
        "saltmarch-terrace",
        "saltmarch-pit"
      ],
      "color": "#00D4E8"
    },
    {
      "id": "run-greywatch",
      "name": "Greywatch Run",
      "bonus": 3,
      "shape": "M 651 596.6 L 652.9 558.8 L 726.4 536.3 L 739.9 515.6 L 772.6 501.7 L 829.9 615.5 L 779.3 629.8 L 745.3 619.4 L 721.7 626.6 Z",
      "territoryIds": [
        "greywatch-terrace",
        "greywatch-pit"
      ],
      "color": "#4A148C"
    },
    {
      "id": "run-emberrock",
      "name": "Emberrock Run",
      "bonus": 3,
      "shape": "M 625.2 624.3 L 651 596.6 L 721.7 626.6 L 745.3 619.4 L 779.3 629.8 L 750 753.8 L 702.1 732.2 L 682.8 702.4 L 660 692.7 Z",
      "territoryIds": [
        "emberrock-terrace",
        "emberrock-pit"
      ],
      "color": "#1B5E20"
    },
    {
      "id": "run-thornvale",
      "name": "Thornvale Run",
      "bonus": 3,
      "shape": "M 570.3 703.8 L 587.6 628.9 L 625.2 624.3 L 660 692.7 L 682.8 702.4 L 702.1 732.2 L 600 808.3 L 577.1 761 L 581.4 725.8 Z",
      "territoryIds": [
        "thornvale-terrace",
        "thornvale-pit"
      ],
      "color": "#F48FB1",
      "bonusAnchor": {
        "x": 621.37,
        "y": 705.09
      }
    },
    {
      "id": "run-mistfell",
      "name": "Mistfell Run",
      "bonus": 3,
      "shape": "M 449.9 753.9 L 462.9 702.9 L 488.9 678.6 L 494.5 654.5 L 555.8 608.3 L 587.6 628.9 L 570.3 703.8 L 581.4 725.8 L 577.1 761 Z",
      "territoryIds": [
        "mistfell-terrace",
        "mistfell-pit"
      ],
      "color": "#A08000"
    },
    {
      "id": "run-goldcrest",
      "name": "Goldcrest Run",
      "bonus": 3,
      "shape": "M 370.1 615.5 L 412.8 584.8 L 448.2 583 L 468.1 568.1 L 544.7 572.2 L 555.8 608.3 L 494.5 654.5 L 488.9 678.6 L 462.9 702.9 Z",
      "territoryIds": [
        "goldcrest-terrace",
        "goldcrest-pit"
      ],
      "color": "#3D4B52"
    },
    {
      "id": "run-stormreach",
      "name": "Stormreach Run",
      "bonus": 3,
      "shape": "M 397.9 458.3 L 450.3 462.2 L 478.7 483.6 L 503.4 484.9 L 559.6 537.2 L 544.7 572.2 L 468.1 568.1 L 448.2 583 L 412.8 584.8 Z",
      "territoryIds": [
        "stormreach-terrace",
        "stormreach-pit"
      ],
      "color": "#9FA8DA"
    },
    {
      "id": "run-ashmoor",
      "name": "Ashmoor Run",
      "bonus": 3,
      "shape": "M 450.3 462.2 L 520.2 355.7 L 557.8 392.3 L 565.8 426.9 L 583.9 443.9 L 593.2 520.1 L 559.6 537.2 L 503.4 484.9 L 478.7 483.6 Z",
      "territoryIds": [
        "ashmoor-terrace",
        "ashmoor-pit"
      ],
      "color": "#880E4F"
    },
    {
      "id": "the-sand",
      "name": "The Sand",
      "bonus": 9,
      "shape": "M 544.7 572.2 L 559.6 537.2 L 593.2 520.1 L 630.2 528.6 L 652.9 558.8 L 651 596.6 L 625.2 624.3 L 587.6 628.9 L 555.8 608.3 Z",
      "territoryIds": [
        "throne-sand"
      ],
      "color": "#FFEE22",
      "bonusAnchor": {
        "x": 600.71,
        "y": 574.26
      }
    },
    {
      "id": "ironhold",
      "name": "Isle of Ironhold",
      "bonus": 3,
      "shape": "M 479.4 70.9 L 480.1 67.9 L 479.7 64.8 L 479.6 61.8 L 479.5 58.8 L 481.1 56.5 L 482.9 54.3 L 484.3 51.9 L 485.2 49.3 L 486.7 46.8 L 488.5 44.7 L 489.7 42.2 L 490.8 39.6 L 492.7 37.4 L 495.4 36 L 498 34.8 L 500.9 34.4 L 502.3 31.8 L 503.2 30.8 L 504.2 29.7 L 506.1 27.5 L 508.2 25.6 L 511.3 25.5 L 514.4 26.3 L 517.5 25.5 L 520.6 26.3 L 523.6 27.2 L 526.8 27.2 L 529.9 27.6 L 533 27.3 L 535.6 26.7 L 538.2 26.5 L 540.8 26.9 L 543.3 27.9 L 545.8 28.5 L 548.4 28.9 L 551 28.8 L 553.5 29.6 L 555.8 29.4 L 558 28.9 L 560.2 28.8 L 562.5 28.6 L 564.7 29.1 L 566.9 29.7 L 569.2 29.4 L 571.5 29 L 573.7 29.4 L 576 29.4 L 578.2 29.4 L 580.5 29.2 L 582.7 29.2 L 584.9 29.8 L 587.1 30.4 L 589.4 30.2 L 592.2 27.7 L 595.6 26.1 L 599.2 25.3 L 602.3 23.1 L 605.6 21.3 L 608.2 18.6 L 611.5 16.9 L 614.9 15.4 L 618 16.1 L 620.9 17.3 L 624.1 17.3 L 627.2 17.7 L 630.3 18.6 L 633.4 18.5 L 636.6 18.3 L 639.7 18.2 L 641.4 20.7 L 643 23.3 L 645 25.6 L 647.2 27.6 L 649.8 29.3 L 652 31.5 L 653.3 34.2 L 655 36.8 L 656 39.2 L 656.2 39.7 L 657.1 42.6 L 657.6 45.7 L 657.8 48.8 L 658 51.9 L 659.2 54.8 L 659.9 57.8 L 660.5 60.8 L 660.1 63.7 L 658.9 66.4 L 658.7 69.3 L 658.6 72.1 L 659.1 75 L 659.7 77.8 L 660 80.7 L 660.4 83.5 L 659.8 86.3 L 658.1 88.6 L 656.3 90.9 L 655.8 93.8 L 654.6 96.3 L 653.5 99 L 652.7 101.7 L 651.7 104.3 L 652 106.3 L 651.9 108.4 L 652.6 110.3 L 653 112.4 L 653.3 114.4 L 653.9 116.3 L 654.6 118.3 L 654.9 120.3 L 654.3 122.3 L 654.2 124.4 L 654.1 126.4 L 654.4 128.5 L 653.8 130.4 L 653.8 132.5 L 653.7 134.6 L 653.7 136.6 L 653.3 138.8 L 653.1 141 L 652.9 143.2 L 653.2 145.4 L 653.3 147.7 L 652.9 149.9 L 653.4 152.1 L 653.6 154.3 L 653 156.9 L 652.7 159.5 L 652.6 162.2 L 652.1 164.8 L 652.4 167.4 L 652.8 170 L 653.3 172.6 L 653.6 175.2 L 652 177 L 650.3 178.8 L 648.9 180.8 L 648 183.1 L 646.5 185 L 644.5 186.4 L 643 188.4 L 641.1 189.9 L 639.4 191.7 L 637.5 193.3 L 636.9 193.8 L 635.6 194.9 L 634 196.8 L 632.5 198.8 L 630.8 200.6 L 629.2 202.5 L 627.8 204.6 L 625.6 205.9 L 623.4 207 L 621 207.8 L 618.5 208.1 L 616.6 209.8 L 614.2 210.6 L 612.1 211.8 L 609.7 212.6 L 607.7 214.3 L 605.5 215.7 L 602.8 215.9 L 600.3 215.2 L 597.8 215.2 L 595.4 215.6 L 592.9 215.6 L 590.5 215.6 L 588.3 217.4 L 586.3 219.4 L 583.8 220.8 L 581.5 222.4 L 579.1 224.1 L 577 226 L 574.4 227.2 L 571.5 227.6 L 568.8 227.4 L 566.1 227.7 L 563.4 228 L 560.8 228 L 558 227.8 L 555.4 227.4 L 552.7 228.1 L 550 228.2 L 547.1 229.5 L 543.9 229.9 L 540.8 230.3 L 537.7 231.1 L 534.6 231.1 L 531.4 231.3 L 528.3 231.3 L 525.2 232.1 L 523.4 229.6 L 522 226.8 L 519.6 224.9 L 517.6 222.6 L 515.4 220.5 L 512.9 218.6 L 510.9 216.4 L 508.9 214 L 506.9 212 L 504.6 210.3 L 502.5 208.5 L 500.8 206.2 L 499.4 203.8 L 497.6 201.6 L 496 199.2 L 495.4 196.4 L 493.9 194.1 L 493.2 191.5 L 492.8 190.8 L 491.6 189 L 492.1 186.2 L 491.1 183.7 L 489.8 181.3 L 488.5 179 L 487.4 176.5 L 487.7 173.5 L 488 170.4 L 487.4 167.4 L 487.7 164.4 L 489.2 161.7 L 490.1 158.8 L 490.4 155.6 L 492.3 153.1 L 493.2 151 L 493.5 148.7 L 494.8 146.7 L 495.7 144.6 L 495.4 142.3 L 495.4 140 L 495.5 137.7 L 495.8 135.4 L 494.4 131.8 L 494.1 127.9 L 493.5 124.1 L 492.6 120.3 L 492.5 116.4 L 492.7 112.5 L 493.7 108.8 L 494.3 104.9 L 492.9 102 L 491.5 99.1 L 489.8 96.3 L 487.6 93.9 L 486 91.1 L 484.7 88.1 L 482.6 85.6 L 481 82.8 L 480.6 79.8 L 480.5 76.8 L 479.8 73.8 Z",
      "territoryIds": [
        "ironhold-keep",
        "ironhold-landing",
        "ironhold-cliffs",
        "ironhold-shoals"
      ],
      "color": "#4E1700"
    },
    {
      "id": "saltmarch",
      "name": "Isle of Saltmarch",
      "bonus": 3,
      "shape": "M 844.3 238 L 845.3 234.4 L 846.4 230.9 L 846 227.2 L 845.5 223.6 L 845.9 220.5 L 845.7 217.4 L 846.8 214.4 L 846.8 211.3 L 846.6 208.1 L 846.6 204.8 L 848.4 202.2 L 849.9 199.3 L 849.5 197 L 849.2 194.7 L 849.4 192.4 L 849.6 190.1 L 849.7 187.8 L 850.3 185.5 L 850.4 183.2 L 851.3 181 L 851.5 178.8 L 851.8 176.7 L 851.3 174.5 L 850.6 172.4 L 849.6 170.5 L 849.5 170 L 849.4 168.3 L 848.7 166.2 L 847.3 164.5 L 847.5 162.4 L 847.3 160.3 L 847.3 158.1 L 847.6 156 L 848.4 154 L 848.8 151.9 L 849.3 149.8 L 849.2 147.7 L 850.5 145.8 L 851.5 143.8 L 853 142 L 854.7 140.5 L 856.5 139 L 858.2 137.5 L 860.1 136.2 L 861.8 134.7 L 862.8 132.9 L 864 131.1 L 863.6 129 L 864.2 126.9 L 864.6 125 L 865.1 123 L 865.2 121 L 865.8 119 L 867.7 118.3 L 869.6 117.3 L 871.5 116.6 L 873.3 115.5 L 874.9 114.2 L 876.6 113 L 878 111.4 L 878.8 109.4 L 880.2 107.4 L 881.2 105.3 L 881.8 103 L 882.7 100.8 L 883.3 98.5 L 883.9 96.2 L 884.7 93.9 L 885.2 91.6 L 887.1 89.4 L 888 86.6 L 889.5 84.2 L 890.7 81.6 L 892.3 79.2 L 894.1 76.8 L 894.7 74 L 895.2 71.1 L 897.3 69.2 L 899.6 67.7 L 902 66.2 L 903.9 64.1 L 905.5 61.8 L 907.8 60.2 L 910 58.4 L 912.5 57.1 L 915.2 56.7 L 917.9 56.3 L 920.6 56.5 L 923.2 57.3 L 925.9 57.5 L 927.6 57.3 L 928.6 57.1 L 931.3 56.9 L 933.9 56.3 L 936 58.2 L 938.5 59.4 L 941.3 59.9 L 943.7 61.4 L 946 62.9 L 948.2 64.6 L 950.6 66.2 L 953.4 66.5 L 955.9 67 L 958.3 67.6 L 960.9 67.9 L 963.4 67.7 L 965.9 67.9 L 968.4 68.2 L 970.8 69 L 973.3 69.4 L 976.2 70 L 979.1 70.2 L 981.9 71 L 984.7 71.9 L 987.6 72.1 L 990.5 71.9 L 993.3 70.8 L 996.3 71.1 L 999 72.2 L 1001.9 72.8 L 1004.8 73.7 L 1007.2 75.5 L 1009.7 77.1 L 1012 79 L 1015 79.5 L 1017.7 80.7 L 1020.6 82.6 L 1023.7 84.3 L 1026.7 86.2 L 1029.9 87.5 L 1033.3 88.6 L 1036.3 90.7 L 1039.8 91 L 1043.3 91.5 L 1042.3 94.8 L 1042.2 98.2 L 1042.2 101.7 L 1044 104.7 L 1044.4 108 L 1046.1 110.9 L 1047.3 114 L 1048.4 117.1 L 1047.3 120.7 L 1045.5 124 L 1045.3 127.9 L 1043.1 131 L 1041.5 134.4 L 1040.1 137.9 L 1037.5 140.7 L 1036.1 144.2 L 1033.5 147 L 1030 148.5 L 1029.1 152.3 L 1026.9 155.4 L 1024.6 158.2 L 1024.6 158.3 L 1021.4 160.1 L 1018.8 162.7 L 1015.6 164.5 L 1014.4 166.7 L 1012.5 168.3 L 1010.9 170.3 L 1009 171.9 L 1006.9 173.1 L 1005 174.7 L 1003.3 176.6 L 1001.2 177.9 L 1001 181.5 L 1001 185.1 L 1000.8 188.7 L 1000.8 192.3 L 1000.3 196 L 999.7 199.6 L 997.9 202.8 L 996.3 206.2 L 995.7 208.4 L 995.3 210.6 L 995.1 212.9 L 994.5 215.1 L 994.5 217.4 L 994.5 219.6 L 994.6 222 L 993.5 224.1 L 992 225.9 L 990.1 227.3 L 989.3 229.5 L 988 231.4 L 986.8 233.4 L 985.9 235.5 L 985.2 237.7 L 984.2 239.8 L 982.1 240.7 L 980.1 241.8 L 977.9 242.4 L 975.6 242.2 L 973.3 242.2 L 971.3 243.3 L 969 243.5 L 966.9 244.3 L 965.3 246.3 L 963.2 247.6 L 961.8 249.6 L 960 251.4 L 958.2 253 L 956.3 254.7 L 954.3 256.1 L 952.4 257.7 L 950 259.6 L 947.4 261.2 L 945.2 263.4 L 942.6 265.1 L 940.5 267.3 L 938.4 269.5 L 936.3 271.8 L 933.9 273.7 L 932.3 273.6 L 930.9 273.5 L 928 274.4 L 925.5 276.1 L 922.6 277 L 919.7 278 L 916.7 277.8 L 913.8 278.6 L 911 279.4 L 907.5 279.3 L 903.9 279.2 L 900.5 280 L 896.9 280.4 L 893.5 281.2 L 890.1 282.2 L 886.8 283.6 L 883.8 285.5 L 880.6 284.7 L 877.6 283.5 L 874.5 282.6 L 871.9 280.5 L 869.3 278.6 L 866.8 276.6 L 863.9 275.1 L 861.3 273.2 L 859.6 270.4 L 858 267.6 L 855.7 265.3 L 853.4 262.9 L 851.8 260.1 L 850.1 257.4 L 848.1 254.8 L 846.1 252.3 L 845.9 248.7 L 845.7 245.1 L 845.6 241.4 Z",
      "territoryIds": [
        "saltmarch-keep",
        "saltmarch-landing",
        "saltmarch-cliffs",
        "saltmarch-shoals"
      ],
      "color": "#8B7355",
      "bonusAnchor": {
        "x": 934.71,
        "y": 162.07
      }
    },
    {
      "id": "greywatch",
      "name": "Isle of Greywatch",
      "bonus": 3,
      "shape": "M 985.3 424.2 L 987.5 422.6 L 989.8 421 L 991 418.6 L 992.4 416.2 L 994.3 414.2 L 995.8 412 L 996.6 409.3 L 997.3 406.7 L 1000.5 406.7 L 1003.6 407.2 L 1005.4 406.4 L 1006.4 405.9 L 1009.6 405.2 L 1012.7 405 L 1015.9 404.6 L 1018.6 403.1 L 1021.3 401.4 L 1023.7 400.7 L 1026.1 400.6 L 1028.6 401 L 1031 400.6 L 1033.4 400 L 1035.8 399.6 L 1038 398.4 L 1040.4 398 L 1042.3 397.3 L 1044.2 396.4 L 1046.1 395.7 L 1048.2 395.9 L 1050.2 395.5 L 1052.3 395.4 L 1054.3 394.9 L 1056.3 394.9 L 1058.5 394.2 L 1060.5 393.2 L 1062.5 391.9 L 1063.5 389.7 L 1064.3 387.6 L 1065.9 386 L 1067.5 384.5 L 1069.1 382.9 L 1070.5 381.4 L 1071.4 379.5 L 1072.2 377.7 L 1073 375.8 L 1073.5 373.8 L 1073.9 371.8 L 1074.4 369.9 L 1075.2 368 L 1076.6 366.5 L 1078.6 365.6 L 1079.4 363.7 L 1080.9 362.3 L 1082.5 360.8 L 1082.8 358.6 L 1084.5 357.5 L 1085.6 355.7 L 1088.9 355.1 L 1092.1 354.1 L 1095.5 354.5 L 1098.9 353.7 L 1100.7 350.7 L 1103.5 348.7 L 1106.8 347.8 L 1109.5 345.5 L 1112.1 347.1 L 1114.8 348.4 L 1117.1 350.2 L 1119.9 351.4 L 1122.9 352.1 L 1125.8 352.8 L 1128.5 354 L 1131.3 355.2 L 1132.8 357.9 L 1134.2 360.7 L 1136.5 362.7 L 1138.2 365.3 L 1141 366.4 L 1143.8 367.8 L 1146.7 368.8 L 1149.5 370 L 1151.1 372.8 L 1152.7 375.6 L 1154 378.5 L 1154.7 381.7 L 1156.1 384.6 L 1156.4 387.9 L 1156.6 388.7 L 1157 391.1 L 1157 394.3 L 1157.7 396.8 L 1158 399.5 L 1159.2 401.8 L 1160.1 404.3 L 1159.8 407 L 1159.8 409.7 L 1161.8 411.8 L 1162 414.6 L 1162.8 417 L 1162.9 419.6 L 1163.1 422.1 L 1163 424.6 L 1163 427.3 L 1163.6 430 L 1161.7 431.9 L 1160.8 434.5 L 1162.9 435.7 L 1165.1 436.7 L 1167 438.1 L 1168.6 439.9 L 1169 442.3 L 1169.4 444.8 L 1171.3 446.3 L 1172.7 448.4 L 1173.8 450.5 L 1174.3 452.9 L 1176.1 454.6 L 1177 456.9 L 1177.6 459.3 L 1179.4 461 L 1179.9 463.4 L 1180.5 465.7 L 1181.5 468.1 L 1182.7 470.4 L 1184.4 472.5 L 1184.9 475.1 L 1184.4 477.6 L 1184.4 480.2 L 1184.6 482.8 L 1184.7 485.4 L 1184.6 487.9 L 1184.5 490.5 L 1183.6 492.9 L 1182.7 495.3 L 1182.7 497.8 L 1181.7 500.2 L 1181.3 502.7 L 1180.7 505.1 L 1180.8 508 L 1179.4 510.5 L 1177.4 512.6 L 1176.8 515.5 L 1177.3 518.3 L 1176.1 521 L 1176.1 521 L 1176.9 523.7 L 1176.6 526.5 L 1175.2 528.8 L 1173.6 531 L 1171.1 532.4 L 1170.1 535.1 L 1167.8 536.6 L 1166.6 539.1 L 1164.8 541.2 L 1163.3 543.4 L 1160.5 543.7 L 1157.9 544.5 L 1155.4 545.6 L 1152.8 546.5 L 1150.5 548 L 1148.1 549.4 L 1145.8 551 L 1144 553.1 L 1141.5 554 L 1139.3 555.6 L 1137.1 557.2 L 1134.9 558.7 L 1132.3 559 L 1129.6 558.9 L 1127 559.6 L 1124.3 559.3 L 1121.6 559 L 1119 559.4 L 1116.4 559.9 L 1113.8 560.4 L 1111.1 560.3 L 1108.7 559.2 L 1106.1 558.5 L 1103.8 557.1 L 1101.3 557.5 L 1099.2 556.2 L 1097 555.3 L 1094.9 554.3 L 1092.6 554 L 1090.3 553.8 L 1087.9 554 L 1085.6 553.9 L 1083.5 554.8 L 1081.1 554.7 L 1078.9 554.5 L 1076.7 554 L 1074.4 553.9 L 1072.2 554.2 L 1070 554.6 L 1067.8 555.1 L 1064.8 554.7 L 1061.9 555.4 L 1059.6 557.3 L 1056.8 558.3 L 1054 559.2 L 1051.5 560.7 L 1048.6 560.8 L 1045.8 561.7 L 1043.1 561.4 L 1040.6 560.4 L 1038 560.4 L 1035.4 559.7 L 1032.9 558.6 L 1030.4 557.8 L 1029.7 557.4 L 1028.1 556.5 L 1025.8 555.1 L 1023.1 554 L 1020.5 552.6 L 1017.6 552.1 L 1014.8 551.6 L 1011.8 550.4 L 1008.8 551 L 1006.3 549.2 L 1004 547.3 L 1002.8 544.1 L 1000.5 541.7 L 999.9 538.4 L 1000.5 535 L 1001.1 531.9 L 1001.9 528.7 L 1001.7 525.5 L 1000.9 522.3 L 999.4 520 L 997.7 518 L 996.5 515.5 L 995.7 512.9 L 996.4 510.2 L 996 507.5 L 996.2 504.8 L 997.3 502.3 L 996.2 500.2 L 995.6 497.9 L 994.8 495.7 L 994 493.5 L 993.6 491.2 L 992.5 489 L 992.3 486.7 L 991.6 484.4 L 991.6 482 L 991.5 479.6 L 991.2 477.2 L 991.6 474.8 L 991 472.5 L 990.8 470 L 989.8 467.9 L 988.7 465.7 L 986.7 463.8 L 986.2 461.1 L 986.9 458.6 L 987.6 456.1 L 988 453.7 L 988.5 451.3 L 989.1 448.9 L 989 446.5 L 988 443.8 L 987.8 441 L 987.4 438.1 L 986.1 435.5 L 985.5 432.6 L 986.5 429.8 L 985.7 427 Z",
      "territoryIds": [
        "greywatch-keep",
        "greywatch-landing",
        "greywatch-cliffs",
        "greywatch-shoals"
      ],
      "color": "#B0003A"
    },
    {
      "id": "emberrock",
      "name": "Isle of Emberrock",
      "bonus": 3,
      "shape": "M 917.9 797.4 L 919 794.5 L 920.3 791.7 L 921.1 788.7 L 921.6 785.7 L 922.7 782.8 L 923.8 779.9 L 924.4 776.8 L 924.4 773.7 L 926.4 771.1 L 928.4 768.7 L 930 765.9 L 931.4 762.9 L 933.5 760.4 L 935.5 757.7 L 938.4 756.1 L 941.6 755.1 L 942.9 752.6 L 943.7 749.8 L 945.5 747.6 L 947.3 745.4 L 949.3 743.3 L 952 742.3 L 954.2 740.6 L 956.6 739.1 L 959.7 738.4 L 962.7 737.5 L 965.9 738.1 L 968.8 739.1 L 971.9 738.5 L 974.8 737.3 L 977.2 735.2 L 979.5 733.1 L 981.5 732 L 983.3 730.6 L 984.6 728.6 L 986 726.9 L 987.9 725.6 L 989.9 724.6 L 992.2 724.3 L 994.3 723.3 L 996.5 723.2 L 998.8 723.1 L 1001 723.2 L 1003.2 722.7 L 1004.9 721.1 L 1006.9 720.1 L 1008.8 718.9 L 1010.8 717.9 L 1011.9 715.8 L 1013.5 714 L 1015.8 712.9 L 1017 710.7 L 1019.3 710 L 1021.5 709 L 1021.5 709 L 1023.8 708.3 L 1025.7 706.8 L 1028 705.8 L 1029.6 703.8 L 1032 703.3 L 1034.4 703.2 L 1036.5 704.9 L 1038.9 705.9 L 1041.4 704.9 L 1043.8 703.9 L 1045.8 705.1 L 1047.9 706 L 1050 707.1 L 1052.2 707.7 L 1054.6 708 L 1056.7 709 L 1059.1 709.3 L 1061.4 708.9 L 1063.3 710.2 L 1065.2 711.3 L 1067.5 711.6 L 1069.6 712.4 L 1071.7 713.1 L 1073.9 713.7 L 1076.1 713.7 L 1078.4 713.8 L 1080.7 714.3 L 1083.1 714.6 L 1085.1 716 L 1087.3 717 L 1089.6 717.3 L 1091.8 718.3 L 1094.2 718.3 L 1096.6 718.3 L 1099.1 719.4 L 1100 722 L 1102 723.5 L 1104.1 724.8 L 1104.7 727.3 L 1106 729.5 L 1106.7 732 L 1106.6 734.5 L 1108.2 736 L 1109.7 737.6 L 1111 739.4 L 1112 741.4 L 1114 742.6 L 1114.7 744.8 L 1115.4 746.9 L 1116.6 748.8 L 1117 751.1 L 1117.5 753.3 L 1119.1 754.9 L 1120.6 756.7 L 1122 758.4 L 1123.8 759.7 L 1124.6 762 L 1126.8 763 L 1128.6 764.9 L 1130.6 766.6 L 1132.6 768.2 L 1134.5 769.9 L 1136.9 771.2 L 1139 773 L 1139.4 775.7 L 1140.8 778.1 L 1141.1 778.5 L 1143.1 781 L 1145.2 784 L 1148.3 786.1 L 1151.7 787.7 L 1154.9 789.5 L 1157.5 792.1 L 1159.4 795.3 L 1162.4 797.4 L 1163.4 800.7 L 1165.4 803.5 L 1166.9 806.6 L 1167.8 809.9 L 1169.4 812.9 L 1170.1 816.3 L 1171.6 819.4 L 1171.8 822.9 L 1169.7 825.4 L 1168.7 828.6 L 1167.3 831.5 L 1165.2 834 L 1163.9 837 L 1162.4 839.9 L 1159.6 841.8 L 1158.1 844.8 L 1155.3 846.4 L 1152.7 848.2 L 1149.4 848.8 L 1147.3 851.5 L 1145.5 854.2 L 1144.4 857.3 L 1142.7 860.1 L 1142.6 863.4 L 1139.3 863.4 L 1136.1 863.8 L 1133.6 866 L 1131.3 868.4 L 1128.8 870.2 L 1126.3 872 L 1123.5 873.6 L 1120.4 874 L 1117.1 873.5 L 1113.9 872.7 L 1110.6 872.9 L 1107.3 872.9 L 1104 873 L 1100.8 872.2 L 1097.5 873.1 L 1094.2 872.9 L 1091.7 873.1 L 1089.3 874 L 1086.7 874 L 1084.4 875.1 L 1082 874.3 L 1079.8 873.1 L 1077.3 872.5 L 1074.8 872.2 L 1073.5 874.1 L 1071.8 875.7 L 1070.2 876.5 L 1069.7 876.8 L 1068.4 878.7 L 1066.5 880.1 L 1064.9 881.8 L 1063 883 L 1061 884.2 L 1059.4 886.2 L 1057.1 887.4 L 1055.2 889.1 L 1053.3 890.8 L 1050.7 891 L 1048.3 891.8 L 1046.1 893.1 L 1043.8 894.3 L 1041.3 894.4 L 1038.9 893.6 L 1036.5 893.9 L 1034 894.3 L 1031.5 894.1 L 1029.1 893.8 L 1026.8 895 L 1024.3 895.2 L 1022.6 893.3 L 1020.6 891.7 L 1018.6 890.1 L 1016.7 888.4 L 1014.7 886.8 L 1012.4 885.6 L 1010.7 883.7 L 1008.7 882.1 L 1006.3 881.1 L 1005 878.9 L 1003.2 877.1 L 1002 875 L 1001.2 872.7 L 1000 870.5 L 999 868.3 L 997.9 866.1 L 996.6 864.3 L 994.6 863.6 L 993.8 861.7 L 992.2 860.3 L 990.2 859.6 L 988.9 857.9 L 987.2 856.7 L 985.6 855.5 L 983.9 854.3 L 982 853.3 L 980.3 852.1 L 978.6 851 L 977.5 849.1 L 976.2 847.5 L 974.4 846.3 L 973.1 844.6 L 969.8 843.9 L 966.5 844 L 963.3 843.3 L 960 842.8 L 956.8 841.8 L 953.7 840.7 L 950.8 839 L 948.1 837 L 945.7 834.6 L 943.6 833.2 L 942.9 832.6 L 939.7 831.2 L 937.6 828.4 L 934.5 826.9 L 931.6 825.2 L 929 822.9 L 926.3 820.8 L 926.6 817.6 L 925.3 814.6 L 924.6 811.5 L 924.2 808.3 L 922 806 L 920 803.5 L 919.7 800.2 Z",
      "territoryIds": [
        "emberrock-keep",
        "emberrock-landing",
        "emberrock-cliffs",
        "emberrock-shoals"
      ],
      "color": "#5D4037"
    },
    {
      "id": "thornvale",
      "name": "Isle of Thornvale",
      "bonus": 3,
      "shape": "M 659.1 1009.4 L 660.3 1006.8 L 661.6 1004.3 L 663.1 1001.9 L 664.7 999.5 L 665.9 996.8 L 665.9 993.9 L 667.6 991.6 L 668.9 989 L 669.5 986.4 L 670 983.9 L 669.9 981.2 L 671.1 978.7 L 670.5 976.1 L 670.6 973.4 L 671.6 970.9 L 672 968.3 L 673.1 967 L 673.8 966.1 L 676.4 964.7 L 677.4 962.1 L 678.8 959.6 L 681.3 958.3 L 683.6 956.8 L 685.6 954.7 L 688.4 954.1 L 690.4 952.4 L 692.9 951.7 L 695.4 951.1 L 697.7 949.8 L 699.9 948.6 L 702.2 947.4 L 704.7 946.7 L 706.7 944.9 L 708.8 944 L 710.7 942.9 L 712.9 942.3 L 715.1 941.6 L 716.6 939.9 L 718.7 939 L 720.8 938.1 L 722.4 936.4 L 724.4 935.2 L 725.9 933.5 L 727.7 931.9 L 729 930.1 L 730.1 928 L 731.6 926.1 L 733.8 925.3 L 735.7 923.8 L 738.4 924.2 L 741.1 924.2 L 743.6 923 L 746 921.9 L 748 920 L 750.2 918.4 L 751.1 915.8 L 752 913.2 L 754.7 913.1 L 757.3 912.5 L 759.9 911.9 L 762.5 911.1 L 764.5 909.2 L 767.2 908.5 L 769 906.4 L 771.1 904.7 L 773.6 902.4 L 776.9 901.9 L 779.9 900.6 L 782.3 898.4 L 785.9 898.3 L 789.4 898.8 L 792.4 896.7 L 794.2 893.5 L 796.8 894.9 L 799.5 896 L 802.1 897.3 L 804.4 899.1 L 806.9 900.8 L 809.9 901.3 L 812.9 901.5 L 815.8 901.7 L 818.1 903.6 L 819.5 906.2 L 821.1 908.7 L 822.4 910.1 L 823 910.8 L 825.4 912.7 L 827 915.2 L 829.7 916.5 L 832.3 917.9 L 833.1 921 L 834.6 923.8 L 835.9 926.8 L 838 929.2 L 837.6 932.3 L 837.7 935.5 L 838.2 938.7 L 838.7 941.8 L 840.3 944 L 842 946.1 L 843.1 948.7 L 844 951.2 L 843.5 953.9 L 842.8 956.5 L 841.8 959.1 L 842.1 961.9 L 842.6 964 L 842.9 966.1 L 843.3 968.3 L 842.7 970.5 L 844 972.3 L 845.3 974 L 845.5 976.2 L 845.9 978.4 L 847.8 979.6 L 849.3 981.1 L 850.2 983.2 L 851.4 985 L 852.3 987 L 853.8 988.6 L 854.9 990.5 L 855.4 992.6 L 858 993.8 L 860.2 995.6 L 862.8 997.1 L 863.9 999.9 L 866.2 1001.7 L 868.6 1003.5 L 869 1006.5 L 869.7 1009.4 L 869.1 1011.8 L 868.4 1014.1 L 867.5 1016.4 L 866.5 1018.6 L 866.5 1021.1 L 866.8 1023.5 L 866.9 1026 L 866.7 1028.4 L 865.9 1030.7 L 865.7 1033.1 L 865.1 1035.5 L 865.2 1037.9 L 864.6 1040.3 L 863.3 1042.3 L 862.6 1044.7 L 861 1046.6 L 859.2 1048.3 L 858.8 1050.8 L 857.5 1052.9 L 856.7 1055.1 L 854.8 1056.7 L 852.9 1058.3 L 852.7 1058.6 L 851.7 1060.5 L 851.2 1062.9 L 849.3 1064.3 L 847.5 1065.9 L 845.7 1067.4 L 843.5 1068.4 L 841.8 1070.1 L 839.7 1071.4 L 838.4 1073.4 L 837.4 1075.6 L 835.6 1078.1 L 835 1081.1 L 834.1 1083.9 L 832.4 1086.4 L 831.4 1089.4 L 832.5 1092.4 L 831.7 1095.3 L 830.5 1098.1 L 829.2 1100.9 L 828.2 1103.8 L 827 1106.6 L 824.9 1108.9 L 823 1111.3 L 820.4 1113 L 818.4 1115.5 L 815.6 1116.8 L 813.2 1119.3 L 810.7 1121.7 L 809.1 1124.9 L 808.5 1128.4 L 805.1 1129.1 L 801.7 1129.4 L 798.7 1131.2 L 795.7 1132.9 L 792.6 1132.7 L 789.5 1132.6 L 786.5 1132.8 L 783.4 1133 L 780.3 1133.6 L 777.2 1132.9 L 774.1 1132.7 L 771.1 1131.8 L 768.1 1130.5 L 765.3 1128.8 L 762.3 1127.8 L 759.2 1126.6 L 757.3 1123.9 L 754.6 1122 L 751.4 1120.8 L 749.5 1118 L 747.5 1114.6 L 746 1110.9 L 745.2 1107 L 744.9 1103 L 743.2 1101.7 L 741.4 1100.5 L 739.8 1099.1 L 738.7 1097.2 L 738.9 1095.1 L 739 1093 L 738.7 1090.9 L 738.2 1088.8 L 738.1 1088.7 L 737.1 1086.7 L 736.3 1084.5 L 735 1082.5 L 733.4 1080.8 L 731.8 1078.9 L 730.7 1076.9 L 730.4 1074.5 L 729.1 1072.4 L 725.9 1070.3 L 722.7 1068.3 L 719.5 1066.3 L 716.2 1064.3 L 713.8 1063.9 L 711.6 1062.8 L 709.9 1061 L 707.7 1059.9 L 705.6 1058.6 L 703.2 1058.2 L 700.7 1058 L 698.3 1058.1 L 695.5 1057.3 L 692.8 1056.1 L 690.1 1055 L 687.2 1054.4 L 684.5 1053.2 L 682.6 1050.9 L 679.5 1050.5 L 677.4 1048.2 L 676 1046 L 675.6 1043.5 L 675 1041.1 L 674.8 1038.6 L 673 1036.6 L 671.9 1034.3 L 671.1 1031.7 L 671.7 1029.1 L 669.5 1027 L 667 1025.3 L 665.1 1023 L 663.7 1020.3 L 663 1017.3 L 660.8 1015.1 L 659.8 1012.3 Z",
      "territoryIds": [
        "thornvale-keep",
        "thornvale-landing",
        "thornvale-cliffs",
        "thornvale-shoals"
      ],
      "color": "#D32F2F"
    },
    {
      "id": "mistfell",
      "name": "Isle of Mistfell",
      "bonus": 3,
      "shape": "M 356.5 1017.8 L 357.2 1015.6 L 357.1 1013.3 L 357.7 1011.1 L 357.7 1008.8 L 359 1007 L 360.4 1005.2 L 361.2 1003 L 362.4 1001.1 L 363.6 999.4 L 364.4 997.5 L 365.7 995.9 L 367.2 994.6 L 368 992.6 L 369 990.9 L 370 989.1 L 370.9 987.3 L 371.2 983.7 L 372.4 980.3 L 372.9 976.7 L 372.7 973.1 L 372.8 970.9 L 372.5 968.6 L 372.3 966.4 L 372.4 964.2 L 372.1 962 L 372.2 959.7 L 372.1 957.5 L 371.9 955.3 L 370.6 951.6 L 370 947.7 L 368.3 944.2 L 367.1 940.4 L 367.1 938.4 L 367.9 936.4 L 367.4 934.4 L 366.6 932.5 L 364.8 929 L 364.3 925 L 365.2 921.9 L 365.6 918.7 L 367.6 916.1 L 368.8 913 L 370.3 910.2 L 371.4 907.2 L 372.2 904.1 L 373.6 901.2 L 375.5 898.3 L 378 895.8 L 380.3 893.1 L 381.3 889.7 L 383.7 887.1 L 385.3 884.1 L 387.5 881.4 L 388.8 879.8 L 389.7 878.7 L 392.9 878.2 L 396.2 878 L 399.5 877.9 L 402.6 876.5 L 405.9 876.2 L 409.1 875.3 L 412.3 876.3 L 415.6 876.3 L 418.7 875.6 L 421.8 875.2 L 424.9 874.2 L 428 873.8 L 431.2 873.6 L 434.3 872.9 L 437.4 872.1 L 440.4 871 L 442.9 873.3 L 445.3 875.6 L 448.3 877.3 L 451.4 878.7 L 454.5 879.9 L 457.5 881.5 L 460.5 882.9 L 463.7 883.9 L 466.5 885 L 468.5 887.2 L 471.3 888.2 L 473.8 889.8 L 476.2 891.6 L 478.7 893.3 L 481.6 893.9 L 484.5 894.7 L 486.8 897.1 L 488.5 899.9 L 489.1 903.2 L 490.2 906.3 L 491.4 909.3 L 493.4 911.9 L 494.3 915 L 496 917.8 L 497.4 920.1 L 497.8 922.8 L 499.3 925 L 500.5 927.3 L 501.3 929.9 L 502.9 932.1 L 503.6 934.6 L 504.3 937.2 L 503.4 940.3 L 502.4 943.3 L 501.3 946.4 L 501 949.6 L 500.4 952.7 L 499.6 955.8 L 499.1 959 L 498.7 962.2 L 499.3 965.6 L 500 969 L 501.1 972.3 L 502 975.6 L 504.2 978.3 L 505.1 979.6 L 506 981.2 L 507.6 984.3 L 508.8 987.5 L 508.5 990.9 L 508.5 994.3 L 508.8 997.7 L 509.3 1001.1 L 510.8 1003.1 L 512.7 1004.8 L 513.4 1007.3 L 514.8 1009.3 L 516.6 1011.1 L 518.7 1012.6 L 519.8 1014.9 L 521 1017.1 L 521.9 1019.8 L 523.7 1022.1 L 523.4 1024.9 L 523.6 1027.8 L 524.9 1030.2 L 525.7 1032.8 L 527.3 1035.1 L 528.5 1037.6 L 528.2 1040.3 L 528.5 1043 L 529 1045.7 L 529 1048.5 L 529.1 1051.2 L 529 1054 L 528 1056.5 L 527.3 1059.2 L 526.8 1062 L 525.4 1064.4 L 524.4 1067.1 L 523.7 1069.8 L 523.1 1072.5 L 522.3 1075.2 L 520.8 1077.7 L 519.4 1080.1 L 517.1 1081.6 L 515.1 1083.5 L 513.1 1085.3 L 511.2 1087.4 L 509.3 1089.3 L 506.9 1090.8 L 504.6 1092.3 L 502.2 1093.6 L 500.2 1096.3 L 498.5 1099.2 L 496.8 1102.2 L 495.5 1105.3 L 493.7 1108.1 L 491.5 1110.7 L 489.5 1113.5 L 488.2 1116.6 L 485.6 1118.8 L 482.7 1120.8 L 480.5 1121.8 L 479.6 1122.3 L 476.6 1124.1 L 474 1126.3 L 471.1 1128.2 L 469 1131 L 466.7 1133.6 L 463.4 1133.8 L 460.1 1134.3 L 456.8 1134.4 L 453.5 1133.8 L 450.2 1133.9 L 447 1134.6 L 443.7 1134.6 L 440.4 1134.3 L 438.7 1133.1 L 437.4 1131.4 L 435.6 1130.4 L 434 1129.1 L 432.2 1128 L 430.8 1126.5 L 428.9 1125.6 L 427.2 1124.4 L 426 1122.7 L 425.2 1120.8 L 424.5 1118.8 L 423.6 1117 L 421.8 1115.8 L 420.3 1114.2 L 419.6 1112.2 L 418.7 1110.3 L 416.9 1108 L 414.7 1106 L 412.8 1103.7 L 410.9 1101.5 L 408.7 1099.5 L 406.7 1097.3 L 404.4 1095.4 L 402.1 1093.6 L 401.8 1090.3 L 401.8 1086.9 L 401.1 1083.7 L 401 1080.3 L 399.9 1077.1 L 398.8 1074 L 397.4 1070.9 L 395.6 1068.1 L 395.5 1065.9 L 395.4 1063.6 L 394.5 1061.6 L 393.5 1059.5 L 392.7 1057.5 L 391.9 1055.4 L 390.8 1053.5 L 390.1 1051.4 L 386.5 1050 L 383.1 1048.2 L 380.2 1045.8 L 377.2 1043.4 L 375.3 1042.1 L 373.5 1040.7 L 371.4 1039.7 L 369.2 1039.2 L 367.5 1037.7 L 366.5 1037.1 L 365.6 1036.5 L 363.8 1035.1 L 362.2 1033.5 L 361.3 1031.6 L 360.9 1029.5 L 360 1027.6 L 359.1 1025.7 L 358.4 1023.7 L 357.4 1021.9 L 357.2 1019.8 Z",
      "territoryIds": [
        "mistfell-keep",
        "mistfell-landing",
        "mistfell-cliffs",
        "mistfell-shoals"
      ],
      "color": "#80CBC4"
    },
    {
      "id": "goldcrest",
      "name": "Isle of Goldcrest",
      "bonus": 3,
      "shape": "M 79.1 859.1 L 79.5 856.6 L 79.5 854 L 79.7 851.4 L 80.6 848.9 L 81.2 846.3 L 82.6 844 L 82.8 841.4 L 83.5 838.9 L 84 836.3 L 85.2 833.9 L 84.8 831.6 L 85.9 829.6 L 86.8 827.6 L 88.3 826 L 88.8 823.9 L 89.1 821.8 L 89.6 819.7 L 89.9 817.6 L 89.4 815.6 L 89.1 813.6 L 89.5 811.6 L 89.1 809.6 L 88.8 807.6 L 88.2 805.7 L 87.5 803.7 L 87.5 801.7 L 87 800.7 L 86.3 799.4 L 85.4 797.1 L 86.5 794.7 L 86.2 792.1 L 86.2 789.6 L 85.5 787.2 L 84.7 784.9 L 83.4 782.8 L 83.6 780.3 L 83.6 777.8 L 83.3 775.4 L 83.3 772.9 L 83.9 770.4 L 84.8 768.1 L 85.7 765.8 L 86.3 763.4 L 87.7 761.1 L 88.7 758.7 L 89.3 756.1 L 90.5 753.7 L 91 751.1 L 91.2 748.4 L 92.3 746 L 93.2 743.5 L 93.7 740.1 L 92.8 736.9 L 94.4 733.9 L 95.2 730.7 L 96.5 727.6 L 98.9 725.3 L 100.7 722.6 L 101.8 719.5 L 104.9 719 L 107 716.7 L 110.1 715.7 L 111.3 712.7 L 113.7 710.8 L 116.5 710 L 118.9 708.3 L 121.4 706.7 L 123.5 704.2 L 126 702 L 128.6 700 L 131.7 698.7 L 133.5 695.7 L 136.9 694.8 L 140 693.6 L 142.1 690.9 L 145.4 691.2 L 148.4 692.3 L 151.6 693.1 L 154.9 693 L 157.7 694.7 L 160.7 696.2 L 164 696 L 167.3 696.8 L 170.3 697.5 L 173.1 699 L 175.3 701.2 L 177.7 703.2 L 180.9 703.3 L 183.6 704.9 L 186.6 705.6 L 189.7 705.2 L 190.9 709 L 193.2 712.2 L 193.6 712.7 L 195.6 715.4 L 197.4 718.8 L 197.7 722.8 L 198.8 726.6 L 200.3 730.3 L 202.1 733.8 L 202.6 736.5 L 203.9 738.8 L 205 741.3 L 205.3 744 L 205.8 746.7 L 206.5 749.4 L 208.3 751.5 L 210.2 753.5 L 212.5 756.5 L 214.7 759.6 L 217.3 762.3 L 220.4 764.6 L 224.1 765.9 L 227.3 768.2 L 229.6 771.3 L 231.5 774.7 L 233.5 778.1 L 236.2 780.9 L 238.7 784 L 241.1 787.1 L 244.4 788 L 247.8 788.5 L 251.1 789.4 L 254.1 791 L 256.7 793.3 L 259.9 794.5 L 262.9 796.1 L 265.7 798 L 267 801.2 L 270.2 802.7 L 273 804.3 L 275.5 806.3 L 277.4 809 L 278.1 812.2 L 280.3 814.7 L 281.7 817.6 L 280.4 820.1 L 279 822.6 L 277.4 825.1 L 275.8 827.5 L 275.4 830.3 L 275.1 833.2 L 273.4 835.6 L 273.1 838.6 L 271 840.3 L 269.3 842.5 L 269.1 843 L 268.3 845 L 267.5 847.6 L 267.1 850.3 L 265.6 852.6 L 264 854.8 L 262.9 857.2 L 261.4 859.4 L 259.1 860.7 L 257.8 863 L 257.3 865.6 L 255.7 867.6 L 254 869.4 L 252.4 871.4 L 251.3 873.7 L 250.1 875.9 L 248 877.4 L 246.1 878.9 L 244.3 880.7 L 243.3 883.1 L 241.3 884.6 L 239.9 886.7 L 237.9 888.2 L 236.9 891 L 236.7 894 L 235.4 896.6 L 233.8 899.1 L 232.2 901.6 L 231.2 904.4 L 230.6 907.3 L 228.9 909.7 L 226.9 911.7 L 224.7 913.5 L 222 914.3 L 219.4 915.3 L 217 916.7 L 214.7 918.4 L 212.8 920.4 L 210.7 922.2 L 207.9 922.3 L 205.1 922.2 L 202.3 922.4 L 199.4 922.3 L 196.6 922.8 L 193.8 923.4 L 190.9 923.4 L 188.2 922.5 L 185.5 922.9 L 182.8 922.5 L 180.2 923.3 L 177.8 924.5 L 175.1 924.4 L 172.5 924.2 L 170 923.3 L 167.3 923 L 164.7 921.8 L 162.1 920.4 L 159.2 919.2 L 157.6 916.7 L 155.8 914.4 L 153.6 912.5 L 151.4 910.5 L 149.2 908.6 L 147.4 907.1 L 145.1 906.4 L 143 904.9 L 142.9 904.9 L 140.6 905.8 L 138.4 905 L 136.6 903.6 L 134.8 902.2 L 132.7 901.3 L 130.3 901.6 L 127.9 901.2 L 125.7 900.2 L 123.4 899.5 L 121.2 898.5 L 119.3 897 L 116.8 897.4 L 114.4 896.9 L 111.7 896.2 L 109.1 897 L 106.5 896.4 L 104.1 895.1 L 102.3 893.2 L 100 891.9 L 97.4 891.3 L 95.1 889.9 L 93.3 888.2 L 91.7 886.2 L 89.8 884.5 L 88.7 882.2 L 87 880.3 L 85.4 878.3 L 84.1 876.1 L 83.3 873.7 L 81.7 871.6 L 81.1 869.1 L 80.4 866.6 L 79.7 864.2 L 79.7 861.6 Z",
      "territoryIds": [
        "goldcrest-keep",
        "goldcrest-landing",
        "goldcrest-cliffs",
        "goldcrest-shoals"
      ],
      "color": "#2E4000"
    },
    {
      "id": "stormreach",
      "name": "Isle of Stormreach",
      "bonus": 3,
      "shape": "M 16.3 515.8 L 16.4 512.7 L 17.2 509.7 L 16.7 506.7 L 17.3 503.6 L 19 500.9 L 18.9 497.7 L 20.4 495.1 L 21.5 492.3 L 22.4 489.4 L 23.4 486.6 L 26.1 484.8 L 27.9 482.1 L 29 479.2 L 29.2 476 L 31 473.6 L 32.6 471.1 L 34.4 468.6 L 35.3 465.8 L 37.6 463.8 L 40.1 462.1 L 42.5 460.3 L 45.5 459.5 L 46.4 457.6 L 47.1 455.5 L 48.4 453.8 L 49.4 451.9 L 51 450.5 L 52.7 449.1 L 54.1 447.5 L 55.4 445.8 L 55.3 443.4 L 56 441.1 L 56.7 438.8 L 56.8 436.5 L 56.3 434.2 L 55.6 431.9 L 54.8 429.6 L 55.1 427.2 L 56.5 425.5 L 58.4 424.3 L 60.4 423.3 L 61.7 421.4 L 62.9 419.6 L 64.2 417.8 L 65.2 415.9 L 66.3 414 L 68.1 412.8 L 70.1 412 L 71.6 410.4 L 73.5 409.3 L 75.4 408.1 L 77.4 407.3 L 79.6 407.2 L 81.6 406.3 L 83.7 406.1 L 85.5 405 L 85.6 405 L 87.3 403.9 L 89.3 403.6 L 91.2 402.7 L 93.2 402 L 95.3 401.3 L 96.5 399.5 L 98.5 399.3 L 100.6 399 L 102.3 397.9 L 104.3 397.2 L 106.3 397 L 108.4 397.4 L 110.2 396.3 L 112.2 395.8 L 114.2 394.7 L 116.5 393.9 L 118.4 392.7 L 120.3 391.4 L 122 389.6 L 123.7 388.1 L 125.9 387 L 128.2 386.5 L 130.5 385.7 L 132.6 384.5 L 135.1 384.6 L 137.3 383.4 L 139.6 382.2 L 142.1 382.4 L 144.5 382.4 L 146.9 382 L 150.2 381.1 L 153 379.2 L 156.4 379.2 L 159.6 378 L 162.5 375.9 L 166.1 375.9 L 169.4 374.6 L 171.4 371.7 L 174.6 372.8 L 178 372.7 L 181.3 372.1 L 184.7 372.2 L 188 372.1 L 191.3 371.4 L 194.6 371.7 L 197.9 371.6 L 200.7 373 L 202.6 375.5 L 204.4 378 L 206.8 380 L 208.7 382.6 L 211.5 384 L 213.3 386.5 L 215.4 388.7 L 216.1 391.7 L 216.7 394.8 L 218.1 397.5 L 218.7 400.6 L 220.4 403.1 L 222.2 405.7 L 224.3 408 L 225.8 410.7 L 225.2 413.8 L 224.5 417 L 223.2 420 L 223.5 423.3 L 222.4 426.5 L 222.5 427 L 223.3 429.8 L 224 432.9 L 224.5 436.1 L 224.7 438.8 L 225.1 441.5 L 226.9 443.7 L 228.2 446.1 L 227.5 448.6 L 226.9 451.2 L 225.6 453.7 L 226.2 456.5 L 227.5 458.8 L 228.8 461.1 L 230.3 463.4 L 231.6 465.7 L 232.5 468.2 L 233.4 470.7 L 233.9 473.3 L 234.2 476 L 235.3 478.7 L 237.1 481 L 236.9 483.9 L 237.6 486.8 L 236.7 489.6 L 237 492.6 L 237.6 495.4 L 239 498 L 237.7 500.5 L 236.2 502.9 L 235.9 505.6 L 235.2 508.4 L 233.5 510.6 L 232.4 513.1 L 230.7 515.4 L 230.4 518.3 L 227.5 519.3 L 225.1 521.2 L 223.2 523.8 L 220.1 524.6 L 217.4 526.1 L 214.4 526.8 L 212 528.7 L 209.3 530.2 L 206.2 530.8 L 203.2 531.3 L 200.2 532.2 L 197.1 532.9 L 194.1 533.6 L 190.9 533.3 L 187.7 533.9 L 184.7 532.5 L 182.5 532.6 L 180.3 533.1 L 178.1 533.5 L 176 534.2 L 173.7 534.7 L 171.5 534 L 169.3 534.4 L 167.1 534.2 L 164.6 534.6 L 163.6 534.8 L 160.3 535.8 L 156.8 536.3 L 153.3 536.7 L 151 539.5 L 148.1 541.7 L 145.1 543.7 L 142.1 545.8 L 140.9 548.1 L 139.1 550 L 137.3 551.9 L 135.3 553.7 L 133.9 555.8 L 132.4 558 L 130.2 559.4 L 128.2 561.2 L 126.2 563.5 L 124.4 566.1 L 121.6 567.4 L 119.4 569.5 L 117 571.5 L 114.2 572.7 L 111.1 573.3 L 108.5 574.9 L 105.6 575.2 L 102.7 576.1 L 100.2 577.5 L 97.5 578.8 L 94.5 578.6 L 91.8 577.4 L 88.8 577.2 L 85.9 578.1 L 82.7 578.5 L 79.5 578.1 L 76.3 577.9 L 73.2 577.1 L 70 577.4 L 66.8 577.5 L 63.6 578.1 L 60.4 577.4 L 58.1 575.5 L 55.9 573.4 L 53.8 571.1 L 52 568.7 L 49.3 567.4 L 46.6 565.9 L 43.8 564.7 L 41.6 562.5 L 39.2 560.7 L 36.8 558.8 L 34.6 556.6 L 33.5 553.7 L 31.8 551.2 L 29.6 549.1 L 28 546.4 L 27.9 545.9 L 27.2 543.5 L 25.6 540.8 L 24.7 537.8 L 24.6 534.7 L 24.6 531.6 L 24 528.5 L 22.2 525.8 L 19.7 523.9 L 17.3 521.9 L 16.9 518.9 Z",
      "territoryIds": [
        "stormreach-keep",
        "stormreach-landing",
        "stormreach-cliffs",
        "stormreach-shoals"
      ],
      "color": "#7A3200",
      "bonusAnchor": {
        "x": 128.39,
        "y": 476.82
      }
    },
    {
      "id": "ashmoor",
      "name": "Isle of Ashmoor",
      "bonus": 3,
      "shape": "M 146.6 205.4 L 146.9 202.4 L 148 199.5 L 149 196.6 L 150.7 194.1 L 152.1 191.4 L 153.1 188.6 L 153.4 187.7 L 154.1 185.7 L 155.4 183 L 156.7 180.4 L 157.6 177.7 L 158.1 174.8 L 158.9 172 L 160.1 169.4 L 161.9 167.1 L 164.3 165.5 L 166.1 163.1 L 167.8 160.9 L 169.7 159 L 171.7 157.2 L 173.7 155.2 L 175.1 152.9 L 177.1 151 L 178.8 148.9 L 180.8 147 L 182.9 145.1 L 185.4 144 L 187.1 141.9 L 188.9 139.8 L 191.5 138.9 L 194.1 138.1 L 196.6 137.1 L 199.2 136.3 L 201 134.7 L 203.1 133.5 L 205.1 132 L 206.7 130.2 L 208.9 129.2 L 211.2 128.6 L 213.5 127.7 L 215.7 126.7 L 217.5 125.2 L 219.6 124.1 L 221.5 122.8 L 223.5 121.5 L 225.8 121 L 227.8 119.7 L 230 119 L 232.2 118.2 L 234.6 117.6 L 237.1 117 L 239.5 116.3 L 242 116.3 L 243.9 114.6 L 245.6 112.8 L 247.3 110.9 L 249.2 109.3 L 251.6 109.2 L 254 108.5 L 256.3 107.8 L 258.6 107 L 261 107.4 L 263.4 107.5 L 265.9 107.4 L 268.3 107.3 L 270.7 107.3 L 273.2 107.3 L 275.6 107.3 L 278 106.9 L 279 106.8 L 280.5 106.8 L 282.8 107.7 L 285.3 108.1 L 287.7 108.1 L 289.9 109.2 L 292.2 110.1 L 294.4 111.2 L 296.7 112.3 L 298.3 114.2 L 300.3 115.7 L 302.2 117.2 L 304.3 118.6 L 306.3 119.7 L 308.2 121 L 310.1 122.4 L 311.4 124.4 L 313.5 125.4 L 315.5 126.5 L 317.3 128 L 319.1 129.4 L 321.3 130.7 L 323.4 132.1 L 326 132.4 L 328.5 132.7 L 331 133.1 L 333.2 134.4 L 335.7 134.6 L 338 135.8 L 338.3 138.3 L 338.9 140.8 L 340 143.2 L 340.3 145.8 L 340.8 148.3 L 341.5 150.7 L 342 153.2 L 342.7 155.7 L 343.8 157.6 L 345.3 159.3 L 346.1 161.4 L 346.8 163.5 L 348.2 165.2 L 349.2 167.2 L 350.4 169 L 351.2 171.1 L 353 172.9 L 354.4 175 L 355.9 177 L 357.7 178.8 L 359.4 180.6 L 361.1 182.5 L 363.2 184 L 364.4 186.3 L 365.2 188.8 L 365.7 191.3 L 366.9 193.6 L 368.4 195.7 L 369.2 198.2 L 370.1 200.6 L 371.1 202.9 L 371.8 205.4 L 371.6 208.2 L 372 211.1 L 373 213.7 L 374.4 216.2 L 375 218.9 L 375.7 221.6 L 375.8 222.5 L 376 224.3 L 376.7 227 L 375.1 229.3 L 373.3 231.3 L 372.1 233.7 L 371 236.2 L 370.2 238.9 L 368.8 241.3 L 368 243.8 L 367.4 246.5 L 366.4 249 L 365.5 251.6 L 365.3 254.3 L 364.8 257 L 363.3 259.3 L 361.5 261.3 L 360.6 263.9 L 359.7 266.5 L 358.4 268.9 L 356.7 271 L 354.7 272.8 L 352.8 274.8 L 351.1 276.8 L 349.3 278.9 L 347.3 280.8 L 346.2 283.3 L 343.6 284.3 L 340.9 284.9 L 338.1 285.4 L 335.8 287 L 333.5 288.6 L 330.8 289.4 L 328.4 290.6 L 325.7 291.4 L 323.6 293 L 320.9 293.1 L 318.8 294.5 L 316.6 295.6 L 314.2 296.6 L 311.9 297.5 L 309.5 298.3 L 307.1 299.1 L 305 300.7 L 302.8 302.1 L 300.5 303.3 L 298.3 304.7 L 295.6 305.2 L 292.9 305.7 L 290.9 307.5 L 289 309.5 L 286.2 309.3 L 283.5 308.7 L 281.2 307.2 L 278.7 306 L 276.1 305.3 L 273.4 304.7 L 270.9 303.5 L 268.3 302.7 L 265.9 302.7 L 263.5 302.7 L 261 302.8 L 258.7 302.4 L 256.2 302.3 L 255.2 302.2 L 253.8 302 L 251.3 302 L 249 302.7 L 247.4 300.2 L 245.5 298.1 L 244.2 295.5 L 242.9 292.9 L 241.6 290.3 L 240 287.8 L 238.1 285.6 L 236 283.6 L 234.2 282.6 L 232.2 281.8 L 230.3 280.9 L 228.3 280.5 L 226.4 279.5 L 224.4 278.8 L 222.9 277.3 L 221.2 276 L 219.7 274.6 L 218.3 273 L 216.6 271.7 L 215.1 270.2 L 213.6 268.7 L 212.1 267.2 L 210.2 266.2 L 208.2 265.5 L 206.1 264.6 L 204.1 263.6 L 202.5 262 L 200.9 260.4 L 198.9 259.4 L 197.2 258 L 195.2 257 L 193.5 255.5 L 191.7 253.9 L 189.9 252.3 L 188.1 250.6 L 186.2 249.1 L 184.2 247.7 L 182.7 245.8 L 181 244 L 179.2 242.4 L 176.7 240.3 L 173.9 238.7 L 171 237.2 L 168 236 L 165.3 234.1 L 163 231.8 L 160.4 229.9 L 158.4 227.3 L 157.4 224.3 L 156.4 221.4 L 154.9 218.6 L 153.7 215.7 L 151.6 213.4 L 150 210.7 L 148 208.2 Z",
      "territoryIds": [
        "ashmoor-keep",
        "ashmoor-landing",
        "ashmoor-cliffs",
        "ashmoor-shoals"
      ],
      "color": "#1A237E"
    }
  ],
  "territories": [
    {
      "id": "ironhold-gate",
      "name": "Ironhold Gate",
      "regionId": "gate-ironhold",
      "adjacencies": [
        "ashmoor-gate",
        "ashmoor-terrace",
        "gull-rock",
        "ironhold-terrace",
        "saltmarch-gate",
        "tern-islet"
      ],
      "borderDice": {
        "gull-rock": {
          "attack": 5
        },
        "tern-islet": {
          "attack": 5
        }
      },
      "shape": "M 501 303.1 L 501.1 303.1 L 504.5 300.4 L 508.5 298.7 L 512.4 296.9 L 516.2 295.1 L 519.8 292.3 L 523.9 290.2 L 528.3 291.5 L 532.9 292 L 537.1 290.7 L 541.4 291.4 L 545.7 292.7 L 549.9 291 L 553.8 288.9 L 557.7 286.8 L 561.7 285 L 566 283.6 L 570.4 282.5 L 574 279.7 L 578.3 278.7 L 582.7 277.8 L 586.7 279.7 L 590.7 281.7 L 595.7 280.8 L 599.3 284.4 L 603.8 284.4 L 608.1 285.7 L 612.9 285.5 L 616.7 288.3 L 621.3 288 L 625.6 289.5 L 629.9 288.3 L 634.2 287.1 L 637.9 290 L 642.6 290.2 L 646.3 292.9 L 649.2 296.3 L 653.2 297.5 L 657.3 298.3 L 661.1 300.1 L 664.8 302 L 667.7 305.2 L 670.8 308.2 L 675 309.6 L 679.3 310 L 683.1 311.5 L 686.9 313.1 L 690.1 315.6 L 693.4 318 L 693.5 318.1 L 679.8 355.6 L 557.8 392.3 L 520.2 355.7 Z",
      "position": {
        "x": 593.2,
        "y": 331.5
      },
      "badgeAnchor": {
        "x": 576.2,
        "y": 333.26
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "saltmarch-gate",
      "name": "Saltmarch Gate",
      "regionId": "gate-saltmarch",
      "adjacencies": [
        "greywatch-gate",
        "gull-rock",
        "ironhold-gate",
        "ironhold-terrace",
        "saltmarch-terrace",
        "seal-skerry"
      ],
      "borderDice": {
        "gull-rock": {
          "attack": 5
        },
        "seal-skerry": {
          "attack": 5
        }
      },
      "shape": "M 679.8 355.6 L 693.5 318.1 L 697.1 319.9 L 700.9 321.4 L 704.3 323.8 L 706.9 327.1 L 712.5 325.8 L 718.1 324.7 L 724 324.8 L 729.2 322.2 L 734.9 321.1 L 740.1 318.6 L 744.6 314.6 L 750.6 314.1 L 754.8 315.7 L 758.2 318.5 L 761.7 321.2 L 765.9 322.8 L 770 324.4 L 774.1 326.3 L 777.2 329.5 L 780.5 332.5 L 785 334 L 788.6 337.2 L 791.9 340.6 L 795.9 343.1 L 800 345.4 L 804.7 346.5 L 809.6 345.9 L 813.9 348.3 L 812.5 353.9 L 812.2 359.6 L 811.5 365.4 L 813.1 371 L 813.1 376.7 L 814.5 382.2 L 815 387.9 L 816.4 393.4 L 819.4 397.1 L 819.8 401.8 L 822.7 405.4 L 824 409.8 L 823 414.3 L 823.3 418.8 L 822.6 423.4 L 823.6 427.9 L 825.2 431.9 L 828.4 434.8 L 832.3 436.7 L 834.9 439.4 L 802.2 458.3 L 685.1 408 Z",
      "position": {
        "x": 754.3,
        "y": 383.6
      },
      "badgeAnchor": {
        "x": 745.23,
        "y": 374.93
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "greywatch-gate",
      "name": "Greywatch Gate",
      "regionId": "gate-greywatch",
      "adjacencies": [
        "driftstone",
        "emberrock-gate",
        "greywatch-terrace",
        "saltmarch-gate",
        "saltmarch-terrace",
        "seal-skerry"
      ],
      "borderDice": {
        "driftstone": {
          "attack": 5
        },
        "seal-skerry": {
          "attack": 5
        }
      },
      "shape": "M 772.6 501.7 L 802.2 458.3 L 834.9 439.4 L 835.3 439.7 L 838.7 442.2 L 842.2 444.4 L 844.7 447.8 L 848 450.5 L 850.5 454.2 L 853.3 457.6 L 852.6 462 L 852.5 466.4 L 855.9 469.1 L 859.4 471.5 L 860.5 475.7 L 862.9 479.3 L 865.9 483.1 L 869.9 486 L 870.5 491.1 L 874 494.9 L 877.6 497.9 L 881.5 500.7 L 885.3 503.6 L 889.1 506.5 L 888.3 510.9 L 886.5 515 L 886.3 519.4 L 886.7 523.9 L 888.9 527.8 L 890.1 532.2 L 890.9 536.6 L 890.1 541.1 L 888.7 545.8 L 885.1 549 L 882.6 552.9 L 879.7 556.6 L 879.8 561.3 L 878.7 565.9 L 877.4 570.4 L 876.8 575 L 877.6 579.6 L 877.5 584.2 L 879.3 588.4 L 880.2 593 L 883 596.8 L 883.9 601.4 L 885.7 605.8 L 889.4 608.8 L 886.5 612.1 L 883.5 615.4 L 881.6 619.4 L 880.5 623.7 L 880.4 624.4 L 829.9 615.5 Z",
      "position": {
        "x": 837.4,
        "y": 531.7
      },
      "badgeAnchor": {
        "x": 837.3,
        "y": 523.23
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "emberrock-gate",
      "name": "Emberrock Gate",
      "regionId": "gate-emberrock",
      "adjacencies": [
        "driftstone",
        "emberrock-terrace",
        "greywatch-gate",
        "greywatch-terrace",
        "thornvale-gate",
        "wreckers-reef"
      ],
      "borderDice": {
        "driftstone": {
          "attack": 5
        },
        "wreckers-reef": {
          "attack": 5
        }
      },
      "shape": "M 750 753.8 L 779.3 629.8 L 829.9 615.5 L 880.4 624.4 L 879.7 628 L 877.7 631.9 L 875.9 636 L 876 640.4 L 875.8 645 L 875.2 649.6 L 877.2 653.8 L 878.2 658.3 L 878.9 663.1 L 876.8 667.4 L 878.5 671.7 L 878.6 676.4 L 876.6 680.5 L 872.9 683.3 L 869.5 686.2 L 866 688.9 L 862.8 692.3 L 861 696.5 L 860.9 701.1 L 860 705.6 L 857.6 709.2 L 855.7 713.1 L 853.9 717.1 L 852.2 721.1 L 849.9 724.9 L 846.1 727.4 L 842.5 729.8 L 838.6 731.9 L 836.6 735.8 L 836.1 740.1 L 834 743.9 L 832.6 747.9 L 830.3 751.6 L 827.2 754.7 L 824.5 758.1 L 823.1 762.2 L 818.1 762.4 L 813.2 763.6 L 808.3 763 L 803.3 762.7 L 798.6 764.2 L 794.1 766.5 L 790 769.2 L 785.8 771.9 L 781.6 774.5 L 778.3 778.2 L 778.6 783.1 L 778.5 787.8 Z",
      "position": {
        "x": 813.2,
        "y": 690.9
      },
      "badgeAnchor": {
        "x": 817.24,
        "y": 677.42
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "thornvale-gate",
      "name": "Thornvale Gate",
      "regionId": "gate-thornvale",
      "adjacencies": [
        "emberrock-gate",
        "emberrock-terrace",
        "kelp-holm",
        "mistfell-gate",
        "thornvale-terrace",
        "wreckers-reef"
      ],
      "borderDice": {
        "kelp-holm": {
          "attack": 5
        },
        "wreckers-reef": {
          "attack": 5
        }
      },
      "shape": "M 600 808.3 L 702.1 732.2 L 750 753.8 L 778.5 787.8 L 778.5 788 L 776 791.7 L 773.8 795.5 L 771.8 799.5 L 770.2 803.6 L 766 804.4 L 762.3 806.6 L 758.3 808.2 L 754.9 810.8 L 750.7 811.8 L 746.5 812.1 L 742.4 813.2 L 738.4 814.7 L 736.3 819.3 L 733.7 823.7 L 729.8 826.9 L 725.7 829.8 L 724.4 834.7 L 721.2 838.6 L 720.1 843.5 L 717.7 847.9 L 714.7 851.3 L 711.3 854.2 L 707.1 855.8 L 702.9 857.5 L 698.5 858.2 L 694.3 859.9 L 690.3 861.8 L 686.7 864.5 L 681.3 864.7 L 675.8 864.6 L 672.6 860.1 L 667.9 857.1 L 663.2 855.2 L 658.1 854.6 L 653.6 852.1 L 648.7 850.9 L 644.6 851.5 L 640.7 852.7 L 636.6 851.9 L 632.4 852.7 L 628.4 852 L 624.3 851.9 L 620.2 851.4 L 616.1 852.1 L 611.1 852.5 L 606.9 855.1 L 602.1 855.5 L 600 855.5 Z",
      "position": {
        "x": 686,
        "y": 802.4
      },
      "badgeAnchor": {
        "x": 680.88,
        "y": 808.8
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mistfell-gate",
      "name": "Mistfell Gate",
      "regionId": "gate-mistfell",
      "adjacencies": [
        "fog-isle",
        "goldcrest-gate",
        "kelp-holm",
        "mistfell-terrace",
        "thornvale-gate",
        "thornvale-terrace"
      ],
      "borderDice": {
        "fog-isle": {
          "attack": 5
        },
        "kelp-holm": {
          "attack": 5
        }
      },
      "shape": "M 422.6 786.5 L 449.9 753.9 L 577.1 761 L 600 808.3 L 600 855.5 L 597.2 855.5 L 593 857.9 L 588.8 860.6 L 586 864.6 L 582.9 868.3 L 579.2 871.3 L 574.6 872.5 L 570 871.8 L 565.4 871.1 L 561.9 868.2 L 557.7 866.6 L 553.5 864.8 L 549 864.3 L 545.2 861.9 L 541.1 860.3 L 536.7 859.9 L 532.4 858.9 L 528.1 857.4 L 523.6 857.7 L 519.4 859.4 L 514.9 859.3 L 510.9 857.6 L 506.9 855.9 L 502.7 855.1 L 498.5 853.8 L 494.6 852 L 490.5 850.6 L 486.3 849.5 L 482.5 847.5 L 479.2 844.3 L 477.3 840.1 L 474.2 836.9 L 470.7 834 L 466.4 832.5 L 462.8 829.7 L 458.4 828.6 L 453.9 828.1 L 451.4 824.5 L 448.2 821.5 L 444.7 818.9 L 441.2 816.4 L 438.3 813.1 L 436.5 809.1 L 433.5 805.9 L 430.3 803 L 427.5 799.4 L 426.1 795 L 423.7 791.1 L 422.7 786.6 Z",
      "position": {
        "x": 520.4,
        "y": 807.1
      },
      "badgeAnchor": {
        "x": 519.62,
        "y": 807.64
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "goldcrest-gate",
      "name": "Goldcrest Gate",
      "regionId": "gate-goldcrest",
      "adjacencies": [
        "fog-isle",
        "gannet-rock",
        "goldcrest-terrace",
        "mistfell-gate",
        "mistfell-terrace",
        "stormreach-gate"
      ],
      "borderDice": {
        "fog-isle": {
          "attack": 5
        },
        "gannet-rock": {
          "attack": 5
        }
      },
      "shape": "M 320.4 624.3 L 370.1 615.5 L 462.9 702.9 L 449.9 753.9 L 422.6 786.5 L 421.4 782.1 L 418.3 778.6 L 417.7 774.1 L 416.3 769.7 L 411.6 768.4 L 408.3 764.8 L 404.2 762.7 L 399.7 761.2 L 395 760.8 L 390.3 761.2 L 385.6 760.6 L 381.3 758.5 L 378.9 754.8 L 375.3 752.2 L 372.1 749.3 L 369 746.2 L 365.7 743.3 L 361.9 741.1 L 359 737.7 L 354.7 736.3 L 349.8 735.7 L 345.3 733.4 L 342.4 729.5 L 339.4 725.6 L 335.5 722.9 L 331.6 720.2 L 329.1 716.2 L 326.1 712.5 L 326.8 707.6 L 327.5 702.7 L 328.4 697.8 L 329.3 693 L 328.3 688 L 327.9 683 L 328.3 677.9 L 330.3 673.2 L 327.7 669.6 L 327.6 665.2 L 326.9 661 L 324.7 657.3 L 324.9 653.1 L 324.4 648.9 L 323.4 644.8 L 323.2 640.6 L 323 636.4 L 322 632.4 L 320.8 628.4 Z",
      "position": {
        "x": 388.1,
        "y": 696.4
      },
      "badgeAnchor": {
        "x": 380.52,
        "y": 692.98
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "stormreach-gate",
      "name": "Stormreach Gate",
      "regionId": "gate-stormreach",
      "adjacencies": [
        "ashmoor-gate",
        "brine-skerry",
        "gannet-rock",
        "goldcrest-gate",
        "goldcrest-terrace",
        "stormreach-terrace"
      ],
      "borderDice": {
        "brine-skerry": {
          "attack": 5
        },
        "gannet-rock": {
          "attack": 5
        }
      },
      "shape": "M 304.9 540.5 L 305.5 536.2 L 306.1 531.8 L 305.7 527.4 L 305.5 523.1 L 307.4 518.9 L 310.6 515.6 L 311.7 511.1 L 311 506.5 L 311.4 502 L 311.8 497.4 L 313.8 493.3 L 315.1 488.9 L 315.1 484.4 L 314.6 479.9 L 313.9 475.4 L 314 470.9 L 319.7 467.9 L 326.1 467.6 L 332 465.5 L 338.3 464.6 L 343.1 460.2 L 349.5 458.9 L 354.9 455.2 L 361.5 455.2 L 363.7 451.6 L 364.9 447.5 L 365.8 443.4 L 366.4 440.1 L 397.9 458.3 L 412.8 584.8 L 370.1 615.5 L 320.4 624.3 L 320.4 624.2 L 320.5 620.1 L 320.8 615.9 L 320.5 611.8 L 320.8 607.6 L 320.3 603.4 L 318.6 599.5 L 319.8 595.4 L 320 591.1 L 319.1 586.8 L 320.2 582.6 L 317.5 579.2 L 316.5 575 L 315.3 570.6 L 313.5 566.4 L 312.1 562 L 309.8 558 L 310 553.3 L 309.9 548.5 L 308.5 543.9 Z",
      "position": {
        "x": 358.9,
        "y": 535.5
      },
      "badgeAnchor": {
        "x": 357.16,
        "y": 535.08
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ashmoor-gate",
      "name": "Ashmoor Gate",
      "regionId": "gate-ashmoor",
      "adjacencies": [
        "ashmoor-terrace",
        "brine-skerry",
        "ironhold-gate",
        "stormreach-gate",
        "stormreach-terrace",
        "tern-islet"
      ],
      "borderDice": {
        "brine-skerry": {
          "attack": 5
        },
        "tern-islet": {
          "attack": 5
        }
      },
      "shape": "M 366.2 435 L 366.4 430.8 L 367.5 426.7 L 368.2 422.5 L 369.4 418.5 L 370.6 414.6 L 373.2 411.3 L 374.7 407.3 L 377.1 404 L 379.3 400.5 L 382 397.4 L 383.8 393.6 L 385.5 389.5 L 388.5 386.2 L 389.9 382.1 L 391.6 378 L 392.9 373.8 L 395.9 370.5 L 397.9 366.5 L 399.5 362.5 L 401.5 357.9 L 406.2 355.9 L 407.8 351.5 L 409.4 347.1 L 411.3 342.9 L 413.2 338.8 L 415.5 334.7 L 418.7 331.4 L 423.5 331.3 L 427.3 328.4 L 431.7 327 L 435 323.6 L 439.2 322.1 L 443.6 321 L 447.9 319.1 L 452.5 319.5 L 456.9 319.1 L 461.3 319.2 L 465.1 316.8 L 469.6 316.2 L 474 315.8 L 478.1 314.2 L 482.3 313.2 L 486.4 311.7 L 490 309.4 L 494.1 307.9 L 497.9 305.9 L 501 303.1 L 520.2 355.7 L 450.3 462.2 L 397.9 458.3 L 366.4 440.1 L 366.6 439.2 Z",
      "position": {
        "x": 443.6,
        "y": 386.9
      },
      "badgeAnchor": {
        "x": 450.42,
        "y": 375.19
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ironhold-terrace",
      "name": "Ironhold Terrace",
      "regionId": "run-ironhold",
      "adjacencies": [
        "ashmoor-pit",
        "ashmoor-terrace",
        "ironhold-gate",
        "ironhold-pit",
        "saltmarch-gate",
        "saltmarch-terrace"
      ],
      "shape": "M 557.8 392.3 L 679.8 355.6 L 685.1 408 L 669 439.6 L 583.9 443.9 L 565.8 426.9 Z",
      "position": {
        "x": 627.1,
        "y": 405.3
      },
      "badgeAnchor": {
        "x": 643.33,
        "y": 403.89
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ironhold-pit",
      "name": "Ironhold Pit",
      "regionId": "run-ironhold",
      "adjacencies": [
        "ashmoor-pit",
        "ironhold-terrace",
        "saltmarch-pit",
        "saltmarch-terrace",
        "throne-sand"
      ],
      "borderDice": {
        "throne-sand": {
          "attack": 8
        }
      },
      "shape": "M 583.9 443.9 L 669 439.6 L 672 464.2 L 630.2 528.6 L 593.2 520.1 Z",
      "position": {
        "x": 624.8,
        "y": 477.9
      },
      "badgeAnchor": {
        "x": 623.82,
        "y": 477.15
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "saltmarch-terrace",
      "name": "Saltmarch Terrace",
      "regionId": "run-saltmarch",
      "adjacencies": [
        "greywatch-gate",
        "greywatch-terrace",
        "ironhold-pit",
        "ironhold-terrace",
        "saltmarch-gate",
        "saltmarch-pit"
      ],
      "shape": "M 669 439.6 L 685.1 408 L 802.2 458.3 L 772.6 501.7 L 739.9 515.6 L 672 464.2 Z",
      "position": {
        "x": 729.9,
        "y": 462.5
      },
      "badgeAnchor": {
        "x": 746.01,
        "y": 473.57
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "saltmarch-pit",
      "name": "Saltmarch Pit",
      "regionId": "run-saltmarch",
      "adjacencies": [
        "greywatch-pit",
        "greywatch-terrace",
        "ironhold-pit",
        "saltmarch-terrace",
        "throne-sand"
      ],
      "borderDice": {
        "throne-sand": {
          "attack": 8
        }
      },
      "shape": "M 630.2 528.6 L 672 464.2 L 739.9 515.6 L 726.4 536.3 L 652.9 558.8 Z",
      "position": {
        "x": 681.4,
        "y": 516.5
      },
      "badgeAnchor": {
        "x": 679.91,
        "y": 512.98
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "greywatch-terrace",
      "name": "Greywatch Terrace",
      "regionId": "run-greywatch",
      "adjacencies": [
        "emberrock-gate",
        "emberrock-terrace",
        "greywatch-gate",
        "greywatch-pit",
        "saltmarch-pit",
        "saltmarch-terrace"
      ],
      "shape": "M 726.4 536.3 L 739.9 515.6 L 772.6 501.7 L 829.9 615.5 L 779.3 629.8 L 745.3 619.4 Z",
      "position": {
        "x": 771.9,
        "y": 572.3
      },
      "badgeAnchor": {
        "x": 776.53,
        "y": 591.77
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "greywatch-pit",
      "name": "Greywatch Pit",
      "regionId": "run-greywatch",
      "adjacencies": [
        "emberrock-pit",
        "emberrock-terrace",
        "greywatch-terrace",
        "saltmarch-pit",
        "throne-sand"
      ],
      "borderDice": {
        "throne-sand": {
          "attack": 8
        }
      },
      "shape": "M 651 596.6 L 652.9 558.8 L 726.4 536.3 L 745.3 619.4 L 721.7 626.6 Z",
      "position": {
        "x": 700,
        "y": 582.5
      },
      "badgeAnchor": {
        "x": 699.62,
        "y": 580.04
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "emberrock-terrace",
      "name": "Emberrock Terrace",
      "regionId": "run-emberrock",
      "adjacencies": [
        "emberrock-gate",
        "emberrock-pit",
        "greywatch-pit",
        "greywatch-terrace",
        "thornvale-gate",
        "thornvale-terrace"
      ],
      "shape": "M 682.8 702.4 L 721.7 626.6 L 745.3 619.4 L 779.3 629.8 L 750 753.8 L 702.1 732.2 Z",
      "position": {
        "x": 733.4,
        "y": 683.3
      },
      "badgeAnchor": {
        "x": 726.53,
        "y": 697.1
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "emberrock-pit",
      "name": "Emberrock Pit",
      "regionId": "run-emberrock",
      "adjacencies": [
        "emberrock-terrace",
        "greywatch-pit",
        "thornvale-pit",
        "thornvale-terrace",
        "throne-sand"
      ],
      "borderDice": {
        "throne-sand": {
          "attack": 8
        }
      },
      "shape": "M 625.2 624.3 L 651 596.6 L 721.7 626.6 L 682.8 702.4 L 660 692.7 Z",
      "position": {
        "x": 671.8,
        "y": 645
      },
      "badgeAnchor": {
        "x": 674.96,
        "y": 644.54
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "thornvale-terrace",
      "name": "Thornvale Terrace",
      "regionId": "run-thornvale",
      "adjacencies": [
        "emberrock-pit",
        "emberrock-terrace",
        "mistfell-gate",
        "mistfell-terrace",
        "thornvale-gate",
        "thornvale-pit"
      ],
      "shape": "M 577.1 761 L 581.4 725.8 L 660 692.7 L 682.8 702.4 L 702.1 732.2 L 600 808.3 Z",
      "position": {
        "x": 632.5,
        "y": 743.7
      },
      "badgeAnchor": {
        "x": 614.21,
        "y": 752.31
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "thornvale-pit",
      "name": "Thornvale Pit",
      "regionId": "run-thornvale",
      "adjacencies": [
        "emberrock-pit",
        "mistfell-pit",
        "mistfell-terrace",
        "thornvale-terrace",
        "throne-sand"
      ],
      "borderDice": {
        "throne-sand": {
          "attack": 8
        }
      },
      "shape": "M 570.3 703.8 L 587.6 628.9 L 625.2 624.3 L 660 692.7 L 581.4 725.8 Z",
      "position": {
        "x": 610,
        "y": 674.7
      },
      "badgeAnchor": {
        "x": 610.95,
        "y": 676.64
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mistfell-terrace",
      "name": "Mistfell Terrace",
      "regionId": "run-mistfell",
      "adjacencies": [
        "goldcrest-gate",
        "goldcrest-terrace",
        "mistfell-gate",
        "mistfell-pit",
        "thornvale-pit",
        "thornvale-terrace"
      ],
      "shape": "M 449.9 753.9 L 462.9 702.9 L 488.9 678.6 L 570.3 703.8 L 581.4 725.8 L 577.1 761 Z",
      "position": {
        "x": 516.4,
        "y": 725.2
      },
      "badgeAnchor": {
        "x": 505.38,
        "y": 721.09
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mistfell-pit",
      "name": "Mistfell Pit",
      "regionId": "run-mistfell",
      "adjacencies": [
        "goldcrest-pit",
        "goldcrest-terrace",
        "mistfell-terrace",
        "thornvale-pit",
        "throne-sand"
      ],
      "borderDice": {
        "throne-sand": {
          "attack": 8
        }
      },
      "shape": "M 488.9 678.6 L 494.5 654.5 L 555.8 608.3 L 587.6 628.9 L 570.3 703.8 Z",
      "position": {
        "x": 543.6,
        "y": 657.8
      },
      "badgeAnchor": {
        "x": 545.96,
        "y": 660.53
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "goldcrest-terrace",
      "name": "Goldcrest Terrace",
      "regionId": "run-goldcrest",
      "adjacencies": [
        "goldcrest-gate",
        "goldcrest-pit",
        "mistfell-pit",
        "mistfell-terrace",
        "stormreach-gate",
        "stormreach-terrace"
      ],
      "shape": "M 370.1 615.5 L 412.8 584.8 L 448.2 583 L 494.5 654.5 L 488.9 678.6 L 462.9 702.9 Z",
      "position": {
        "x": 439.5,
        "y": 636.4
      },
      "badgeAnchor": {
        "x": 430.36,
        "y": 622.34
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "goldcrest-pit",
      "name": "Goldcrest Pit",
      "regionId": "run-goldcrest",
      "adjacencies": [
        "goldcrest-terrace",
        "mistfell-pit",
        "stormreach-pit",
        "stormreach-terrace",
        "throne-sand"
      ],
      "borderDice": {
        "throne-sand": {
          "attack": 8
        }
      },
      "shape": "M 448.2 583 L 468.1 568.1 L 544.7 572.2 L 555.8 608.3 L 494.5 654.5 Z",
      "position": {
        "x": 503.4,
        "y": 602.1
      },
      "badgeAnchor": {
        "x": 503.68,
        "y": 604.55
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "stormreach-terrace",
      "name": "Stormreach Terrace",
      "regionId": "run-stormreach",
      "adjacencies": [
        "ashmoor-gate",
        "ashmoor-terrace",
        "goldcrest-pit",
        "goldcrest-terrace",
        "stormreach-gate",
        "stormreach-pit"
      ],
      "shape": "M 397.9 458.3 L 450.3 462.2 L 478.7 483.6 L 468.1 568.1 L 448.2 583 L 412.8 584.8 Z",
      "position": {
        "x": 437.6,
        "y": 518.9
      },
      "badgeAnchor": {
        "x": 439.56,
        "y": 499.81
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "stormreach-pit",
      "name": "Stormreach Pit",
      "regionId": "run-stormreach",
      "adjacencies": [
        "ashmoor-pit",
        "ashmoor-terrace",
        "goldcrest-pit",
        "stormreach-terrace",
        "throne-sand"
      ],
      "borderDice": {
        "throne-sand": {
          "attack": 8
        }
      },
      "shape": "M 468.1 568.1 L 478.7 483.6 L 503.4 484.9 L 559.6 537.2 L 544.7 572.2 Z",
      "position": {
        "x": 508.7,
        "y": 533.8
      },
      "badgeAnchor": {
        "x": 506.7,
        "y": 534.82
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ashmoor-terrace",
      "name": "Ashmoor Terrace",
      "regionId": "run-ashmoor",
      "adjacencies": [
        "ashmoor-gate",
        "ashmoor-pit",
        "ironhold-gate",
        "ironhold-terrace",
        "stormreach-pit",
        "stormreach-terrace"
      ],
      "shape": "M 450.3 462.2 L 520.2 355.7 L 557.8 392.3 L 565.8 426.9 L 503.4 484.9 L 478.7 483.6 Z",
      "position": {
        "x": 511.7,
        "y": 427.6
      },
      "badgeAnchor": {
        "x": 524.29,
        "y": 414.24
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ashmoor-pit",
      "name": "Ashmoor Pit",
      "regionId": "run-ashmoor",
      "adjacencies": [
        "ashmoor-terrace",
        "ironhold-pit",
        "ironhold-terrace",
        "stormreach-pit",
        "throne-sand"
      ],
      "borderDice": {
        "throne-sand": {
          "attack": 8
        }
      },
      "shape": "M 503.4 484.9 L 565.8 426.9 L 583.9 443.9 L 593.2 520.1 L 559.6 537.2 Z",
      "position": {
        "x": 556.5,
        "y": 484.6
      },
      "badgeAnchor": {
        "x": 555.32,
        "y": 487.22
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "throne-sand",
      "name": "Throne Sand",
      "regionId": "the-sand",
      "adjacencies": [
        "ashmoor-pit",
        "emberrock-pit",
        "goldcrest-pit",
        "greywatch-pit",
        "ironhold-pit",
        "mistfell-pit",
        "saltmarch-pit",
        "stormreach-pit",
        "thornvale-pit"
      ],
      "shape": "M 544.7 572.2 L 559.6 537.2 L 593.2 520.1 L 630.2 528.6 L 652.9 558.8 L 651 596.6 L 625.2 624.3 L 587.6 628.9 L 555.8 608.3 Z",
      "position": {
        "x": 600,
        "y": 575
      },
      "badgeAnchor": {
        "x": 600.49,
        "y": 576.2
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ironhold-keep",
      "name": "Ironhold Keep",
      "regionId": "ironhold",
      "adjacencies": [
        "ironhold-cliffs",
        "ironhold-landing",
        "ironhold-shoals"
      ],
      "shape": "M 503.2 30.8 L 504.2 29.7 L 506.1 27.5 L 508.2 25.6 L 511.3 25.5 L 514.4 26.3 L 517.5 25.5 L 520.6 26.3 L 523.6 27.2 L 526.8 27.2 L 529.9 27.6 L 533 27.3 L 535.6 26.7 L 538.2 26.5 L 540.8 26.9 L 543.3 27.9 L 545.8 28.5 L 548.4 28.9 L 551 28.8 L 553.5 29.6 L 555.8 29.4 L 558 28.9 L 560.2 28.8 L 562.5 28.6 L 564.7 29.1 L 566.9 29.7 L 569.2 29.4 L 571.5 29 L 573.7 29.4 L 576 29.4 L 578.2 29.4 L 580.5 29.2 L 582.7 29.2 L 584.9 29.8 L 587.1 30.4 L 589.4 30.2 L 592.2 27.7 L 595.6 26.1 L 599.2 25.3 L 602.3 23.1 L 605.6 21.3 L 608.2 18.6 L 611.5 16.9 L 614.9 15.4 L 618 16.1 L 620.9 17.3 L 624.1 17.3 L 627.2 17.7 L 630.3 18.6 L 633.4 18.5 L 636.6 18.3 L 639.7 18.2 L 641.4 20.7 L 643 23.3 L 645 25.6 L 647.2 27.6 L 649.8 29.3 L 652 31.5 L 653.3 34.2 L 655 36.8 L 656 39.2 L 586.9 122.6 L 556.7 122 Z",
      "position": {
        "x": 580,
        "y": 62.8
      },
      "badgeAnchor": {
        "x": 577.21,
        "y": 70.68
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ironhold-landing",
      "name": "Ironhold Landing",
      "regionId": "ironhold",
      "adjacencies": [
        "ironhold-cliffs",
        "ironhold-keep",
        "ironhold-shoals"
      ],
      "oneWayBorders": [
        "ironhold-gate"
      ],
      "shape": "M 492.8 190.8 L 556.7 122 L 586.9 122.6 L 636.9 193.8 L 635.6 194.9 L 634 196.8 L 632.5 198.8 L 630.8 200.6 L 629.2 202.5 L 627.8 204.6 L 625.6 205.9 L 623.4 207 L 621 207.8 L 618.5 208.1 L 616.6 209.8 L 614.2 210.6 L 612.1 211.8 L 609.7 212.6 L 607.7 214.3 L 605.5 215.7 L 602.8 215.9 L 600.3 215.2 L 597.8 215.2 L 595.4 215.6 L 592.9 215.6 L 590.5 215.6 L 588.3 217.4 L 586.3 219.4 L 583.8 220.8 L 581.5 222.4 L 579.1 224.1 L 577 226 L 574.4 227.2 L 571.5 227.6 L 568.8 227.4 L 566.1 227.7 L 563.4 228 L 560.8 228 L 558 227.8 L 555.4 227.4 L 552.7 228.1 L 550 228.2 L 547.1 229.5 L 543.9 229.9 L 540.8 230.3 L 537.7 231.1 L 534.6 231.1 L 531.4 231.3 L 528.3 231.3 L 525.2 232.1 L 523.4 229.6 L 522 226.8 L 519.6 224.9 L 517.6 222.6 L 515.4 220.5 L 512.9 218.6 L 510.9 216.4 L 508.9 214 L 506.9 212 L 504.6 210.3 L 502.5 208.5 L 500.8 206.2 L 499.4 203.8 L 497.6 201.6 L 496 199.2 L 495.4 196.4 L 493.9 194.1 L 493.2 191.5 Z",
      "position": {
        "x": 563.9,
        "y": 181.2
      },
      "badgeAnchor": {
        "x": 567.1,
        "y": 175.33
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ironhold-cliffs",
      "name": "Ironhold Cliffs",
      "regionId": "ironhold",
      "adjacencies": [
        "gull-rock",
        "ironhold-keep",
        "ironhold-landing"
      ],
      "borderDice": {
        "gull-rock": {
          "attack": 5
        }
      },
      "shape": "M 586.9 122.6 L 656 39.2 L 656.2 39.7 L 657.1 42.6 L 657.6 45.7 L 657.8 48.8 L 658 51.9 L 659.2 54.8 L 659.9 57.8 L 660.5 60.8 L 660.1 63.7 L 658.9 66.4 L 658.7 69.3 L 658.6 72.1 L 659.1 75 L 659.7 77.8 L 660 80.7 L 660.4 83.5 L 659.8 86.3 L 658.1 88.6 L 656.3 90.9 L 655.8 93.8 L 654.6 96.3 L 653.5 99 L 652.7 101.7 L 651.7 104.3 L 652 106.3 L 651.9 108.4 L 652.6 110.3 L 653 112.4 L 653.3 114.4 L 653.9 116.3 L 654.6 118.3 L 654.9 120.3 L 654.3 122.3 L 654.2 124.4 L 654.1 126.4 L 654.4 128.5 L 653.8 130.4 L 653.8 132.5 L 653.7 134.6 L 653.7 136.6 L 653.3 138.8 L 653.1 141 L 652.9 143.2 L 653.2 145.4 L 653.3 147.7 L 652.9 149.9 L 653.4 152.1 L 653.6 154.3 L 653 156.9 L 652.7 159.5 L 652.6 162.2 L 652.1 164.8 L 652.4 167.4 L 652.8 170 L 653.3 172.6 L 653.6 175.2 L 652 177 L 650.3 178.8 L 648.9 180.8 L 648 183.1 L 646.5 185 L 644.5 186.4 L 643 188.4 L 641.1 189.9 L 639.4 191.7 L 637.5 193.3 L 636.9 193.8 Z",
      "position": {
        "x": 631.5,
        "y": 120.4
      },
      "badgeAnchor": {
        "x": 624.85,
        "y": 123.75
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ironhold-shoals",
      "name": "Ironhold Shoals",
      "regionId": "ironhold",
      "adjacencies": [
        "ironhold-keep",
        "ironhold-landing",
        "tern-islet"
      ],
      "borderDice": {
        "tern-islet": {
          "attack": 5
        }
      },
      "shape": "M 479.4 70.9 L 480.1 67.9 L 479.7 64.8 L 479.6 61.8 L 479.5 58.8 L 481.1 56.5 L 482.9 54.3 L 484.3 51.9 L 485.2 49.3 L 486.7 46.8 L 488.5 44.7 L 489.7 42.2 L 490.8 39.6 L 492.7 37.4 L 495.4 36 L 498 34.8 L 500.9 34.4 L 502.3 31.8 L 503.2 30.8 L 556.7 122 L 492.8 190.8 L 491.6 189 L 492.1 186.2 L 491.1 183.7 L 489.8 181.3 L 488.5 179 L 487.4 176.5 L 487.7 173.5 L 488 170.4 L 487.4 167.4 L 487.7 164.4 L 489.2 161.7 L 490.1 158.8 L 490.4 155.6 L 492.3 153.1 L 493.2 151 L 493.5 148.7 L 494.8 146.7 L 495.7 144.6 L 495.4 142.3 L 495.4 140 L 495.5 137.7 L 495.8 135.4 L 494.4 131.8 L 494.1 127.9 L 493.5 124.1 L 492.6 120.3 L 492.5 116.4 L 492.7 112.5 L 493.7 108.8 L 494.3 104.9 L 492.9 102 L 491.5 99.1 L 489.8 96.3 L 487.6 93.9 L 486 91.1 L 484.7 88.1 L 482.6 85.6 L 481 82.8 L 480.6 79.8 L 480.5 76.8 L 479.8 73.8 Z",
      "position": {
        "x": 511.8,
        "y": 107.9
      },
      "badgeAnchor": {
        "x": 521.67,
        "y": 118.3
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "saltmarch-keep",
      "name": "Saltmarch Keep",
      "regionId": "saltmarch",
      "adjacencies": [
        "saltmarch-cliffs",
        "saltmarch-landing",
        "saltmarch-shoals"
      ],
      "shape": "M 923.2 154.7 L 927.6 57.3 L 928.6 57.1 L 931.3 56.9 L 933.9 56.3 L 936 58.2 L 938.5 59.4 L 941.3 59.9 L 943.7 61.4 L 946 62.9 L 948.2 64.6 L 950.6 66.2 L 953.4 66.5 L 955.9 67 L 958.3 67.6 L 960.9 67.9 L 963.4 67.7 L 965.9 67.9 L 968.4 68.2 L 970.8 69 L 973.3 69.4 L 976.2 70 L 979.1 70.2 L 981.9 71 L 984.7 71.9 L 987.6 72.1 L 990.5 71.9 L 993.3 70.8 L 996.3 71.1 L 999 72.2 L 1001.9 72.8 L 1004.8 73.7 L 1007.2 75.5 L 1009.7 77.1 L 1012 79 L 1015 79.5 L 1017.7 80.7 L 1020.6 82.6 L 1023.7 84.3 L 1026.7 86.2 L 1029.9 87.5 L 1033.3 88.6 L 1036.3 90.7 L 1039.8 91 L 1043.3 91.5 L 1042.3 94.8 L 1042.2 98.2 L 1042.2 101.7 L 1044 104.7 L 1044.4 108 L 1046.1 110.9 L 1047.3 114 L 1048.4 117.1 L 1047.3 120.7 L 1045.5 124 L 1045.3 127.9 L 1043.1 131 L 1041.5 134.4 L 1040.1 137.9 L 1037.5 140.7 L 1036.1 144.2 L 1033.5 147 L 1030 148.5 L 1029.1 152.3 L 1026.9 155.4 L 1024.6 158.2 L 948.5 173.7 Z",
      "position": {
        "x": 978.8,
        "y": 117.7
      },
      "badgeAnchor": {
        "x": 972.11,
        "y": 126.6
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "saltmarch-landing",
      "name": "Saltmarch Landing",
      "regionId": "saltmarch",
      "adjacencies": [
        "saltmarch-cliffs",
        "saltmarch-keep",
        "saltmarch-shoals"
      ],
      "oneWayBorders": [
        "saltmarch-gate"
      ],
      "shape": "M 844.3 238 L 845.3 234.4 L 846.4 230.9 L 846 227.2 L 845.5 223.6 L 845.9 220.5 L 845.7 217.4 L 846.8 214.4 L 846.8 211.3 L 846.6 208.1 L 846.6 204.8 L 848.4 202.2 L 849.9 199.3 L 849.5 197 L 849.2 194.7 L 849.4 192.4 L 849.6 190.1 L 849.7 187.8 L 850.3 185.5 L 850.4 183.2 L 851.3 181 L 851.5 178.8 L 851.8 176.7 L 851.3 174.5 L 850.6 172.4 L 849.6 170.5 L 849.5 170 L 923.2 154.7 L 948.5 173.7 L 932.3 273.6 L 930.9 273.5 L 928 274.4 L 925.5 276.1 L 922.6 277 L 919.7 278 L 916.7 277.8 L 913.8 278.6 L 911 279.4 L 907.5 279.3 L 903.9 279.2 L 900.5 280 L 896.9 280.4 L 893.5 281.2 L 890.1 282.2 L 886.8 283.6 L 883.8 285.5 L 880.6 284.7 L 877.6 283.5 L 874.5 282.6 L 871.9 280.5 L 869.3 278.6 L 866.8 276.6 L 863.9 275.1 L 861.3 273.2 L 859.6 270.4 L 858 267.6 L 855.7 265.3 L 853.4 262.9 L 851.8 260.1 L 850.1 257.4 L 848.1 254.8 L 846.1 252.3 L 845.9 248.7 L 845.7 245.1 L 845.6 241.4 Z",
      "position": {
        "x": 895.4,
        "y": 218.6
      },
      "badgeAnchor": {
        "x": 894.77,
        "y": 213.97
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "saltmarch-cliffs",
      "name": "Saltmarch Cliffs",
      "regionId": "saltmarch",
      "adjacencies": [
        "saltmarch-keep",
        "saltmarch-landing",
        "seal-skerry"
      ],
      "borderDice": {
        "seal-skerry": {
          "attack": 5
        }
      },
      "shape": "M 932.3 273.6 L 948.5 173.7 L 1024.6 158.2 L 1024.6 158.3 L 1021.4 160.1 L 1018.8 162.7 L 1015.6 164.5 L 1014.4 166.7 L 1012.5 168.3 L 1010.9 170.3 L 1009 171.9 L 1006.9 173.1 L 1005 174.7 L 1003.3 176.6 L 1001.2 177.9 L 1001 181.5 L 1001 185.1 L 1000.8 188.7 L 1000.8 192.3 L 1000.3 196 L 999.7 199.6 L 997.9 202.8 L 996.3 206.2 L 995.7 208.4 L 995.3 210.6 L 995.1 212.9 L 994.5 215.1 L 994.5 217.4 L 994.5 219.6 L 994.6 222 L 993.5 224.1 L 992 225.9 L 990.1 227.3 L 989.3 229.5 L 988 231.4 L 986.8 233.4 L 985.9 235.5 L 985.2 237.7 L 984.2 239.8 L 982.1 240.7 L 980.1 241.8 L 977.9 242.4 L 975.6 242.2 L 973.3 242.2 L 971.3 243.3 L 969 243.5 L 966.9 244.3 L 965.3 246.3 L 963.2 247.6 L 961.8 249.6 L 960 251.4 L 958.2 253 L 956.3 254.7 L 954.3 256.1 L 952.4 257.7 L 950 259.6 L 947.4 261.2 L 945.2 263.4 L 942.6 265.1 L 940.5 267.3 L 938.4 269.5 L 936.3 271.8 L 933.9 273.7 Z",
      "position": {
        "x": 969.1,
        "y": 208.7
      },
      "badgeAnchor": {
        "x": 971.24,
        "y": 196.1
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "saltmarch-shoals",
      "name": "Saltmarch Shoals",
      "regionId": "saltmarch",
      "adjacencies": [
        "gull-rock",
        "saltmarch-keep",
        "saltmarch-landing"
      ],
      "borderDice": {
        "gull-rock": {
          "attack": 5
        }
      },
      "shape": "M 847.3 164.5 L 847.5 162.4 L 847.3 160.3 L 847.3 158.1 L 847.6 156 L 848.4 154 L 848.8 151.9 L 849.3 149.8 L 849.2 147.7 L 850.5 145.8 L 851.5 143.8 L 853 142 L 854.7 140.5 L 856.5 139 L 858.2 137.5 L 860.1 136.2 L 861.8 134.7 L 862.8 132.9 L 864 131.1 L 863.6 129 L 864.2 126.9 L 864.6 125 L 865.1 123 L 865.2 121 L 865.8 119 L 867.7 118.3 L 869.6 117.3 L 871.5 116.6 L 873.3 115.5 L 874.9 114.2 L 876.6 113 L 878 111.4 L 878.8 109.4 L 880.2 107.4 L 881.2 105.3 L 881.8 103 L 882.7 100.8 L 883.3 98.5 L 883.9 96.2 L 884.7 93.9 L 885.2 91.6 L 887.1 89.4 L 888 86.6 L 889.5 84.2 L 890.7 81.6 L 892.3 79.2 L 894.1 76.8 L 894.7 74 L 895.2 71.1 L 897.3 69.2 L 899.6 67.7 L 902 66.2 L 903.9 64.1 L 905.5 61.8 L 907.8 60.2 L 910 58.4 L 912.5 57.1 L 915.2 56.7 L 917.9 56.3 L 920.6 56.5 L 923.2 57.3 L 925.9 57.5 L 927.6 57.3 L 923.2 154.7 L 849.5 170 L 849.4 168.3 L 848.7 166.2 Z",
      "position": {
        "x": 895.4,
        "y": 120.3
      },
      "badgeAnchor": {
        "x": 896.23,
        "y": 126.6
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "greywatch-keep",
      "name": "Greywatch Keep",
      "regionId": "greywatch",
      "adjacencies": [
        "greywatch-cliffs",
        "greywatch-landing",
        "greywatch-shoals"
      ],
      "shape": "M 1084.4 454.4 L 1156.6 388.7 L 1157 391.1 L 1157 394.3 L 1157.7 396.8 L 1158 399.5 L 1159.2 401.8 L 1160.1 404.3 L 1159.8 407 L 1159.8 409.7 L 1161.8 411.8 L 1162 414.6 L 1162.8 417 L 1162.9 419.6 L 1163.1 422.1 L 1163 424.6 L 1163 427.3 L 1163.6 430 L 1161.7 431.9 L 1160.8 434.5 L 1162.9 435.7 L 1165.1 436.7 L 1167 438.1 L 1168.6 439.9 L 1169 442.3 L 1169.4 444.8 L 1171.3 446.3 L 1172.7 448.4 L 1173.8 450.5 L 1174.3 452.9 L 1176.1 454.6 L 1177 456.9 L 1177.6 459.3 L 1179.4 461 L 1179.9 463.4 L 1180.5 465.7 L 1181.5 468.1 L 1182.7 470.4 L 1184.4 472.5 L 1184.9 475.1 L 1184.4 477.6 L 1184.4 480.2 L 1184.6 482.8 L 1184.7 485.4 L 1184.6 487.9 L 1184.5 490.5 L 1183.6 492.9 L 1182.7 495.3 L 1182.7 497.8 L 1181.7 500.2 L 1181.3 502.7 L 1180.7 505.1 L 1180.8 508 L 1179.4 510.5 L 1177.4 512.6 L 1176.8 515.5 L 1177.3 518.3 L 1176.1 521 L 1176.1 521 L 1089.4 483.4 Z",
      "position": {
        "x": 1139.4,
        "y": 461.8
      },
      "badgeAnchor": {
        "x": 1133.08,
        "y": 461.05
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "greywatch-landing",
      "name": "Greywatch Landing",
      "regionId": "greywatch",
      "adjacencies": [
        "greywatch-cliffs",
        "greywatch-keep",
        "greywatch-shoals"
      ],
      "oneWayBorders": [
        "greywatch-gate"
      ],
      "shape": "M 985.3 424.2 L 987.5 422.6 L 989.8 421 L 991 418.6 L 992.4 416.2 L 994.3 414.2 L 995.8 412 L 996.6 409.3 L 997.3 406.7 L 1000.5 406.7 L 1003.6 407.2 L 1005.4 406.4 L 1084.4 454.4 L 1089.4 483.4 L 1029.7 557.4 L 1028.1 556.5 L 1025.8 555.1 L 1023.1 554 L 1020.5 552.6 L 1017.6 552.1 L 1014.8 551.6 L 1011.8 550.4 L 1008.8 551 L 1006.3 549.2 L 1004 547.3 L 1002.8 544.1 L 1000.5 541.7 L 999.9 538.4 L 1000.5 535 L 1001.1 531.9 L 1001.9 528.7 L 1001.7 525.5 L 1000.9 522.3 L 999.4 520 L 997.7 518 L 996.5 515.5 L 995.7 512.9 L 996.4 510.2 L 996 507.5 L 996.2 504.8 L 997.3 502.3 L 996.2 500.2 L 995.6 497.9 L 994.8 495.7 L 994 493.5 L 993.6 491.2 L 992.5 489 L 992.3 486.7 L 991.6 484.4 L 991.6 482 L 991.5 479.6 L 991.2 477.2 L 991.6 474.8 L 991 472.5 L 990.8 470 L 989.8 467.9 L 988.7 465.7 L 986.7 463.8 L 986.2 461.1 L 986.9 458.6 L 987.6 456.1 L 988 453.7 L 988.5 451.3 L 989.1 448.9 L 989 446.5 L 988 443.8 L 987.8 441 L 987.4 438.1 L 986.1 435.5 L 985.5 432.6 L 986.5 429.8 L 985.7 427 Z",
      "position": {
        "x": 1031,
        "y": 479.2
      },
      "badgeAnchor": {
        "x": 1035.72,
        "y": 479.54
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "greywatch-cliffs",
      "name": "Greywatch Cliffs",
      "regionId": "greywatch",
      "adjacencies": [
        "driftstone",
        "greywatch-keep",
        "greywatch-landing"
      ],
      "borderDice": {
        "driftstone": {
          "attack": 5
        }
      },
      "shape": "M 1029.7 557.4 L 1089.4 483.4 L 1176.1 521 L 1176.9 523.7 L 1176.6 526.5 L 1175.2 528.8 L 1173.6 531 L 1171.1 532.4 L 1170.1 535.1 L 1167.8 536.6 L 1166.6 539.1 L 1164.8 541.2 L 1163.3 543.4 L 1160.5 543.7 L 1157.9 544.5 L 1155.4 545.6 L 1152.8 546.5 L 1150.5 548 L 1148.1 549.4 L 1145.8 551 L 1144 553.1 L 1141.5 554 L 1139.3 555.6 L 1137.1 557.2 L 1134.9 558.7 L 1132.3 559 L 1129.6 558.9 L 1127 559.6 L 1124.3 559.3 L 1121.6 559 L 1119 559.4 L 1116.4 559.9 L 1113.8 560.4 L 1111.1 560.3 L 1108.7 559.2 L 1106.1 558.5 L 1103.8 557.1 L 1101.3 557.5 L 1099.2 556.2 L 1097 555.3 L 1094.9 554.3 L 1092.6 554 L 1090.3 553.8 L 1087.9 554 L 1085.6 553.9 L 1083.5 554.8 L 1081.1 554.7 L 1078.9 554.5 L 1076.7 554 L 1074.4 553.9 L 1072.2 554.2 L 1070 554.6 L 1067.8 555.1 L 1064.8 554.7 L 1061.9 555.4 L 1059.6 557.3 L 1056.8 558.3 L 1054 559.2 L 1051.5 560.7 L 1048.6 560.8 L 1045.8 561.7 L 1043.1 561.4 L 1040.6 560.4 L 1038 560.4 L 1035.4 559.7 L 1032.9 558.6 L 1030.4 557.8 Z",
      "position": {
        "x": 1105.1,
        "y": 528.7
      },
      "badgeAnchor": {
        "x": 1101,
        "y": 523.77
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "greywatch-shoals",
      "name": "Greywatch Shoals",
      "regionId": "greywatch",
      "adjacencies": [
        "greywatch-keep",
        "greywatch-landing",
        "seal-skerry"
      ],
      "borderDice": {
        "seal-skerry": {
          "attack": 5
        }
      },
      "shape": "M 1005.4 406.4 L 1006.4 405.9 L 1009.6 405.2 L 1012.7 405 L 1015.9 404.6 L 1018.6 403.1 L 1021.3 401.4 L 1023.7 400.7 L 1026.1 400.6 L 1028.6 401 L 1031 400.6 L 1033.4 400 L 1035.8 399.6 L 1038 398.4 L 1040.4 398 L 1042.3 397.3 L 1044.2 396.4 L 1046.1 395.7 L 1048.2 395.9 L 1050.2 395.5 L 1052.3 395.4 L 1054.3 394.9 L 1056.3 394.9 L 1058.5 394.2 L 1060.5 393.2 L 1062.5 391.9 L 1063.5 389.7 L 1064.3 387.6 L 1065.9 386 L 1067.5 384.5 L 1069.1 382.9 L 1070.5 381.4 L 1071.4 379.5 L 1072.2 377.7 L 1073 375.8 L 1073.5 373.8 L 1073.9 371.8 L 1074.4 369.9 L 1075.2 368 L 1076.6 366.5 L 1078.6 365.6 L 1079.4 363.7 L 1080.9 362.3 L 1082.5 360.8 L 1082.8 358.6 L 1084.5 357.5 L 1085.6 355.7 L 1088.9 355.1 L 1092.1 354.1 L 1095.5 354.5 L 1098.9 353.7 L 1100.7 350.7 L 1103.5 348.7 L 1106.8 347.8 L 1109.5 345.5 L 1112.1 347.1 L 1114.8 348.4 L 1117.1 350.2 L 1119.9 351.4 L 1122.9 352.1 L 1125.8 352.8 L 1128.5 354 L 1131.3 355.2 L 1132.8 357.9 L 1134.2 360.7 L 1136.5 362.7 L 1138.2 365.3 L 1141 366.4 L 1143.8 367.8 L 1146.7 368.8 L 1149.5 370 L 1151.1 372.8 L 1152.7 375.6 L 1154 378.5 L 1154.7 381.7 L 1156.1 384.6 L 1156.4 387.9 L 1156.6 388.7 L 1084.4 454.4 Z",
      "position": {
        "x": 1091.6,
        "y": 399.5
      },
      "badgeAnchor": {
        "x": 1106.99,
        "y": 388.04
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "emberrock-keep",
      "name": "Emberrock Keep",
      "regionId": "emberrock",
      "adjacencies": [
        "emberrock-cliffs",
        "emberrock-landing",
        "emberrock-shoals"
      ],
      "shape": "M 1038.7 807.6 L 1050.8 783.5 L 1141.1 778.5 L 1143.1 781 L 1145.2 784 L 1148.3 786.1 L 1151.7 787.7 L 1154.9 789.5 L 1157.5 792.1 L 1159.4 795.3 L 1162.4 797.4 L 1163.4 800.7 L 1165.4 803.5 L 1166.9 806.6 L 1167.8 809.9 L 1169.4 812.9 L 1170.1 816.3 L 1171.6 819.4 L 1171.8 822.9 L 1169.7 825.4 L 1168.7 828.6 L 1167.3 831.5 L 1165.2 834 L 1163.9 837 L 1162.4 839.9 L 1159.6 841.8 L 1158.1 844.8 L 1155.3 846.4 L 1152.7 848.2 L 1149.4 848.8 L 1147.3 851.5 L 1145.5 854.2 L 1144.4 857.3 L 1142.7 860.1 L 1142.6 863.4 L 1139.3 863.4 L 1136.1 863.8 L 1133.6 866 L 1131.3 868.4 L 1128.8 870.2 L 1126.3 872 L 1123.5 873.6 L 1120.4 874 L 1117.1 873.5 L 1113.9 872.7 L 1110.6 872.9 L 1107.3 872.9 L 1104 873 L 1100.8 872.2 L 1097.5 873.1 L 1094.2 872.9 L 1091.7 873.1 L 1089.3 874 L 1086.7 874 L 1084.4 875.1 L 1082 874.3 L 1079.8 873.1 L 1077.3 872.5 L 1074.8 872.2 L 1073.5 874.1 L 1071.8 875.7 L 1070.2 876.5 Z",
      "position": {
        "x": 1104.6,
        "y": 823.7
      },
      "badgeAnchor": {
        "x": 1107.33,
        "y": 825.97
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "emberrock-landing",
      "name": "Emberrock Landing",
      "regionId": "emberrock",
      "adjacencies": [
        "emberrock-cliffs",
        "emberrock-keep",
        "emberrock-shoals"
      ],
      "oneWayBorders": [
        "emberrock-gate"
      ],
      "shape": "M 917.9 797.4 L 919 794.5 L 920.3 791.7 L 921.1 788.7 L 921.6 785.7 L 922.7 782.8 L 923.8 779.9 L 924.4 776.8 L 924.4 773.7 L 926.4 771.1 L 928.4 768.7 L 930 765.9 L 931.4 762.9 L 933.5 760.4 L 935.5 757.7 L 938.4 756.1 L 941.6 755.1 L 942.9 752.6 L 943.7 749.8 L 945.5 747.6 L 947.3 745.4 L 949.3 743.3 L 952 742.3 L 954.2 740.6 L 956.6 739.1 L 959.7 738.4 L 962.7 737.5 L 965.9 738.1 L 968.8 739.1 L 971.9 738.5 L 974.8 737.3 L 977.2 735.2 L 979.5 733.1 L 981.5 732 L 983.3 730.6 L 984.6 728.6 L 986 726.9 L 987.9 725.6 L 989.9 724.6 L 992.2 724.3 L 994.3 723.3 L 996.5 723.2 L 998.8 723.1 L 1001 723.2 L 1003.2 722.7 L 1004.9 721.1 L 1006.9 720.1 L 1008.8 718.9 L 1010.8 717.9 L 1011.9 715.8 L 1013.5 714 L 1015.8 712.9 L 1017 710.7 L 1019.3 710 L 1021.5 709 L 1021.5 709 L 1050.8 783.5 L 1038.7 807.6 L 943.6 833.2 L 942.9 832.6 L 939.7 831.2 L 937.6 828.4 L 934.5 826.9 L 931.6 825.2 L 929 822.9 L 926.3 820.8 L 926.6 817.6 L 925.3 814.6 L 924.6 811.5 L 924.2 808.3 L 922 806 L 920 803.5 L 919.7 800.2 Z",
      "position": {
        "x": 985.1,
        "y": 777.5
      },
      "badgeAnchor": {
        "x": 998.89,
        "y": 773.04
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "emberrock-cliffs",
      "name": "Emberrock Cliffs",
      "regionId": "emberrock",
      "adjacencies": [
        "emberrock-keep",
        "emberrock-landing",
        "wreckers-reef"
      ],
      "borderDice": {
        "wreckers-reef": {
          "attack": 5
        }
      },
      "shape": "M 943.6 833.2 L 1038.7 807.6 L 1070.2 876.5 L 1069.7 876.8 L 1068.4 878.7 L 1066.5 880.1 L 1064.9 881.8 L 1063 883 L 1061 884.2 L 1059.4 886.2 L 1057.1 887.4 L 1055.2 889.1 L 1053.3 890.8 L 1050.7 891 L 1048.3 891.8 L 1046.1 893.1 L 1043.8 894.3 L 1041.3 894.4 L 1038.9 893.6 L 1036.5 893.9 L 1034 894.3 L 1031.5 894.1 L 1029.1 893.8 L 1026.8 895 L 1024.3 895.2 L 1022.6 893.3 L 1020.6 891.7 L 1018.6 890.1 L 1016.7 888.4 L 1014.7 886.8 L 1012.4 885.6 L 1010.7 883.7 L 1008.7 882.1 L 1006.3 881.1 L 1005 878.9 L 1003.2 877.1 L 1002 875 L 1001.2 872.7 L 1000 870.5 L 999 868.3 L 997.9 866.1 L 996.6 864.3 L 994.6 863.6 L 993.8 861.7 L 992.2 860.3 L 990.2 859.6 L 988.9 857.9 L 987.2 856.7 L 985.6 855.5 L 983.9 854.3 L 982 853.3 L 980.3 852.1 L 978.6 851 L 977.5 849.1 L 976.2 847.5 L 974.4 846.3 L 973.1 844.6 L 969.8 843.9 L 966.5 844 L 963.3 843.3 L 960 842.8 L 956.8 841.8 L 953.7 840.7 L 950.8 839 L 948.1 837 L 945.7 834.6 Z",
      "position": {
        "x": 1019.1,
        "y": 850.6
      },
      "badgeAnchor": {
        "x": 1020.75,
        "y": 844.56
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "emberrock-shoals",
      "name": "Emberrock Shoals",
      "regionId": "emberrock",
      "adjacencies": [
        "driftstone",
        "emberrock-keep",
        "emberrock-landing"
      ],
      "borderDice": {
        "driftstone": {
          "attack": 5
        }
      },
      "shape": "M 1021.5 709 L 1023.8 708.3 L 1025.7 706.8 L 1028 705.8 L 1029.6 703.8 L 1032 703.3 L 1034.4 703.2 L 1036.5 704.9 L 1038.9 705.9 L 1041.4 704.9 L 1043.8 703.9 L 1045.8 705.1 L 1047.9 706 L 1050 707.1 L 1052.2 707.7 L 1054.6 708 L 1056.7 709 L 1059.1 709.3 L 1061.4 708.9 L 1063.3 710.2 L 1065.2 711.3 L 1067.5 711.6 L 1069.6 712.4 L 1071.7 713.1 L 1073.9 713.7 L 1076.1 713.7 L 1078.4 713.8 L 1080.7 714.3 L 1083.1 714.6 L 1085.1 716 L 1087.3 717 L 1089.6 717.3 L 1091.8 718.3 L 1094.2 718.3 L 1096.6 718.3 L 1099.1 719.4 L 1100 722 L 1102 723.5 L 1104.1 724.8 L 1104.7 727.3 L 1106 729.5 L 1106.7 732 L 1106.6 734.5 L 1108.2 736 L 1109.7 737.6 L 1111 739.4 L 1112 741.4 L 1114 742.6 L 1114.7 744.8 L 1115.4 746.9 L 1116.6 748.8 L 1117 751.1 L 1117.5 753.3 L 1119.1 754.9 L 1120.6 756.7 L 1122 758.4 L 1123.8 759.7 L 1124.6 762 L 1126.8 763 L 1128.6 764.9 L 1130.6 766.6 L 1132.6 768.2 L 1134.5 769.9 L 1136.9 771.2 L 1139 773 L 1139.4 775.7 L 1140.8 778.1 L 1141.1 778.5 L 1050.8 783.5 Z",
      "position": {
        "x": 1075,
        "y": 746.9
      },
      "badgeAnchor": {
        "x": 1071.96,
        "y": 747.11
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "thornvale-keep",
      "name": "Thornvale Keep",
      "regionId": "thornvale",
      "adjacencies": [
        "thornvale-cliffs",
        "thornvale-landing",
        "thornvale-shoals"
      ],
      "shape": "M 738.1 1088.7 L 758.6 1013.8 L 784.2 1004.9 L 852.7 1058.6 L 851.7 1060.5 L 851.2 1062.9 L 849.3 1064.3 L 847.5 1065.9 L 845.7 1067.4 L 843.5 1068.4 L 841.8 1070.1 L 839.7 1071.4 L 838.4 1073.4 L 837.4 1075.6 L 835.6 1078.1 L 835 1081.1 L 834.1 1083.9 L 832.4 1086.4 L 831.4 1089.4 L 832.5 1092.4 L 831.7 1095.3 L 830.5 1098.1 L 829.2 1100.9 L 828.2 1103.8 L 827 1106.6 L 824.9 1108.9 L 823 1111.3 L 820.4 1113 L 818.4 1115.5 L 815.6 1116.8 L 813.2 1119.3 L 810.7 1121.7 L 809.1 1124.9 L 808.5 1128.4 L 805.1 1129.1 L 801.7 1129.4 L 798.7 1131.2 L 795.7 1132.9 L 792.6 1132.7 L 789.5 1132.6 L 786.5 1132.8 L 783.4 1133 L 780.3 1133.6 L 777.2 1132.9 L 774.1 1132.7 L 771.1 1131.8 L 768.1 1130.5 L 765.3 1128.8 L 762.3 1127.8 L 759.2 1126.6 L 757.3 1123.9 L 754.6 1122 L 751.4 1120.8 L 749.5 1118 L 747.5 1114.6 L 746 1110.9 L 745.2 1107 L 744.9 1103 L 743.2 1101.7 L 741.4 1100.5 L 739.8 1099.1 L 738.7 1097.2 L 738.9 1095.1 L 739 1093 L 738.7 1090.9 L 738.2 1088.8 Z",
      "position": {
        "x": 788.6,
        "y": 1072.3
      },
      "badgeAnchor": {
        "x": 790.03,
        "y": 1071.26
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "thornvale-landing",
      "name": "Thornvale Landing",
      "regionId": "thornvale",
      "adjacencies": [
        "thornvale-cliffs",
        "thornvale-keep",
        "thornvale-shoals"
      ],
      "oneWayBorders": [
        "thornvale-gate"
      ],
      "shape": "M 673.1 967 L 673.8 966.1 L 676.4 964.7 L 677.4 962.1 L 678.8 959.6 L 681.3 958.3 L 683.6 956.8 L 685.6 954.7 L 688.4 954.1 L 690.4 952.4 L 692.9 951.7 L 695.4 951.1 L 697.7 949.8 L 699.9 948.6 L 702.2 947.4 L 704.7 946.7 L 706.7 944.9 L 708.8 944 L 710.7 942.9 L 712.9 942.3 L 715.1 941.6 L 716.6 939.9 L 718.7 939 L 720.8 938.1 L 722.4 936.4 L 724.4 935.2 L 725.9 933.5 L 727.7 931.9 L 729 930.1 L 730.1 928 L 731.6 926.1 L 733.8 925.3 L 735.7 923.8 L 738.4 924.2 L 741.1 924.2 L 743.6 923 L 746 921.9 L 748 920 L 750.2 918.4 L 751.1 915.8 L 752 913.2 L 754.7 913.1 L 757.3 912.5 L 759.9 911.9 L 762.5 911.1 L 764.5 909.2 L 767.2 908.5 L 769 906.4 L 771.1 904.7 L 773.6 902.4 L 776.9 901.9 L 779.9 900.6 L 782.3 898.4 L 785.9 898.3 L 789.4 898.8 L 792.4 896.7 L 794.2 893.5 L 796.8 894.9 L 799.5 896 L 802.1 897.3 L 804.4 899.1 L 806.9 900.8 L 809.9 901.3 L 812.9 901.5 L 815.8 901.7 L 818.1 903.6 L 819.5 906.2 L 821.1 908.7 L 822.4 910.1 L 784.2 1004.9 L 758.6 1013.8 Z",
      "position": {
        "x": 757.7,
        "y": 955.1
      },
      "badgeAnchor": {
        "x": 754.75,
        "y": 963.05
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "thornvale-cliffs",
      "name": "Thornvale Cliffs",
      "regionId": "thornvale",
      "adjacencies": [
        "kelp-holm",
        "thornvale-keep",
        "thornvale-landing"
      ],
      "borderDice": {
        "kelp-holm": {
          "attack": 5
        }
      },
      "shape": "M 659.1 1009.4 L 660.3 1006.8 L 661.6 1004.3 L 663.1 1001.9 L 664.7 999.5 L 665.9 996.8 L 665.9 993.9 L 667.6 991.6 L 668.9 989 L 669.5 986.4 L 670 983.9 L 669.9 981.2 L 671.1 978.7 L 670.5 976.1 L 670.6 973.4 L 671.6 970.9 L 672 968.3 L 673.1 967 L 758.6 1013.8 L 738.1 1088.7 L 737.1 1086.7 L 736.3 1084.5 L 735 1082.5 L 733.4 1080.8 L 731.8 1078.9 L 730.7 1076.9 L 730.4 1074.5 L 729.1 1072.4 L 725.9 1070.3 L 722.7 1068.3 L 719.5 1066.3 L 716.2 1064.3 L 713.8 1063.9 L 711.6 1062.8 L 709.9 1061 L 707.7 1059.9 L 705.6 1058.6 L 703.2 1058.2 L 700.7 1058 L 698.3 1058.1 L 695.5 1057.3 L 692.8 1056.1 L 690.1 1055 L 687.2 1054.4 L 684.5 1053.2 L 682.6 1050.9 L 679.5 1050.5 L 677.4 1048.2 L 676 1046 L 675.6 1043.5 L 675 1041.1 L 674.8 1038.6 L 673 1036.6 L 671.9 1034.3 L 671.1 1031.7 L 671.7 1029.1 L 669.5 1027 L 667 1025.3 L 665.1 1023 L 663.7 1020.3 L 663 1017.3 L 660.8 1015.1 L 659.8 1012.3 Z",
      "position": {
        "x": 708.6,
        "y": 1023.7
      },
      "badgeAnchor": {
        "x": 704.19,
        "y": 1022.15
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "thornvale-shoals",
      "name": "Thornvale Shoals",
      "regionId": "thornvale",
      "adjacencies": [
        "thornvale-keep",
        "thornvale-landing",
        "wreckers-reef"
      ],
      "borderDice": {
        "wreckers-reef": {
          "attack": 5
        }
      },
      "shape": "M 784.2 1004.9 L 822.4 910.1 L 823 910.8 L 825.4 912.7 L 827 915.2 L 829.7 916.5 L 832.3 917.9 L 833.1 921 L 834.6 923.8 L 835.9 926.8 L 838 929.2 L 837.6 932.3 L 837.7 935.5 L 838.2 938.7 L 838.7 941.8 L 840.3 944 L 842 946.1 L 843.1 948.7 L 844 951.2 L 843.5 953.9 L 842.8 956.5 L 841.8 959.1 L 842.1 961.9 L 842.6 964 L 842.9 966.1 L 843.3 968.3 L 842.7 970.5 L 844 972.3 L 845.3 974 L 845.5 976.2 L 845.9 978.4 L 847.8 979.6 L 849.3 981.1 L 850.2 983.2 L 851.4 985 L 852.3 987 L 853.8 988.6 L 854.9 990.5 L 855.4 992.6 L 858 993.8 L 860.2 995.6 L 862.8 997.1 L 863.9 999.9 L 866.2 1001.7 L 868.6 1003.5 L 869 1006.5 L 869.7 1009.4 L 869.1 1011.8 L 868.4 1014.1 L 867.5 1016.4 L 866.5 1018.6 L 866.5 1021.1 L 866.8 1023.5 L 866.9 1026 L 866.7 1028.4 L 865.9 1030.7 L 865.7 1033.1 L 865.1 1035.5 L 865.2 1037.9 L 864.6 1040.3 L 863.3 1042.3 L 862.6 1044.7 L 861 1046.6 L 859.2 1048.3 L 858.8 1050.8 L 857.5 1052.9 L 856.7 1055.1 L 854.8 1056.7 L 852.9 1058.3 L 852.7 1058.6 Z",
      "position": {
        "x": 828.8,
        "y": 991.8
      },
      "badgeAnchor": {
        "x": 820.27,
        "y": 995.95
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mistfell-keep",
      "name": "Mistfell Keep",
      "regionId": "mistfell",
      "adjacencies": [
        "mistfell-cliffs",
        "mistfell-landing",
        "mistfell-shoals"
      ],
      "shape": "M 366.5 1037.1 L 432.1 996.8 L 455.3 1006.7 L 480.5 1121.8 L 479.6 1122.3 L 476.6 1124.1 L 474 1126.3 L 471.1 1128.2 L 469 1131 L 466.7 1133.6 L 463.4 1133.8 L 460.1 1134.3 L 456.8 1134.4 L 453.5 1133.8 L 450.2 1133.9 L 447 1134.6 L 443.7 1134.6 L 440.4 1134.3 L 438.7 1133.1 L 437.4 1131.4 L 435.6 1130.4 L 434 1129.1 L 432.2 1128 L 430.8 1126.5 L 428.9 1125.6 L 427.2 1124.4 L 426 1122.7 L 425.2 1120.8 L 424.5 1118.8 L 423.6 1117 L 421.8 1115.8 L 420.3 1114.2 L 419.6 1112.2 L 418.7 1110.3 L 416.9 1108 L 414.7 1106 L 412.8 1103.7 L 410.9 1101.5 L 408.7 1099.5 L 406.7 1097.3 L 404.4 1095.4 L 402.1 1093.6 L 401.8 1090.3 L 401.8 1086.9 L 401.1 1083.7 L 401 1080.3 L 399.9 1077.1 L 398.8 1074 L 397.4 1070.9 L 395.6 1068.1 L 395.5 1065.9 L 395.4 1063.6 L 394.5 1061.6 L 393.5 1059.5 L 392.7 1057.5 L 391.9 1055.4 L 390.8 1053.5 L 390.1 1051.4 L 386.5 1050 L 383.1 1048.2 L 380.2 1045.8 L 377.2 1043.4 L 375.3 1042.1 L 373.5 1040.7 L 371.4 1039.7 L 369.2 1039.2 L 367.5 1037.7 Z",
      "position": {
        "x": 432.9,
        "y": 1065.5
      },
      "badgeAnchor": {
        "x": 428.84,
        "y": 1050.63
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mistfell-landing",
      "name": "Mistfell Landing",
      "regionId": "mistfell",
      "adjacencies": [
        "mistfell-cliffs",
        "mistfell-keep",
        "mistfell-shoals"
      ],
      "oneWayBorders": [
        "mistfell-gate"
      ],
      "shape": "M 388.8 879.8 L 389.7 878.7 L 392.9 878.2 L 396.2 878 L 399.5 877.9 L 402.6 876.5 L 405.9 876.2 L 409.1 875.3 L 412.3 876.3 L 415.6 876.3 L 418.7 875.6 L 421.8 875.2 L 424.9 874.2 L 428 873.8 L 431.2 873.6 L 434.3 872.9 L 437.4 872.1 L 440.4 871 L 442.9 873.3 L 445.3 875.6 L 448.3 877.3 L 451.4 878.7 L 454.5 879.9 L 457.5 881.5 L 460.5 882.9 L 463.7 883.9 L 466.5 885 L 468.5 887.2 L 471.3 888.2 L 473.8 889.8 L 476.2 891.6 L 478.7 893.3 L 481.6 893.9 L 484.5 894.7 L 486.8 897.1 L 488.5 899.9 L 489.1 903.2 L 490.2 906.3 L 491.4 909.3 L 493.4 911.9 L 494.3 915 L 496 917.8 L 497.4 920.1 L 497.8 922.8 L 499.3 925 L 500.5 927.3 L 501.3 929.9 L 502.9 932.1 L 503.6 934.6 L 504.3 937.2 L 503.4 940.3 L 502.4 943.3 L 501.3 946.4 L 501 949.6 L 500.4 952.7 L 499.6 955.8 L 499.1 959 L 498.7 962.2 L 499.3 965.6 L 500 969 L 501.1 972.3 L 502 975.6 L 504.2 978.3 L 505.1 979.6 L 455.3 1006.7 L 432.1 996.8 Z",
      "position": {
        "x": 450.9,
        "y": 935.3
      },
      "badgeAnchor": {
        "x": 456.04,
        "y": 936.73
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mistfell-cliffs",
      "name": "Mistfell Cliffs",
      "regionId": "mistfell",
      "adjacencies": [
        "fog-isle",
        "mistfell-keep",
        "mistfell-landing"
      ],
      "borderDice": {
        "fog-isle": {
          "attack": 5
        }
      },
      "shape": "M 356.5 1017.8 L 357.2 1015.6 L 357.1 1013.3 L 357.7 1011.1 L 357.7 1008.8 L 359 1007 L 360.4 1005.2 L 361.2 1003 L 362.4 1001.1 L 363.6 999.4 L 364.4 997.5 L 365.7 995.9 L 367.2 994.6 L 368 992.6 L 369 990.9 L 370 989.1 L 370.9 987.3 L 371.2 983.7 L 372.4 980.3 L 372.9 976.7 L 372.7 973.1 L 372.8 970.9 L 372.5 968.6 L 372.3 966.4 L 372.4 964.2 L 372.1 962 L 372.2 959.7 L 372.1 957.5 L 371.9 955.3 L 370.6 951.6 L 370 947.7 L 368.3 944.2 L 367.1 940.4 L 367.1 938.4 L 367.9 936.4 L 367.4 934.4 L 366.6 932.5 L 364.8 929 L 364.3 925 L 365.2 921.9 L 365.6 918.7 L 367.6 916.1 L 368.8 913 L 370.3 910.2 L 371.4 907.2 L 372.2 904.1 L 373.6 901.2 L 375.5 898.3 L 378 895.8 L 380.3 893.1 L 381.3 889.7 L 383.7 887.1 L 385.3 884.1 L 387.5 881.4 L 388.8 879.8 L 432.1 996.8 L 366.5 1037.1 L 365.6 1036.5 L 363.8 1035.1 L 362.2 1033.5 L 361.3 1031.6 L 360.9 1029.5 L 360 1027.6 L 359.1 1025.7 L 358.4 1023.7 L 357.4 1021.9 L 357.2 1019.8 Z",
      "position": {
        "x": 390.5,
        "y": 967
      },
      "badgeAnchor": {
        "x": 400.21,
        "y": 985.49
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mistfell-shoals",
      "name": "Mistfell Shoals",
      "regionId": "mistfell",
      "adjacencies": [
        "kelp-holm",
        "mistfell-keep",
        "mistfell-landing"
      ],
      "borderDice": {
        "kelp-holm": {
          "attack": 5
        }
      },
      "shape": "M 455.3 1006.7 L 505.1 979.6 L 506 981.2 L 507.6 984.3 L 508.8 987.5 L 508.5 990.9 L 508.5 994.3 L 508.8 997.7 L 509.3 1001.1 L 510.8 1003.1 L 512.7 1004.8 L 513.4 1007.3 L 514.8 1009.3 L 516.6 1011.1 L 518.7 1012.6 L 519.8 1014.9 L 521 1017.1 L 521.9 1019.8 L 523.7 1022.1 L 523.4 1024.9 L 523.6 1027.8 L 524.9 1030.2 L 525.7 1032.8 L 527.3 1035.1 L 528.5 1037.6 L 528.2 1040.3 L 528.5 1043 L 529 1045.7 L 529 1048.5 L 529.1 1051.2 L 529 1054 L 528 1056.5 L 527.3 1059.2 L 526.8 1062 L 525.4 1064.4 L 524.4 1067.1 L 523.7 1069.8 L 523.1 1072.5 L 522.3 1075.2 L 520.8 1077.7 L 519.4 1080.1 L 517.1 1081.6 L 515.1 1083.5 L 513.1 1085.3 L 511.2 1087.4 L 509.3 1089.3 L 506.9 1090.8 L 504.6 1092.3 L 502.2 1093.6 L 500.2 1096.3 L 498.5 1099.2 L 496.8 1102.2 L 495.5 1105.3 L 493.7 1108.1 L 491.5 1110.7 L 489.5 1113.5 L 488.2 1116.6 L 485.6 1118.8 L 482.7 1120.8 L 480.5 1121.8 Z",
      "position": {
        "x": 492.8,
        "y": 1044.8
      },
      "badgeAnchor": {
        "x": 495.66,
        "y": 1044.03
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "goldcrest-keep",
      "name": "Goldcrest Keep",
      "regionId": "goldcrest",
      "adjacencies": [
        "goldcrest-cliffs",
        "goldcrest-landing",
        "goldcrest-shoals"
      ],
      "shape": "M 79.1 859.1 L 79.5 856.6 L 79.5 854 L 79.7 851.4 L 80.6 848.9 L 81.2 846.3 L 82.6 844 L 82.8 841.4 L 83.5 838.9 L 84 836.3 L 85.2 833.9 L 84.8 831.6 L 85.9 829.6 L 86.8 827.6 L 88.3 826 L 88.8 823.9 L 89.1 821.8 L 89.6 819.7 L 89.9 817.6 L 89.4 815.6 L 89.1 813.6 L 89.5 811.6 L 89.1 809.6 L 88.8 807.6 L 88.2 805.7 L 87.5 803.7 L 87.5 801.7 L 87 800.7 L 154.9 805.4 L 171.7 829.5 L 142.9 904.9 L 140.6 905.8 L 138.4 905 L 136.6 903.6 L 134.8 902.2 L 132.7 901.3 L 130.3 901.6 L 127.9 901.2 L 125.7 900.2 L 123.4 899.5 L 121.2 898.5 L 119.3 897 L 116.8 897.4 L 114.4 896.9 L 111.7 896.2 L 109.1 897 L 106.5 896.4 L 104.1 895.1 L 102.3 893.2 L 100 891.9 L 97.4 891.3 L 95.1 889.9 L 93.3 888.2 L 91.7 886.2 L 89.8 884.5 L 88.7 882.2 L 87 880.3 L 85.4 878.3 L 84.1 876.1 L 83.3 873.7 L 81.7 871.6 L 81.1 869.1 L 80.4 866.6 L 79.7 864.2 L 79.7 861.6 Z",
      "position": {
        "x": 123.1,
        "y": 848.8
      },
      "badgeAnchor": {
        "x": 121.06,
        "y": 851.61
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "goldcrest-landing",
      "name": "Goldcrest Landing",
      "regionId": "goldcrest",
      "adjacencies": [
        "goldcrest-cliffs",
        "goldcrest-keep",
        "goldcrest-shoals"
      ],
      "oneWayBorders": [
        "goldcrest-gate"
      ],
      "shape": "M 154.9 805.4 L 193.6 712.7 L 195.6 715.4 L 197.4 718.8 L 197.7 722.8 L 198.8 726.6 L 200.3 730.3 L 202.1 733.8 L 202.6 736.5 L 203.9 738.8 L 205 741.3 L 205.3 744 L 205.8 746.7 L 206.5 749.4 L 208.3 751.5 L 210.2 753.5 L 212.5 756.5 L 214.7 759.6 L 217.3 762.3 L 220.4 764.6 L 224.1 765.9 L 227.3 768.2 L 229.6 771.3 L 231.5 774.7 L 233.5 778.1 L 236.2 780.9 L 238.7 784 L 241.1 787.1 L 244.4 788 L 247.8 788.5 L 251.1 789.4 L 254.1 791 L 256.7 793.3 L 259.9 794.5 L 262.9 796.1 L 265.7 798 L 267 801.2 L 270.2 802.7 L 273 804.3 L 275.5 806.3 L 277.4 809 L 278.1 812.2 L 280.3 814.7 L 281.7 817.6 L 280.4 820.1 L 279 822.6 L 277.4 825.1 L 275.8 827.5 L 275.4 830.3 L 275.1 833.2 L 273.4 835.6 L 273.1 838.6 L 271 840.3 L 269.3 842.5 L 269.1 843 L 171.7 829.5 Z",
      "position": {
        "x": 212.3,
        "y": 796.5
      },
      "badgeAnchor": {
        "x": 200.47,
        "y": 796.17
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "goldcrest-cliffs",
      "name": "Goldcrest Cliffs",
      "regionId": "goldcrest",
      "adjacencies": [
        "gannet-rock",
        "goldcrest-keep",
        "goldcrest-landing"
      ],
      "borderDice": {
        "gannet-rock": {
          "attack": 5
        }
      },
      "shape": "M 83.3 775.4 L 83.3 772.9 L 83.9 770.4 L 84.8 768.1 L 85.7 765.8 L 86.3 763.4 L 87.7 761.1 L 88.7 758.7 L 89.3 756.1 L 90.5 753.7 L 91 751.1 L 91.2 748.4 L 92.3 746 L 93.2 743.5 L 93.7 740.1 L 92.8 736.9 L 94.4 733.9 L 95.2 730.7 L 96.5 727.6 L 98.9 725.3 L 100.7 722.6 L 101.8 719.5 L 104.9 719 L 107 716.7 L 110.1 715.7 L 111.3 712.7 L 113.7 710.8 L 116.5 710 L 118.9 708.3 L 121.4 706.7 L 123.5 704.2 L 126 702 L 128.6 700 L 131.7 698.7 L 133.5 695.7 L 136.9 694.8 L 140 693.6 L 142.1 690.9 L 145.4 691.2 L 148.4 692.3 L 151.6 693.1 L 154.9 693 L 157.7 694.7 L 160.7 696.2 L 164 696 L 167.3 696.8 L 170.3 697.5 L 173.1 699 L 175.3 701.2 L 177.7 703.2 L 180.9 703.3 L 183.6 704.9 L 186.6 705.6 L 189.7 705.2 L 190.9 709 L 193.2 712.2 L 193.6 712.7 L 154.9 805.4 L 87 800.7 L 86.3 799.4 L 85.4 797.1 L 86.5 794.7 L 86.2 792.1 L 86.2 789.6 L 85.5 787.2 L 84.7 784.9 L 83.4 782.8 L 83.6 780.3 L 83.6 777.8 Z",
      "position": {
        "x": 135.8,
        "y": 750.1
      },
      "badgeAnchor": {
        "x": 133.28,
        "y": 749.94
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "goldcrest-shoals",
      "name": "Goldcrest Shoals",
      "regionId": "goldcrest",
      "adjacencies": [
        "fog-isle",
        "goldcrest-keep",
        "goldcrest-landing"
      ],
      "borderDice": {
        "fog-isle": {
          "attack": 5
        }
      },
      "shape": "M 142.9 904.9 L 171.7 829.5 L 269.1 843 L 268.3 845 L 267.5 847.6 L 267.1 850.3 L 265.6 852.6 L 264 854.8 L 262.9 857.2 L 261.4 859.4 L 259.1 860.7 L 257.8 863 L 257.3 865.6 L 255.7 867.6 L 254 869.4 L 252.4 871.4 L 251.3 873.7 L 250.1 875.9 L 248 877.4 L 246.1 878.9 L 244.3 880.7 L 243.3 883.1 L 241.3 884.6 L 239.9 886.7 L 237.9 888.2 L 236.9 891 L 236.7 894 L 235.4 896.6 L 233.8 899.1 L 232.2 901.6 L 231.2 904.4 L 230.6 907.3 L 228.9 909.7 L 226.9 911.7 L 224.7 913.5 L 222 914.3 L 219.4 915.3 L 217 916.7 L 214.7 918.4 L 212.8 920.4 L 210.7 922.2 L 207.9 922.3 L 205.1 922.2 L 202.3 922.4 L 199.4 922.3 L 196.6 922.8 L 193.8 923.4 L 190.9 923.4 L 188.2 922.5 L 185.5 922.9 L 182.8 922.5 L 180.2 923.3 L 177.8 924.5 L 175.1 924.4 L 172.5 924.2 L 170 923.3 L 167.3 923 L 164.7 921.8 L 162.1 920.4 L 159.2 919.2 L 157.6 916.7 L 155.8 914.4 L 153.6 912.5 L 151.4 910.5 L 149.2 908.6 L 147.4 907.1 L 145.1 906.4 L 143 904.9 Z",
      "position": {
        "x": 200.7,
        "y": 876.1
      },
      "badgeAnchor": {
        "x": 196.14,
        "y": 881.45
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "stormreach-keep",
      "name": "Stormreach Keep",
      "regionId": "stormreach",
      "adjacencies": [
        "stormreach-cliffs",
        "stormreach-landing",
        "stormreach-shoals"
      ],
      "shape": "M 16.3 515.8 L 16.4 512.7 L 17.2 509.7 L 16.7 506.7 L 17.3 503.6 L 19 500.9 L 18.9 497.7 L 20.4 495.1 L 21.5 492.3 L 22.4 489.4 L 23.4 486.6 L 26.1 484.8 L 27.9 482.1 L 29 479.2 L 29.2 476 L 31 473.6 L 32.6 471.1 L 34.4 468.6 L 35.3 465.8 L 37.6 463.8 L 40.1 462.1 L 42.5 460.3 L 45.5 459.5 L 46.4 457.6 L 47.1 455.5 L 48.4 453.8 L 49.4 451.9 L 51 450.5 L 52.7 449.1 L 54.1 447.5 L 55.4 445.8 L 55.3 443.4 L 56 441.1 L 56.7 438.8 L 56.8 436.5 L 56.3 434.2 L 55.6 431.9 L 54.8 429.6 L 55.1 427.2 L 56.5 425.5 L 58.4 424.3 L 60.4 423.3 L 61.7 421.4 L 62.9 419.6 L 64.2 417.8 L 65.2 415.9 L 66.3 414 L 68.1 412.8 L 70.1 412 L 71.6 410.4 L 73.5 409.3 L 75.4 408.1 L 77.4 407.3 L 79.6 407.2 L 81.6 406.3 L 83.7 406.1 L 85.5 405 L 85.6 405 L 132.2 459.4 L 125.1 491.1 L 27.9 545.9 L 27.2 543.5 L 25.6 540.8 L 24.7 537.8 L 24.6 534.7 L 24.6 531.6 L 24 528.5 L 22.2 525.8 L 19.7 523.9 L 17.3 521.9 L 16.9 518.9 Z",
      "position": {
        "x": 72.9,
        "y": 476.1
      },
      "badgeAnchor": {
        "x": 86.93,
        "y": 468.85
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "stormreach-landing",
      "name": "Stormreach Landing",
      "regionId": "stormreach",
      "adjacencies": [
        "stormreach-cliffs",
        "stormreach-keep",
        "stormreach-shoals"
      ],
      "oneWayBorders": [
        "stormreach-gate"
      ],
      "shape": "M 125.1 491.1 L 132.2 459.4 L 222.5 427 L 223.3 429.8 L 224 432.9 L 224.5 436.1 L 224.7 438.8 L 225.1 441.5 L 226.9 443.7 L 228.2 446.1 L 227.5 448.6 L 226.9 451.2 L 225.6 453.7 L 226.2 456.5 L 227.5 458.8 L 228.8 461.1 L 230.3 463.4 L 231.6 465.7 L 232.5 468.2 L 233.4 470.7 L 233.9 473.3 L 234.2 476 L 235.3 478.7 L 237.1 481 L 236.9 483.9 L 237.6 486.8 L 236.7 489.6 L 237 492.6 L 237.6 495.4 L 239 498 L 237.7 500.5 L 236.2 502.9 L 235.9 505.6 L 235.2 508.4 L 233.5 510.6 L 232.4 513.1 L 230.7 515.4 L 230.4 518.3 L 227.5 519.3 L 225.1 521.2 L 223.2 523.8 L 220.1 524.6 L 217.4 526.1 L 214.4 526.8 L 212 528.7 L 209.3 530.2 L 206.2 530.8 L 203.2 531.3 L 200.2 532.2 L 197.1 532.9 L 194.1 533.6 L 190.9 533.3 L 187.7 533.9 L 184.7 532.5 L 182.5 532.6 L 180.3 533.1 L 178.1 533.5 L 176 534.2 L 173.7 534.7 L 171.5 534 L 169.3 534.4 L 167.1 534.2 L 164.6 534.6 Z",
      "position": {
        "x": 185.9,
        "y": 484.8
      },
      "badgeAnchor": {
        "x": 190.95,
        "y": 485.9
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "stormreach-cliffs",
      "name": "Stormreach Cliffs",
      "regionId": "stormreach",
      "adjacencies": [
        "brine-skerry",
        "stormreach-keep",
        "stormreach-landing"
      ],
      "borderDice": {
        "brine-skerry": {
          "attack": 5
        }
      },
      "shape": "M 85.6 405 L 87.3 403.9 L 89.3 403.6 L 91.2 402.7 L 93.2 402 L 95.3 401.3 L 96.5 399.5 L 98.5 399.3 L 100.6 399 L 102.3 397.9 L 104.3 397.2 L 106.3 397 L 108.4 397.4 L 110.2 396.3 L 112.2 395.8 L 114.2 394.7 L 116.5 393.9 L 118.4 392.7 L 120.3 391.4 L 122 389.6 L 123.7 388.1 L 125.9 387 L 128.2 386.5 L 130.5 385.7 L 132.6 384.5 L 135.1 384.6 L 137.3 383.4 L 139.6 382.2 L 142.1 382.4 L 144.5 382.4 L 146.9 382 L 150.2 381.1 L 153 379.2 L 156.4 379.2 L 159.6 378 L 162.5 375.9 L 166.1 375.9 L 169.4 374.6 L 171.4 371.7 L 174.6 372.8 L 178 372.7 L 181.3 372.1 L 184.7 372.2 L 188 372.1 L 191.3 371.4 L 194.6 371.7 L 197.9 371.6 L 200.7 373 L 202.6 375.5 L 204.4 378 L 206.8 380 L 208.7 382.6 L 211.5 384 L 213.3 386.5 L 215.4 388.7 L 216.1 391.7 L 216.7 394.8 L 218.1 397.5 L 218.7 400.6 L 220.4 403.1 L 222.2 405.7 L 224.3 408 L 225.8 410.7 L 225.2 413.8 L 224.5 417 L 223.2 420 L 223.5 423.3 L 222.4 426.5 L 222.5 427 L 132.2 459.4 Z",
      "position": {
        "x": 160.5,
        "y": 412.6
      },
      "badgeAnchor": {
        "x": 149.13,
        "y": 416.78
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "stormreach-shoals",
      "name": "Stormreach Shoals",
      "regionId": "stormreach",
      "adjacencies": [
        "gannet-rock",
        "stormreach-keep",
        "stormreach-landing"
      ],
      "borderDice": {
        "gannet-rock": {
          "attack": 5
        }
      },
      "shape": "M 27.9 545.9 L 125.1 491.1 L 164.6 534.6 L 163.6 534.8 L 160.3 535.8 L 156.8 536.3 L 153.3 536.7 L 151 539.5 L 148.1 541.7 L 145.1 543.7 L 142.1 545.8 L 140.9 548.1 L 139.1 550 L 137.3 551.9 L 135.3 553.7 L 133.9 555.8 L 132.4 558 L 130.2 559.4 L 128.2 561.2 L 126.2 563.5 L 124.4 566.1 L 121.6 567.4 L 119.4 569.5 L 117 571.5 L 114.2 572.7 L 111.1 573.3 L 108.5 574.9 L 105.6 575.2 L 102.7 576.1 L 100.2 577.5 L 97.5 578.8 L 94.5 578.6 L 91.8 577.4 L 88.8 577.2 L 85.9 578.1 L 82.7 578.5 L 79.5 578.1 L 76.3 577.9 L 73.2 577.1 L 70 577.4 L 66.8 577.5 L 63.6 578.1 L 60.4 577.4 L 58.1 575.5 L 55.9 573.4 L 53.8 571.1 L 52 568.7 L 49.3 567.4 L 46.6 565.9 L 43.8 564.7 L 41.6 562.5 L 39.2 560.7 L 36.8 558.8 L 34.6 556.6 L 33.5 553.7 L 31.8 551.2 L 29.6 549.1 L 28 546.4 Z",
      "position": {
        "x": 97.4,
        "y": 540.3
      },
      "badgeAnchor": {
        "x": 102.66,
        "y": 541.8
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ashmoor-keep",
      "name": "Ashmoor Keep",
      "regionId": "ashmoor",
      "adjacencies": [
        "ashmoor-cliffs",
        "ashmoor-landing",
        "ashmoor-shoals"
      ],
      "shape": "M 153.4 187.7 L 154.1 185.7 L 155.4 183 L 156.7 180.4 L 157.6 177.7 L 158.1 174.8 L 158.9 172 L 160.1 169.4 L 161.9 167.1 L 164.3 165.5 L 166.1 163.1 L 167.8 160.9 L 169.7 159 L 171.7 157.2 L 173.7 155.2 L 175.1 152.9 L 177.1 151 L 178.8 148.9 L 180.8 147 L 182.9 145.1 L 185.4 144 L 187.1 141.9 L 188.9 139.8 L 191.5 138.9 L 194.1 138.1 L 196.6 137.1 L 199.2 136.3 L 201 134.7 L 203.1 133.5 L 205.1 132 L 206.7 130.2 L 208.9 129.2 L 211.2 128.6 L 213.5 127.7 L 215.7 126.7 L 217.5 125.2 L 219.6 124.1 L 221.5 122.8 L 223.5 121.5 L 225.8 121 L 227.8 119.7 L 230 119 L 232.2 118.2 L 234.6 117.6 L 237.1 117 L 239.5 116.3 L 242 116.3 L 243.9 114.6 L 245.6 112.8 L 247.3 110.9 L 249.2 109.3 L 251.6 109.2 L 254 108.5 L 256.3 107.8 L 258.6 107 L 261 107.4 L 263.4 107.5 L 265.9 107.4 L 268.3 107.3 L 270.7 107.3 L 273.2 107.3 L 275.6 107.3 L 278 106.9 L 279 106.8 L 278.9 196.8 L 257 213.1 Z",
      "position": {
        "x": 229.7,
        "y": 163.1
      },
      "badgeAnchor": {
        "x": 233.86,
        "y": 164.93
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ashmoor-landing",
      "name": "Ashmoor Landing",
      "regionId": "ashmoor",
      "adjacencies": [
        "ashmoor-cliffs",
        "ashmoor-keep",
        "ashmoor-shoals"
      ],
      "oneWayBorders": [
        "ashmoor-gate"
      ],
      "shape": "M 255.2 302.2 L 257 213.1 L 278.9 196.8 L 375.8 222.5 L 376 224.3 L 376.7 227 L 375.1 229.3 L 373.3 231.3 L 372.1 233.7 L 371 236.2 L 370.2 238.9 L 368.8 241.3 L 368 243.8 L 367.4 246.5 L 366.4 249 L 365.5 251.6 L 365.3 254.3 L 364.8 257 L 363.3 259.3 L 361.5 261.3 L 360.6 263.9 L 359.7 266.5 L 358.4 268.9 L 356.7 271 L 354.7 272.8 L 352.8 274.8 L 351.1 276.8 L 349.3 278.9 L 347.3 280.8 L 346.2 283.3 L 343.6 284.3 L 340.9 284.9 L 338.1 285.4 L 335.8 287 L 333.5 288.6 L 330.8 289.4 L 328.4 290.6 L 325.7 291.4 L 323.6 293 L 320.9 293.1 L 318.8 294.5 L 316.6 295.6 L 314.2 296.6 L 311.9 297.5 L 309.5 298.3 L 307.1 299.1 L 305 300.7 L 302.8 302.1 L 300.5 303.3 L 298.3 304.7 L 295.6 305.2 L 292.9 305.7 L 290.9 307.5 L 289 309.5 L 286.2 309.3 L 283.5 308.7 L 281.2 307.2 L 278.7 306 L 276.1 305.3 L 273.4 304.7 L 270.9 303.5 L 268.3 302.7 L 265.9 302.7 L 263.5 302.7 L 261 302.8 L 258.7 302.4 L 256.2 302.3 Z",
      "position": {
        "x": 305.9,
        "y": 251.2
      },
      "badgeAnchor": {
        "x": 302.66,
        "y": 251.39
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ashmoor-cliffs",
      "name": "Ashmoor Cliffs",
      "regionId": "ashmoor",
      "adjacencies": [
        "ashmoor-keep",
        "ashmoor-landing",
        "tern-islet"
      ],
      "borderDice": {
        "tern-islet": {
          "attack": 5
        }
      },
      "shape": "M 278.9 196.8 L 279 106.8 L 280.5 106.8 L 282.8 107.7 L 285.3 108.1 L 287.7 108.1 L 289.9 109.2 L 292.2 110.1 L 294.4 111.2 L 296.7 112.3 L 298.3 114.2 L 300.3 115.7 L 302.2 117.2 L 304.3 118.6 L 306.3 119.7 L 308.2 121 L 310.1 122.4 L 311.4 124.4 L 313.5 125.4 L 315.5 126.5 L 317.3 128 L 319.1 129.4 L 321.3 130.7 L 323.4 132.1 L 326 132.4 L 328.5 132.7 L 331 133.1 L 333.2 134.4 L 335.7 134.6 L 338 135.8 L 338.3 138.3 L 338.9 140.8 L 340 143.2 L 340.3 145.8 L 340.8 148.3 L 341.5 150.7 L 342 153.2 L 342.7 155.7 L 343.8 157.6 L 345.3 159.3 L 346.1 161.4 L 346.8 163.5 L 348.2 165.2 L 349.2 167.2 L 350.4 169 L 351.2 171.1 L 353 172.9 L 354.4 175 L 355.9 177 L 357.7 178.8 L 359.4 180.6 L 361.1 182.5 L 363.2 184 L 364.4 186.3 L 365.2 188.8 L 365.7 191.3 L 366.9 193.6 L 368.4 195.7 L 369.2 198.2 L 370.1 200.6 L 371.1 202.9 L 371.8 205.4 L 371.6 208.2 L 372 211.1 L 373 213.7 L 374.4 216.2 L 375 218.9 L 375.7 221.6 L 375.8 222.5 Z",
      "position": {
        "x": 317.7,
        "y": 169.4
      },
      "badgeAnchor": {
        "x": 313.72,
        "y": 170.07
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ashmoor-shoals",
      "name": "Ashmoor Shoals",
      "regionId": "ashmoor",
      "adjacencies": [
        "ashmoor-keep",
        "ashmoor-landing",
        "brine-skerry"
      ],
      "borderDice": {
        "brine-skerry": {
          "attack": 5
        }
      },
      "shape": "M 146.6 205.4 L 146.9 202.4 L 148 199.5 L 149 196.6 L 150.7 194.1 L 152.1 191.4 L 153.1 188.6 L 153.4 187.7 L 257 213.1 L 255.2 302.2 L 253.8 302 L 251.3 302 L 249 302.7 L 247.4 300.2 L 245.5 298.1 L 244.2 295.5 L 242.9 292.9 L 241.6 290.3 L 240 287.8 L 238.1 285.6 L 236 283.6 L 234.2 282.6 L 232.2 281.8 L 230.3 280.9 L 228.3 280.5 L 226.4 279.5 L 224.4 278.8 L 222.9 277.3 L 221.2 276 L 219.7 274.6 L 218.3 273 L 216.6 271.7 L 215.1 270.2 L 213.6 268.7 L 212.1 267.2 L 210.2 266.2 L 208.2 265.5 L 206.1 264.6 L 204.1 263.6 L 202.5 262 L 200.9 260.4 L 198.9 259.4 L 197.2 258 L 195.2 257 L 193.5 255.5 L 191.7 253.9 L 189.9 252.3 L 188.1 250.6 L 186.2 249.1 L 184.2 247.7 L 182.7 245.8 L 181 244 L 179.2 242.4 L 176.7 240.3 L 173.9 238.7 L 171 237.2 L 168 236 L 165.3 234.1 L 163 231.8 L 160.4 229.9 L 158.4 227.3 L 157.4 224.3 L 156.4 221.4 L 154.9 218.6 L 153.7 215.7 L 151.6 213.4 L 150 210.7 L 148 208.2 Z",
      "position": {
        "x": 211.3,
        "y": 234.8
      },
      "badgeAnchor": {
        "x": 220.77,
        "y": 236.22
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "gull-rock",
      "name": "Gull Rock",
      "adjacencies": [
        "ironhold-cliffs",
        "ironhold-gate",
        "saltmarch-gate",
        "saltmarch-shoals"
      ],
      "borderDice": {
        "ironhold-cliffs": {
          "attack": 5
        },
        "ironhold-gate": {
          "attack": 5
        },
        "saltmarch-gate": {
          "attack": 5
        },
        "saltmarch-shoals": {
          "attack": 5
        }
      },
      "shape": "M 717.7 155.1 L 718.9 151.9 L 720.9 149.1 L 720.9 145.7 L 721.9 142.4 L 720.9 139.6 L 720.8 136.7 L 721.1 133.7 L 720.9 130.8 L 721.8 127.7 L 721.8 124.5 L 723.4 121.6 L 724.2 118.5 L 727.1 117.2 L 729.6 115.1 L 732.1 113.1 L 735.1 111.8 L 738.1 111.9 L 741.2 112.2 L 744.2 111.5 L 747.2 111.2 L 750.1 110.7 L 752.9 109.8 L 755.8 109 L 758.7 108.5 L 761.6 109 L 764.4 110.1 L 767.1 111.5 L 769.7 112.9 L 772 114.9 L 773.8 117.3 L 776.4 118.8 L 779 120.3 L 780.4 123.1 L 782.1 125.9 L 782.1 129.1 L 781 132.1 L 783.4 134.5 L 785.4 137.2 L 787.9 139.4 L 789.6 142.4 L 790 145.7 L 788.8 148.7 L 787.5 151.7 L 786.3 154.6 L 783.9 156.6 L 781.7 158.8 L 780.8 161.8 L 778.5 164.1 L 775.8 165.2 L 773.5 166.8 L 770.9 168.3 L 768.8 170.2 L 766.2 171.8 L 763.2 172.8 L 761.2 175.1 L 758.8 177 L 755.9 175.9 L 752.8 175.2 L 750.4 173.1 L 747.5 171.8 L 744.8 172.2 L 742 171.9 L 739.6 170.6 L 737.1 169.4 L 734 168.2 L 730.7 168.2 L 727.6 167.1 L 724.6 166 L 722.8 163.3 L 721.2 160.5 L 719.7 157.6 Z",
      "position": {
        "x": 752.6,
        "y": 142
      },
      "badgeAnchor": {
        "x": 752.72,
        "y": 141.68
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "seal-skerry",
      "name": "Seal Skerry",
      "adjacencies": [
        "greywatch-gate",
        "greywatch-shoals",
        "saltmarch-cliffs",
        "saltmarch-gate"
      ],
      "borderDice": {
        "greywatch-gate": {
          "attack": 5
        },
        "greywatch-shoals": {
          "attack": 5
        },
        "saltmarch-cliffs": {
          "attack": 5
        },
        "saltmarch-gate": {
          "attack": 5
        }
      },
      "shape": "M 972.6 321.6 L 973.5 318.4 L 974.1 315.1 L 976 312.7 L 977.7 310.1 L 978.5 307.1 L 979.5 304.1 L 981.6 302.2 L 983.5 300.2 L 985 297.9 L 986.2 295.4 L 988.4 293 L 989.4 290 L 990.6 287 L 991.8 284.1 L 994.8 283.4 L 997.9 283.3 L 1000.9 283.1 L 1004 282.9 L 1006.8 283.4 L 1009.4 284.4 L 1012.2 284.8 L 1015 285.1 L 1018.5 284.3 L 1021.8 283 L 1025.3 282.3 L 1028.8 282.1 L 1030.4 285 L 1032.4 287.5 L 1034.4 290.2 L 1037.4 291.8 L 1037.9 295.1 L 1038.1 298.4 L 1037.8 301.7 L 1037.4 305 L 1038.9 307.4 L 1039.8 310.2 L 1041.7 312.4 L 1042.6 315.1 L 1041.5 317.7 L 1040.5 320.3 L 1039.6 323 L 1038.7 325.7 L 1038.6 329.1 L 1039.1 332.5 L 1039.6 336 L 1038.6 339.3 L 1035.3 340.2 L 1031.8 340.3 L 1028.4 340.6 L 1025.1 341.8 L 1022.8 344.3 L 1020.9 347.1 L 1018.4 349.4 L 1016.2 351.9 L 1013.5 350 L 1010.3 349.1 L 1007 349.5 L 1003.8 348.6 L 1000.8 348 L 997.9 347.4 L 995.1 346.2 L 992.2 345.4 L 990 343.3 L 988 341 L 987 338.2 L 985.2 335.7 L 982 334.3 L 978.7 333.1 L 976.1 330.9 L 973.9 328.1 L 973.5 324.8 Z",
      "position": {
        "x": 1009.2,
        "y": 315.8
      },
      "badgeAnchor": {
        "x": 1008.69,
        "y": 315.91
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "driftstone",
      "name": "Driftstone",
      "adjacencies": [
        "emberrock-gate",
        "emberrock-shoals",
        "greywatch-cliffs",
        "greywatch-gate"
      ],
      "borderDice": {
        "emberrock-gate": {
          "attack": 5
        },
        "emberrock-shoals": {
          "attack": 5
        },
        "greywatch-cliffs": {
          "attack": 5
        },
        "greywatch-gate": {
          "attack": 5
        }
      },
      "shape": "M 1034.3 631.5 L 1034.4 628.8 L 1035.7 626.4 L 1036.2 623.8 L 1036.5 621.2 L 1036.5 618 L 1036.1 614.8 L 1036.5 611.7 L 1037.4 608.6 L 1040.3 607.4 L 1043.2 606.2 L 1046.3 605.6 L 1049.4 605 L 1051.3 602.7 L 1053.8 601 L 1056.1 599 L 1058.7 597.5 L 1061.8 596.5 L 1065 596.6 L 1067.9 595.4 L 1071.1 595.1 L 1074.5 595.1 L 1077.5 596.6 L 1080.7 597.3 L 1083.7 598.7 L 1086.6 600.3 L 1089.5 602 L 1091.9 604.4 L 1094.3 606.7 L 1093.7 610.2 L 1092.9 613.7 L 1092.7 617.4 L 1094.1 620.8 L 1095 623.7 L 1096.8 626.1 L 1098.3 628.7 L 1099.4 631.5 L 1099.5 634.5 L 1098.3 637.4 L 1097.4 640.2 L 1096.3 643 L 1095.7 646.3 L 1095.4 649.6 L 1094.8 652.9 L 1094.1 656.2 L 1090.4 656.4 L 1086.7 656 L 1083.1 657.1 L 1079.3 656.8 L 1077 658.1 L 1074.7 659.6 L 1072.4 661.1 L 1070.2 662.6 L 1067.1 664.2 L 1063.6 664.6 L 1060.9 666.9 L 1058.1 668.9 L 1056.2 665.9 L 1054.4 662.8 L 1052.2 659.9 L 1049.8 657.3 L 1046.5 656.7 L 1043.3 655.5 L 1040 654.5 L 1036.6 655.1 L 1035.9 651.9 L 1036 648.7 L 1035.9 645.4 L 1035.4 642.2 L 1035.2 639.5 L 1035 636.8 L 1034.6 634.2 Z",
      "position": {
        "x": 1066.2,
        "y": 630.2
      },
      "badgeAnchor": {
        "x": 1065.88,
        "y": 630.85
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "wreckers-reef",
      "name": "Wreckers Reef",
      "adjacencies": [
        "emberrock-cliffs",
        "emberrock-gate",
        "thornvale-gate",
        "thornvale-shoals"
      ],
      "borderDice": {
        "emberrock-cliffs": {
          "attack": 5
        },
        "emberrock-gate": {
          "attack": 5
        },
        "thornvale-gate": {
          "attack": 5
        },
        "thornvale-shoals": {
          "attack": 5
        }
      },
      "shape": "M 873.4 891 L 875.3 888.4 L 877.5 886.1 L 880.7 885.3 L 883.1 883 L 884.3 880 L 886.4 877.7 L 888.3 875.2 L 889.6 872.3 L 892.5 870.9 L 895.5 870.2 L 898.7 870.5 L 901.8 871 L 904.6 870.9 L 907.5 871.1 L 910.3 871.1 L 913.1 871.5 L 915.4 873.2 L 917.2 875.5 L 919.8 876.9 L 922.7 877.1 L 926.2 877 L 929.4 878.3 L 932.7 879.2 L 936.1 879.4 L 938.2 881.9 L 939.4 885 L 939.8 888.2 L 940.8 891.3 L 941.6 894.4 L 942.8 897.4 L 943.4 900.6 L 945.1 903.4 L 943.8 906.5 L 943.7 909.8 L 943.9 913.1 L 942.9 916.3 L 940.3 918.3 L 938.6 921.1 L 936.5 923.6 L 935.2 926.6 L 932.1 927.5 L 929 928.6 L 925.8 929.2 L 922.6 929.6 L 919.7 930.6 L 917.5 932.8 L 914.9 934.4 L 913.4 937.1 L 910.3 937.1 L 907.2 936.9 L 904.5 935.2 L 902.3 933 L 899.6 932.2 L 896.8 931.6 L 894 932 L 891.2 931.6 L 888 930.8 L 884.7 930.3 L 881.2 930.1 L 878.7 927.5 L 879.7 924.2 L 878.9 920.8 L 878.7 917.4 L 877.8 914.2 L 877.9 911.5 L 878.2 908.8 L 878 906.1 L 877.8 903.4 L 877.2 900.1 L 876.2 897 L 874.3 894.2 Z",
      "position": {
        "x": 908.9,
        "y": 903.1
      },
      "badgeAnchor": {
        "x": 908.13,
        "y": 904.7
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "kelp-holm",
      "name": "Kelp Holm",
      "adjacencies": [
        "mistfell-gate",
        "mistfell-shoals",
        "thornvale-cliffs",
        "thornvale-gate"
      ],
      "borderDice": {
        "mistfell-gate": {
          "attack": 5
        },
        "mistfell-shoals": {
          "attack": 5
        },
        "thornvale-cliffs": {
          "attack": 5
        },
        "thornvale-gate": {
          "attack": 5
        }
      },
      "shape": "M 570.4 979 L 571.7 976.2 L 572.2 973.1 L 572.5 969.8 L 574.7 967.4 L 576.9 965.2 L 579.4 963.3 L 581.6 961.3 L 583.6 959.1 L 586.3 957.9 L 588.5 955.8 L 591.8 954.5 L 594.8 952.5 L 596.8 949.6 L 598.7 946.6 L 601.6 949 L 604.6 951.2 L 607.8 953.2 L 610.7 955.6 L 613.4 955.7 L 616.1 956.5 L 618.7 957.1 L 621.4 957.6 L 624.3 958.5 L 627.3 959.3 L 630.1 960.6 L 632.7 962.3 L 632.6 965.6 L 631.5 968.8 L 632.4 971.9 L 633.9 974.9 L 636.1 977.2 L 638 979.7 L 639.8 982.4 L 641.3 985.2 L 639.9 988.1 L 637.9 990.7 L 636.1 993.5 L 633.5 995.4 L 632.1 997.7 L 631.4 1000.3 L 630.7 1002.9 L 629.6 1005.4 L 627.9 1008.1 L 625.7 1010.4 L 624.1 1013.2 L 623.5 1016.3 L 620.4 1016.6 L 617.3 1016.1 L 614.1 1015.9 L 611 1016.2 L 608.2 1016.9 L 605.4 1017.5 L 602.6 1017.7 L 599.7 1017.9 L 596.2 1018.5 L 592.8 1019 L 589.3 1019 L 585.8 1019.3 L 584.7 1016 L 582.5 1013.3 L 581.2 1010.1 L 579.3 1007.2 L 579.1 1004.1 L 578.1 1001.1 L 575.6 999.2 L 573.6 996.8 L 572.4 994 L 571.4 991.2 L 571.7 988.1 L 570.8 985.2 L 570.8 982.1 Z",
      "position": {
        "x": 604,
        "y": 985.3
      },
      "badgeAnchor": {
        "x": 602.53,
        "y": 984.09
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "fog-isle",
      "name": "Fog Isle",
      "adjacencies": [
        "goldcrest-gate",
        "goldcrest-shoals",
        "mistfell-cliffs",
        "mistfell-gate"
      ],
      "borderDice": {
        "goldcrest-gate": {
          "attack": 5
        },
        "goldcrest-shoals": {
          "attack": 5
        },
        "mistfell-cliffs": {
          "attack": 5
        },
        "mistfell-gate": {
          "attack": 5
        }
      },
      "shape": "M 269.2 896.8 L 270.7 893.9 L 272 891 L 273.7 888.2 L 275.6 885.6 L 278.6 884.5 L 281.6 883.5 L 284.5 882 L 287.4 880.8 L 290.3 881 L 293 879.9 L 295.7 879.3 L 298.5 878.8 L 301.8 877.9 L 304.7 876.3 L 307.7 874.7 L 310.4 872.7 L 313.6 874 L 317.1 873.6 L 320.4 874.3 L 323.6 875.2 L 325.2 878.4 L 326.6 881.7 L 328.3 884.8 L 328.9 888.4 L 330.1 891 L 331.1 893.5 L 332.3 896.1 L 333.1 898.8 L 335.5 900.9 L 337.7 903.2 L 338.1 906.3 L 338.9 909.4 L 338.7 912.5 L 338.5 915.5 L 337.3 918.3 L 336.8 921.4 L 335.6 924.3 L 334.8 927.3 L 333.2 930 L 331.5 932.6 L 328.5 933.6 L 326.1 935.6 L 323.3 936.8 L 320.9 938.8 L 318 938.6 L 315 938.9 L 311.9 938.6 L 309.3 940.2 L 306.6 940 L 304.1 939.1 L 301.4 939.1 L 298.7 938.9 L 296 938.7 L 293.4 938.3 L 290.9 937.2 L 288.3 936.5 L 285.1 935.3 L 281.7 935.1 L 278.4 934.6 L 275.2 933.5 L 274.2 930.2 L 274 926.8 L 274.1 923.4 L 274.7 920 L 274.9 917.3 L 274.7 914.6 L 274.1 912 L 273.6 909.4 L 273 906.1 L 272.6 902.7 L 270.4 900 Z",
      "position": {
        "x": 304.5,
        "y": 908.1
      },
      "badgeAnchor": {
        "x": 305.14,
        "y": 909.61
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "gannet-rock",
      "name": "Gannet Rock",
      "adjacencies": [
        "goldcrest-cliffs",
        "goldcrest-gate",
        "stormreach-gate",
        "stormreach-shoals"
      ],
      "borderDice": {
        "goldcrest-cliffs": {
          "attack": 5
        },
        "goldcrest-gate": {
          "attack": 5
        },
        "stormreach-gate": {
          "attack": 5
        },
        "stormreach-shoals": {
          "attack": 5
        }
      },
      "shape": "M 155.9 627 L 159 625.6 L 161.3 623.1 L 163.5 620.5 L 166.8 619.5 L 168 616.4 L 169.4 613.3 L 170.7 610.2 L 172.3 607.2 L 175.3 605.9 L 178.5 605.2 L 181.5 603.6 L 184.7 602.9 L 187.7 604.6 L 190.5 606.6 L 193.8 607.8 L 196.4 610.2 L 199.6 610.7 L 202.8 610.7 L 206 610.2 L 209 609.2 L 210.6 611.8 L 212.6 614.1 L 215 616 L 217.1 618.2 L 219.1 620.6 L 221.2 622.9 L 223 625.5 L 225.5 627.4 L 225.8 630.6 L 227 633.6 L 227 636.8 L 226.2 639.9 L 225.4 642.8 L 223.6 645.3 L 223 648.3 L 221.7 651 L 220.1 653.3 L 218.9 655.9 L 217.5 658.3 L 216.3 660.9 L 213.9 662.4 L 211.3 663.7 L 209.1 665.5 L 207.1 667.5 L 205.1 669.7 L 202.6 671.4 L 199.8 672.3 L 197.1 673.6 L 194.1 673.8 L 191.1 673.3 L 188.3 672.3 L 185.7 670.9 L 182.7 671.1 L 179.6 671.1 L 176.6 670.8 L 173.6 670.5 L 172 667.8 L 170.5 665.1 L 168.8 662.5 L 167.8 659.5 L 165.3 657.9 L 162.9 656.1 L 160.9 653.9 L 159 651.6 L 159.9 648.7 L 159.4 645.7 L 159.3 642.8 L 158.9 639.9 L 157.8 636.7 L 156.6 633.6 L 156.4 630.3 Z",
      "position": {
        "x": 191.1,
        "y": 638.8
      },
      "badgeAnchor": {
        "x": 190.34,
        "y": 639.46
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "brine-skerry",
      "name": "Brine Skerry",
      "adjacencies": [
        "ashmoor-gate",
        "ashmoor-shoals",
        "stormreach-cliffs",
        "stormreach-gate"
      ],
      "borderDice": {
        "ashmoor-gate": {
          "attack": 5
        },
        "ashmoor-shoals": {
          "attack": 5
        },
        "stormreach-cliffs": {
          "attack": 5
        },
        "stormreach-gate": {
          "attack": 5
        }
      },
      "shape": "M 112.9 312.5 L 114.9 309.7 L 117.7 307.6 L 119.8 304.9 L 122.2 302.4 L 123.3 299.9 L 124 297.2 L 124.7 294.6 L 125.5 292 L 127 289.6 L 129.4 288.1 L 131.8 286.6 L 133.9 284.8 L 136.4 283.2 L 138.9 281.6 L 141.4 279.8 L 143.8 278.1 L 146.8 278.6 L 149.7 278.8 L 152.6 279.7 L 155.5 280.5 L 158.6 280.3 L 161.6 280.7 L 164.7 280.9 L 167.6 281.9 L 170.1 283.7 L 172.9 285.1 L 174.9 287.5 L 177.2 289.6 L 178 292.5 L 178.8 295.5 L 179.6 298.4 L 180.6 301.3 L 180.9 304.4 L 182.7 306.9 L 184.2 309.6 L 184.9 312.5 L 185.3 315.6 L 184.7 318.7 L 184.1 321.7 L 183.6 324.8 L 181.5 327.1 L 179 329 L 177 331.4 L 174.2 332.9 L 171.8 334.2 L 169.4 335.5 L 167.4 337.4 L 165.5 339.4 L 162.8 341.5 L 160.7 344.1 L 158.3 346.5 L 156.4 349.3 L 153.4 348 L 150.4 346.5 L 147.4 345.1 L 144.4 343.8 L 141.2 344.3 L 138 344.1 L 134.7 343.9 L 131.5 344.3 L 129.7 341.7 L 127.8 339.2 L 126.3 336.4 L 124.6 333.7 L 122.6 331.3 L 120.8 328.7 L 118.1 327 L 115.6 325 L 114.9 321.9 L 114 318.8 L 113.5 315.6 Z",
      "position": {
        "x": 150.1,
        "y": 312.7
      },
      "badgeAnchor": {
        "x": 150.23,
        "y": 312.59
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tern-islet",
      "name": "Tern Islet",
      "adjacencies": [
        "ashmoor-cliffs",
        "ashmoor-gate",
        "ironhold-gate",
        "ironhold-shoals"
      ],
      "borderDice": {
        "ashmoor-cliffs": {
          "attack": 5
        },
        "ashmoor-gate": {
          "attack": 5
        },
        "ironhold-gate": {
          "attack": 5
        },
        "ironhold-shoals": {
          "attack": 5
        }
      },
      "shape": "M 386.5 157 L 387.2 154.1 L 388.8 151.6 L 388.9 148.2 L 388.6 144.9 L 389.5 141.6 L 390.8 138.5 L 393.7 137 L 396 134.6 L 399.2 133.7 L 401.8 131.6 L 404.9 131.1 L 407.8 130.1 L 410.7 128.8 L 413.8 128.5 L 416.8 128.5 L 419.8 128.5 L 422.7 129.6 L 425.7 129.8 L 428.9 129.9 L 432.1 130.2 L 435.3 130.3 L 438.5 130.7 L 439.3 133.9 L 441.7 136.3 L 443.6 138.9 L 446.3 140.7 L 447.4 143.5 L 449.2 146 L 450.9 148.4 L 452.3 151.1 L 451.6 154.1 L 452.5 157.1 L 454 159.8 L 453.9 162.9 L 453.6 166 L 454.3 169.1 L 453.6 172.1 L 453.6 175.2 L 451.6 177.7 L 450.1 180.5 L 449.2 183.6 L 448.1 186.6 L 445.1 188 L 441.8 188.1 L 438.8 189.3 L 436 190.8 L 433.7 192.9 L 431.5 195.1 L 428.7 196.4 L 426.1 198.1 L 423.4 196.4 L 420.5 194.9 L 417.7 193.4 L 414.8 192 L 412 192.2 L 409.3 192 L 406.7 191 L 403.9 190.6 L 402.5 188.2 L 401.3 185.7 L 399.1 184 L 397.5 181.7 L 395.6 179.9 L 394.3 177.6 L 393.1 175.3 L 391.8 173.1 L 390.3 170.7 L 389.2 168.1 L 388.2 165.4 L 387 162.9 L 387.6 159.9 Z",
      "position": {
        "x": 420.9,
        "y": 161.2
      },
      "badgeAnchor": {
        "x": 421.46,
        "y": 162.21
      },
      "ownerId": "",
      "armies": 0
    }
  ],
  "ruleOverlay": {
    "sets": [
      {
        "id": "islands",
        "label": "Island",
        "glyph": "island",
        "color": "#e2a76f",
        "regions": {
          "ids": [
            "ironhold",
            "saltmarch",
            "greywatch",
            "emberrock",
            "thornvale",
            "mistfell",
            "goldcrest",
            "stormreach",
            "ashmoor"
          ]
        }
      },
      {
        "id": "landings",
        "label": "Landing",
        "glyph": "landing",
        "color": "#38bdf8",
        "territories": {
          "idSuffix": "-landing"
        }
      },
      {
        "id": "gates",
        "label": "Gate",
        "glyph": "gate",
        "color": "#a3e635",
        "territories": {
          "idSuffix": "-gate"
        }
      },
      {
        "id": "islets",
        "label": "Islet",
        "glyph": "islet",
        "color": "#f97316",
        "territories": {
          "ids": [
            "gull-rock",
            "seal-skerry",
            "driftstone",
            "wreckers-reef",
            "kelp-holm",
            "fog-isle",
            "gannet-rock",
            "brine-skerry",
            "tern-islet"
          ]
        }
      },
      {
        "id": "runs",
        "label": "Run",
        "glyph": "swatch",
        "color": "#a3e635",
        "regions": {
          "idPrefix": "run-"
        }
      },
      {
        "id": "pits",
        "label": "Pit",
        "glyph": "ring",
        "color": "#ef4444",
        "territories": {
          "idSuffix": "-pit"
        }
      },
      {
        "id": "sand",
        "label": "The Sand",
        "glyph": "sand",
        "color": "#facc15",
        "territories": {
          "ids": [
            "throne-sand"
          ]
        }
      }
    ],
    "rules": [
      {
        "id": "island",
        "set": "islands",
        "facts": [
          {
            "kind": "bonus",
            "value": 3,
            "label": "island"
          }
        ]
      },
      {
        "id": "landing",
        "set": "landings",
        "facts": [
          {
            "kind": "link",
            "from": "landings",
            "to": "gates",
            "pairs": "oneWay",
            "style": "oneway",
            "label": "only way in"
          }
        ]
      },
      {
        "id": "islet",
        "set": "islets",
        "facts": [
          {
            "kind": "link",
            "from": "islets",
            "pairs": "adjacent",
            "style": "sea",
            "dice": {
              "attack": 5,
              "defend": 6
            },
            "label": "either way"
          },
          {
            "kind": "noBonus"
          }
        ]
      },
      {
        "id": "lane",
        "label": "Arena lane",
        "set": "gates",
        "also": [
          "runs"
        ],
        "facts": [
          {
            "kind": "bonus",
            "value": 1,
            "label": "gate"
          },
          {
            "kind": "bonus",
            "value": 3,
            "label": "run",
            "set": "runs"
          }
        ]
      },
      {
        "id": "sand",
        "set": "sand",
        "facts": [
          {
            "kind": "bonus",
            "value": 9
          },
          {
            "kind": "matchup",
            "from": "pits",
            "to": "sand",
            "attack": 8,
            "defend": 6,
            "drawAll": true
          }
        ]
      }
    ],
    "chips": []
  },
  "geometryVersion": "v1-88284d8c-54948d0a",
  "seaRoutes": [
    {
      "aId": "ironhold-gate",
      "bId": "gull-rock",
      "from": {
        "x": 629.3473099322492,
        "y": 288.4542390886746
      },
      "to": {
        "x": 730.5411713571119,
        "y": 168.14364144929777
      }
    },
    {
      "aId": "ironhold-gate",
      "bId": "tern-islet",
      "from": {
        "x": 551.3739388346403,
        "y": 290.2063406275014
      },
      "to": {
        "x": 447.03956280273997,
        "y": 187.09487069205468
      }
    },
    {
      "aId": "saltmarch-gate",
      "bId": "gull-rock",
      "from": {
        "x": 753.8015641151017,
        "y": 315.31964347241967
      },
      "to": {
        "x": 752.8074672951923,
        "y": 175.2016861634305
      }
    },
    {
      "aId": "saltmarch-gate",
      "bId": "seal-skerry",
      "from": {
        "x": 812.2884996890234,
        "y": 368.1597489115818
      },
      "to": {
        "x": 973.5548379589635,
        "y": 325.2524131614493
      }
    },
    {
      "aId": "greywatch-gate",
      "bId": "driftstone",
      "from": {
        "x": 883.4756380036831,
        "y": 551.5340047142544
      },
      "to": {
        "x": 1036.4209472190246,
        "y": 617.3675777521962
      }
    },
    {
      "aId": "greywatch-gate",
      "bId": "seal-skerry",
      "from": {
        "x": 870.3918776307568,
        "y": 490.1809598614329
      },
      "to": {
        "x": 988.5778073443769,
        "y": 341.6644784460334
      }
    },
    {
      "aId": "emberrock-gate",
      "bId": "driftstone",
      "from": {
        "x": 878.5746679295493,
        "y": 675.2093926888159
      },
      "to": {
        "x": 1035.0649062286423,
        "y": 637.67623408667
      }
    },
    {
      "aId": "emberrock-gate",
      "bId": "wreckers-reef",
      "from": {
        "x": 835.7212228654772,
        "y": 740.7854062434222
      },
      "to": {
        "x": 894.1591746149986,
        "y": 870.5128592565004
      }
    },
    {
      "aId": "thornvale-gate",
      "bId": "kelp-holm",
      "from": {
        "x": 662.3283595884525,
        "y": 855.0974540692298
      },
      "to": {
        "x": 616.8102987821094,
        "y": 956.6639151035637
      }
    },
    {
      "aId": "thornvale-gate",
      "bId": "wreckers-reef",
      "from": {
        "x": 733.5069785540226,
        "y": 823.8583765710586
      },
      "to": {
        "x": 875.5880634169126,
        "y": 888.0988427914095
      }
    },
    {
      "aId": "mistfell-gate",
      "bId": "fog-isle",
      "from": {
        "x": 466.30316712178904,
        "y": 832.4246855391692
      },
      "to": {
        "x": 331.9405628762478,
        "y": 895.3212195652034
      }
    },
    {
      "aId": "mistfell-gate",
      "bId": "kelp-holm",
      "from": {
        "x": 546.531161306708,
        "y": 862.7407334568682
      },
      "to": {
        "x": 589.9129817218844,
        "y": 955.2433708368334
      }
    },
    {
      "aId": "goldcrest-gate",
      "bId": "fog-isle",
      "from": {
        "x": 368.6019763890061,
        "y": 745.8502216751872
      },
      "to": {
        "x": 318.08977417426854,
        "y": 873.8099520975721
      }
    },
    {
      "aId": "goldcrest-gate",
      "bId": "gannet-rock",
      "from": {
        "x": 328.21949014419994,
        "y": 678.926500661451
      },
      "to": {
        "x": 223.0244800861445,
        "y": 648.1775995692774
      }
    },
    {
      "aId": "stormreach-gate",
      "bId": "brine-skerry",
      "from": {
        "x": 315.1,
        "y": 488.7975301545636
      },
      "to": {
        "x": 170.754207574092,
        "y": 334.76647089736684
      }
    },
    {
      "aId": "stormreach-gate",
      "bId": "gannet-rock",
      "from": {
        "x": 312.71722140707516,
        "y": 563.9398387079503
      },
      "to": {
        "x": 219.67095307672324,
        "y": 621.2253295602206
      }
    },
    {
      "aId": "ashmoor-gate",
      "bId": "brine-skerry",
      "from": {
        "x": 392.8103748386691,
        "y": 374.08955821353055
      },
      "to": {
        "x": 184.17037092370578,
        "y": 321.34814538147117
      }
    },
    {
      "aId": "ashmoor-gate",
      "bId": "tern-islet",
      "from": {
        "x": 437.1509258644987,
        "y": 322.8318121912505
      },
      "to": {
        "x": 424.4744560842606,
        "y": 197.07650938638633
      }
    },
    {
      "aId": "ironhold-cliffs",
      "bId": "gull-rock",
      "from": {
        "x": 654.1969345659257,
        "y": 124.46130868148546
      },
      "to": {
        "x": 720.8390321161434,
        "y": 136.30967883856638
      }
    },
    {
      "aId": "ironhold-shoals",
      "bId": "tern-islet",
      "from": {
        "x": 492.57017149408654,
        "y": 119.13668826937361
      },
      "to": {
        "x": 448.48643534207304,
        "y": 145.00893797510145
      }
    },
    {
      "aId": "saltmarch-cliffs",
      "bId": "seal-skerry",
      "from": {
        "x": 981.2312923549241,
        "y": 241.17778920479176
      },
      "to": {
        "x": 997.0244882129883,
        "y": 283.32824231571004
      }
    },
    {
      "aId": "saltmarch-shoals",
      "bId": "gull-rock",
      "from": {
        "x": 864.6082615423252,
        "y": 124.96695383069917
      },
      "to": {
        "x": 785.2499802481038,
        "y": 136.99747333494028
      }
    },
    {
      "aId": "greywatch-cliffs",
      "bId": "driftstone",
      "from": {
        "x": 1095.2437152669015,
        "y": 554.4636739366197
      },
      "to": {
        "x": 1078.980281373678,
        "y": 596.923811550492
      }
    },
    {
      "aId": "greywatch-shoals",
      "bId": "seal-skerry",
      "from": {
        "x": 1071.5543371948156,
        "y": 379.152741311665
      },
      "to": {
        "x": 1033.276893111601,
        "y": 340.25780305395426
      }
    },
    {
      "aId": "emberrock-cliffs",
      "bId": "wreckers-reef",
      "from": {
        "x": 994.1372319340869,
        "y": 862.5009258434566
      },
      "to": {
        "x": 939.8546037524761,
        "y": 888.3692716326763
      }
    },
    {
      "aId": "emberrock-shoals",
      "bId": "driftstone",
      "from": {
        "x": 1072.4452845961446,
        "y": 713.3032594353122
      },
      "to": {
        "x": 1068.713204702476,
        "y": 663.3673782180769
      }
    },
    {
      "aId": "thornvale-cliffs",
      "bId": "kelp-holm",
      "from": {
        "x": 660.6732652304639,
        "y": 1006.0821822491077
      },
      "to": {
        "x": 633.1506667064561,
        "y": 995.9739046965364
      }
    },
    {
      "aId": "thornvale-shoals",
      "bId": "wreckers-reef",
      "from": {
        "x": 845.1222355995548,
        "y": 973.7675388609562
      },
      "to": {
        "x": 884.3655652737403,
        "y": 930.2808894442137
      }
    },
    {
      "aId": "mistfell-cliffs",
      "bId": "fog-isle",
      "from": {
        "x": 371.41294968344044,
        "y": 953.9137798682536
      },
      "to": {
        "x": 334.1419326127244,
        "y": 928.4104887160275
      }
    },
    {
      "aId": "mistfell-shoals",
      "bId": "kelp-holm",
      "from": {
        "x": 523.8249274683976,
        "y": 1028.2152507108879
      },
      "to": {
        "x": 576.5850478908741,
        "y": 999.9486363970643
      }
    },
    {
      "aId": "goldcrest-cliffs",
      "bId": "gannet-rock",
      "from": {
        "x": 162.62306927404663,
        "y": 696.0834503470275
      },
      "to": {
        "x": 175.25215819613643,
        "y": 670.6652158196136
      }
    },
    {
      "aId": "goldcrest-shoals",
      "bId": "fog-isle",
      "from": {
        "x": 238.4727603941612,
        "y": 887.7704297043791
      },
      "to": {
        "x": 269.3908088946779,
        "y": 897.308823719141
      }
    },
    {
      "aId": "stormreach-cliffs",
      "bId": "brine-skerry",
      "from": {
        "x": 156.9728730407433,
        "y": 378.98517260972125
      },
      "to": {
        "x": 153.78063128561203,
        "y": 348.1649402237652
      }
    },
    {
      "aId": "stormreach-shoals",
      "bId": "gannet-rock",
      "from": {
        "x": 122.67139423721306,
        "y": 566.9025669612939
      },
      "to": {
        "x": 168.55838438496795,
        "y": 615.1635774332852
      }
    },
    {
      "aId": "ashmoor-cliffs",
      "bId": "tern-islet",
      "from": {
        "x": 349.0804701970254,
        "y": 166.96094039405082
      },
      "to": {
        "x": 387.47586158675085,
        "y": 163.89137830573088
      }
    },
    {
      "aId": "ashmoor-shoals",
      "bId": "brine-skerry",
      "from": {
        "x": 194.4430057467362,
        "y": 256.332063894179
      },
      "to": {
        "x": 172.1342272859664,
        "y": 284.71711364298324
      }
    },
    {
      "aId": "ironhold-landing",
      "bId": "ironhold-gate",
      "from": {
        "x": 572.9038891108023,
        "y": 227.40636012264795
      },
      "to": {
        "x": 582.7060943993899,
        "y": 277.80289483971023
      },
      "oneWay": true
    },
    {
      "aId": "saltmarch-landing",
      "bId": "saltmarch-gate",
      "from": {
        "x": 855.569365886425,
        "y": 265.1636861423565
      },
      "to": {
        "x": 791.4503216745105,
        "y": 340.1366950585866
      },
      "oneWay": true
    },
    {
      "aId": "greywatch-landing",
      "bId": "greywatch-gate",
      "from": {
        "x": 992.7929358000371,
        "y": 489.5858716000742
      },
      "to": {
        "x": 886.3446132172177,
        "y": 518.4185092212108
      },
      "oneWay": true
    },
    {
      "aId": "emberrock-landing",
      "bId": "emberrock-gate",
      "from": {
        "x": 940.9907735958789,
        "y": 755.290383251288
      },
      "to": {
        "x": 856.0178316425557,
        "y": 712.4476087337014
      },
      "oneWay": true
    },
    {
      "aId": "thornvale-landing",
      "bId": "thornvale-gate",
      "from": {
        "x": 742.7983854425275,
        "y": 923.3847749875869
      },
      "to": {
        "x": 710.4579006513326,
        "y": 854.5207997518734
      },
      "oneWay": true
    },
    {
      "aId": "mistfell-landing",
      "bId": "mistfell-gate",
      "from": {
        "x": 475.0840839993545,
        "y": 890.7630629995159
      },
      "to": {
        "x": 495.7926720625487,
        "y": 852.5504640288686
      },
      "oneWay": true
    },
    {
      "aId": "goldcrest-landing",
      "bId": "goldcrest-gate",
      "from": {
        "x": 237.32614666149627,
        "y": 782.2964218602554
      },
      "to": {
        "x": 338.2669430933607,
        "y": 724.8155759877113
      },
      "oneWay": true
    },
    {
      "aId": "stormreach-landing",
      "bId": "stormreach-gate",
      "from": {
        "x": 237.9225881706227,
        "y": 500.0719458257256
      },
      "to": {
        "x": 306.78833285905284,
        "y": 520.2521063115673
      },
      "oneWay": true
    },
    {
      "aId": "ashmoor-landing",
      "bId": "ashmoor-gate",
      "from": {
        "x": 340.1740343245478,
        "y": 285.0296367277593
      },
      "to": {
        "x": 407.7595264179801,
        "y": 351.61130235055475
      },
      "oneWay": true
    }
  ],
  "borderChevronMarks": [
    {
      "x": 552.15,
      "y": 554.7,
      "angle": 23.1
    },
    {
      "x": 576.4,
      "y": 528.65,
      "angle": 63
    },
    {
      "x": 611.7,
      "y": 524.35,
      "angle": 102.9
    },
    {
      "x": 641.55,
      "y": 543.7,
      "angle": 143.1
    },
    {
      "x": 651.95,
      "y": 577.7,
      "angle": -177.1
    },
    {
      "x": 638.1,
      "y": 610.45,
      "angle": -137
    },
    {
      "x": 606.4,
      "y": 626.6,
      "angle": -97
    },
    {
      "x": 571.7,
      "y": 618.6,
      "angle": -57.1
    },
    {
      "x": 550.25,
      "y": 590.25,
      "angle": -17.1
    }
  ]
}
